import React, { Component, useRef } from 'react';
import {
  View,
  Text,
  TouchableHighlight,
  Alert,
  Image,
  StatusBar,
  Dimensions,Picker,
  Animated,
  ScrollView, 
Platform,
Linking,
ActivityIndicator,Switch,Clipboard
 
} from 'react-native';
import Modal from './modal';
import {StyleContext,styleInfo} from '../styleC';
import Drawer from './drawer';
import DrawerContent from './drawerContent';
import MapView,{AnimatedRegion} from 'react-native-maps'

/*import MapView from './mapView';*/
import firebase from './firebase';
import { getAuth, signOut, onAuthStateChanged,EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue, startAt, endAt, query} from "firebase/database";
import strings from '../strings';
import info from '../info';
import MavButton from './mavButton'; 
import carSimulate from '../carSimulate';
import MavAlert from './mavAlert';
import MavNotation from './mavNotation';
import MavNavigationMinimize from './mavNavigationMinimize';
import Admin from './admin';
import Wait3DSecure from './wait3DSecure';
import MavTextInput from './mavTextInput';
import MavSelectDate from './mavSelectDate';
import moneyList from '../moneyList';
import countryList from '../countryList';
import CreateAccount from './createAccount';
import Trajet from './trajet';
import Book from './book';
import Chat from './chat';
import Qs from 'qs';
import NavigateView from './navigateView';
import AfterRacePay from './afterRacePay';
import CommonActions from "./CommonActions";
import Geolocation from './geolocalisation';
import DeviceInfo from './deviceInfo'
import BookingView from './bookingView';
import iconTrajet from '../iconTrajet';
import POIMapDetail from './POIMapDetail';
import ChoiceCar from './choiceCar';
import languageList from '../languageList';
var devInfo=DeviceInfo.getUniqueId();

import MavMiniButton from './mavMiniButton';
import SncfInfo from './sncfInfo';





const timer = require('react-native-timer');

const backgroundStyle=(info.bundleIdentifer=="BIPMOTO")?true:false;


const trancheKM=(info.bundleIdentifer=="BIPMOTO")?[{to:4,price:50},{to:8,price:55},{to:12,price:60},{to:16,price:65},{to:20,price:70}, ]:undefined

class HeaderRight extends Component {
render() {
    return (
      <StyleContext.Consumer>{style => 
        <View style={{marginRight:(this.props.enablePartner==true && this.props.goBackEnabled!=true)?20:0}}>

        {this.props.goBackEnabled==true && <TouchableHighlight style={{ marginRight:10}} underlayColor={"#FFFFFF00"} onPress={() => { this.props.hideMultiStop() }}>
          <View style={{width:70, height:30,backgroundColor:(style.headerBackgroundColor==style.color1)?style.headerColor:style.color1,borderRadius:20, alignItems:"center", justifyContent:"center"}}>
              <Text style={{fontSize: 14,color:(style.headerBackgroundColor==style.color1)?style.backgroundColor:style.headerBackgroundColor}}>{strings.validate}</Text>
           </View>
          </TouchableHighlight>}
          

        {(this.props.enablePartner==true && this.props.goBackEnabled!=true) && <Switch 
              ios_backgroundColor={style.backgroundColor}
                 onValueChange ={(value)=>{
                    const fireInfo={} 
                    fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/partnerOnline"]=!this.props.partnerOnline
                    update(ref(getDatabase(firebase)), fireInfo)
                }}
                 value = {this.props.partnerOnline}/>}
        </View>
        }</StyleContext.Consumer>
      )
  }
}

class HeaderLeft extends Component {
render() {
    return (
      <StyleContext.Consumer>{style => 

        

       <View>

       {this.props.goBackEnabled==true && <HeaderBackButton label={strings.return} tintColor={style.headerColor}  labelStyle={{color:style.headerColor }} onPress={() => this.props.hideMultiStop() } />}

        {this.props.goBackEnabled!=true && <TouchableHighlight style={{ marginRight:10}} underlayColor={"#FFFFFF00"} onPress={() => {
               if(this.props.enableDrawer==true) this.props.openDrawer();
               else this.props.createAccount();

              
            }}>
            <View>
              {(this.props.enableDrawer==true) && <Image source={(style.mode=="dark" || backgroundStyle===true)?require('../assets/more_dark.png'):require('../assets/more_light.png')} style={{marginLeft:  Dimensions.get('window').width * 0.05, width: 25, height: 25 }}/>}
              {(this.props.enableDrawer!=true) && <Image source={(style.mode=="dark" || backgroundStyle===true)?require('../assets/user_white.png'):require('../assets/user_black.png')} style={{marginLeft:  Dimensions.get('window').width * 0.05, width: 25, height: 25 }}/>}
            </View>
            </TouchableHighlight>}


        </View>
        }</StyleContext.Consumer>
      )
  }
}








export default class main extends Component {
  constructor(props) {
    super(props);
    var i;

    /*Chargement des voitures */
    
    var cS=carSimulate.carList;
    var animateCarsList=[]
    var markersCars=[];



    if(Platform.OS!="web"){
        for(i=0;i<carSimulate.numberMax;i++){


          markersCars[i]={coordinate: new MapView.AnimatedRegion({

            latitude: cS[i][0].latitude,
            longitude: cS[i][0].longitude,
            latitudeDelta: 0,
              longitudeDelta: 0,
          })}
          animateCarsList[i]={
            coordinate:cS[i],
            actual:-1,
          }
        }
      }



    var infoMoney=this.findMoney();

    var urlInfo={}
    if(Platform.OS==="web" && window.location.search!=undefined){
        urlInfo=this.getParamsFromUrl(window.location)
    }

    
  
    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 
    

    this.state = { 
      vaas:(params!=undefined && params.vaas==true)?true:false,
      waitingSettings:true,
      goToCreateAccount:(urlInfo.create=="ok")?true:false,
      linkDownloadApp:(urlInfo.dApp!=undefined)?("http://app.mon-appli-vtc.com?app="+urlInfo.dApp):undefined,
      waitingPersonnalInfo:true, 
      dispenser:{enabled:false, step:"Start"}, 
      trackingUUID:urlInfo.trackLink, 
      trackingInfo:"waiting", 
      viewCreateAccount:false, 
      forcePartner:(urlInfo.partnerID!=undefined)?urlInfo.partnerID:false,
      lockOtherPartner:(urlInfo.lockOtherPartner!=undefined && urlInfo.lockOtherPartner==="true")?true:false,
      viewBook:false,
      viewChat:false,  
      notificationViewChat:"",
      manager:false,
      managerInfo:{},
      money:infoMoney,
      viewSpecificPOI:false,
      disableAutomaticMapFrom:false,
      providerFixeCommission:false, 
      unavailableIfRace:false, 
      viewKarhooForDrivers:false, 
      viewPartnerForDrivers:false,
      defineColorForCustomer:false,
      hidePhoneApp:false,
      oldMyPositionValue:{},
      destinationID:"",
      immediate:false,
      seePOIMap:true,
      waiting3DSecure:false,
      waiting3DSecureStatus:"",
      multiStop:false,
      adsTimer:"",
      delayRaceMin:60,
      privilegeProvider:"basic",
      privilegeDriver:"basic",
      viewTrajetCustomerDriver:false,
      errorGeolocalisation:false,
      immediate:false,
      immediateModeOrder:false,
      extraEUMode:false,
      disabledPromoCode:false,
      adsFullScreen:undefined, 
      addClientBook:false,
      enableTimezone:false, 
      durationMin:0,
      adminNotRace:false,
      onlyOneRaceBySlots:false,
      kilometerMax:0,
      lock:false,
      vip:false,
      vipMode:false, 
      contactFavoriteDriver:false,
      adsMarginBottom:Platform.OS === 'ios' ? ((Dimensions.get('window').height === 812 || Dimensions.get('window').height === 896 || Dimensions.get('window').width === 896 || Dimensions.get('window').width === 812)?15:0) : 0,
      controlePanelOpen:false,
      mapRegion: info.initialRegion,
      markers: [],
      mapFrom: { description: '',userDescription:'' },
      mapTo: { description: '',userDescription:'' },
      mapIntermediate:[], 
      driverNavigateTo:"",
      coords: [],
      priceProvision:'',
      classic:[],
      classicTaxi:[],
      classicDriver:[],
      forfaitDriver:[],
      markerDriverDetail:"",
      forfait:[],
      forfaitTaxi:[],
      driver:false,
      partner:false,
      provider:false,
      customerPro:false, 
      date:"",
      integerDate:"",
      dateMin:"2000-01-01",
      favorite:{},
      messageBeforeBook:false,
      messageEstimation:false,
      realPosition:{ description: '',userDescription:'' },
      favoriteGlobal:{},
      optionalOrder:{}, 
      pricePlace: '',
      priceEstimation: '',
      priceEstimationTaxi:"",
      saveRemovedRace:false,
      bicycling:false,
      hideMAV:false, 
      estimatePriceGo:'',
      estimatePriceGoTaxi:"",
      kmEstimation: '',
      timeEstimation: '',
      timeEstimationValue:'',
      enableFlightTrainVerif:false,
      startTypeVerif:false,
      destinationTypeVerif:false,
      partnerPartialAccessPhoneBook:false,

      viewCalcPrice:false, 
      hideMajoration:false,
      hideParticularRqs:false,
      viewMajorationDynamicDriver:false,
      billWithoutDetail:false,
      startAddress:"",
      endAddress:"",
      mode:"trajet",
      viewAdminMode:false, 
      viewPhone:"never",
      provisionDuration:'',
      commission:0,
      viewTrajet:false, 
      ads:[],
      enterprise:"",
      adressBill:"",
      cityBill:"",
      picturesCar:{ carAvailable:{}, carUsed:{}   }, 
      adsSelected:0,
      animateCarsList:animateCarsList,
      markersCars: markersCars,
      markersCarsReal:[],
      markerGeo:{},
      majoration:{},
      globalMajorationReady:false,
      favoriteDriver:{id:-1},
      multipleCarProvision:false,
      noVAT:false,
      tvaNumber:"",
      blackList:[],
      co2onBill:false,
      co2onOrder:false,
      noZone:"",
      noZoneTaxi:"",
      raceWaiting:{},
      immediateMode:"", 
      sendMessageIfPaiementError:false,
      enableDriverNameInRace:false,
      basicDriverAddRace:false,
      autoriseDriverSeeRace:false,
      partnerOnline:true,
      billMode:"",
      takingTraffic:false,
      disableCancelButton:false,
      activateGoogleMyBusiness:false, 
      googleMyBusinessText:{fr:""}, 
      disabledOldRace:false,
      customerMessageFreeCancel:false, 
      childSeats:false,
      animal:false,
      luggageOption:false,
      boosterSeats:false,
      hideHoursMajoration:false,
      hideOtherCarIfRaceInProgress:false,
      taxiMode:false,
      driverPricing:false, 
      previousSearch:{},
      previousSearchDisplay:{},
      removeRace5minutes:false,
      removeFavoriteDriver30:false,
      pricingPrecise:false,
      enableRealPosition:false,
      durationSelected:false,
      hidePriceRaceForDriver:false, 
      priceNetForDriver:false,
      addCommissionFixe:false,
      addCommissionFixeAmount:0,
      addCommissionVariable:false,
      mapZoom:0,
      wheelchair:false,
      viewRealDriver:false,
      viewRealDriverForDriver:false,
      viewAccurency:false, 
      viewAccurencyList:{},
      viewAccurencyRates:{},
      addCommissionVariableAmount:0,
      purposeReturn:false,
      debugRevenue:false,
      sendMailToAdmin:false,
      pickUpLocation:false,
      geolocDriverPrecise:false, 

      activateCustomerNotation:false, 
      activateDriverNotation:false,
      activateComment:false, 

      directionsLastUpdate:0,
      saveBook:{name:"",lastName:"",phone:"",email:"",enterprise:"",adressBill:"",cityBill:"", description:"",passagerNumber:1},


      immediateInfo:{text:"",car:"",immatriculation:"",picture:""},
    };
    /*findDriver, driverNavigateToCustomer,driverArrivate,raceInProgress, raceReturnInProgress*/

    

    timer.setInterval("positionDuringRace", () => { 
      if(this.state.geolocDriverPrecise==false) this.updatePositionDuringRaceAction() 
    }, 30000);

    timer.setInterval("position", () => {
      if(this.state.priceEstimation == '') this.updatePosition();

    }, info.updateLocationPosition);}

    getDriverPrice(){

      var requestDP=false;  
      if(this.state.forcePartner!=false) requestDP="/pricingDriver/"+this.state.forcePartner;
      else if(this.state.partner==true) requestDP="/pricingDriver/"+getAuth(firebase).currentUser.uid; 
      else if(this.state.favoriteDriver.id!="-1") requestDP="/pricingDriver/"+this.state.favoriteDriver.id; 

      if(requestDP!=false){
        onValue(ref(getDatabase(firebase), requestDP), (value) => {
          var val = value.val(); if(val!=null){  this.analysePrice(val,"driverPrice") } 
        })
      }
    }

    getCustomerPrice(){

      if(this.state.partner!=true && this.state.driver!=true) {
        var requestCP="/pricingCustomer/"+getAuth(firebase).currentUser.uid; 
        onValue(ref(getDatabase(firebase), requestCP), (value) => {
          var val = value.val(); if(val!=null){  this.analysePrice(val,"customerPrice")}
        })
      }
      else console.log("j'ai pas passé")
    }


  getParamsFromUrl(url) {
    url = decodeURI(url);
    if (typeof url === 'string') {
        let params = url.split('?');
        if(params.length==1) return {}
        else {
          let eachParamsArr = params[1].split('&');
          let obj = {};
          if (eachParamsArr && eachParamsArr.length) {
              eachParamsArr.map(param => {
                  let keyValuePair = param.split('=')
                  let key = keyValuePair[0];
                  let value = keyValuePair[1];
                  obj[key] = value;
              })
          }
          return obj;
        }
      }
        else return {}


    }




    analysePrice(val,type){

            var listForfait = new Array();
            var listClassic = new Array();
            var listForfaitRad = new Array();
            var listClassicRad = new Array();
            var i, j;
            var test;
            var tempList = Object.keys(val);

            for (i = 0; i < tempList.length; i++) {
              test = false;
              if (val[tempList[i]].radius != undefined) {
                for (j = 0; j < listClassicRad.length; j++) {
                  if (test == false && val[tempList[i]].radius < listClassicRad[j]) {
                    test = true;
                    listClassicRad.splice(j, 0, val[tempList[i]].radius);
                    listClassic.splice(j, 0, tempList[i]);
                  }
                }
                if (test == false) {listClassicRad.push(val[tempList[i]].radius);listClassic.push(tempList[i]);}
              } else {
                for (j = 0; j < listForfaitRad.length; j++) {
                  if (test == false && val[tempList[i]].startRadius < listForfaitRad[j]) {
                    test = true;
                    listForfaitRad.splice(j, 0, val[tempList[i]].startRadius);
                    listForfait.splice(j, 0, tempList[i]);
                  }
                }
                if (test == false) {listForfaitRad.push(val[tempList[i]].startRadius);listForfait.push(tempList[i]);}
              }
            }

            var listForfait2 = new Array();
            var listClassic2 = new Array();

            for (i = 0; i < listForfait.length; i++) {
              listForfait2[i] = val[listForfait[i]];
              listForfait2[i].i = i;
              listForfait2[i].id = listForfait[i];
            }
            for (i = 0; i < listClassic.length; i++) {
              listClassic2[i] = val[listClassic[i]];
              listClassic2[i].i = i;
              listClassic2[i].id = listClassic[i];
            }


            
            if(type=="customerPrice") {
              this.setState({classicCustomer: listClassic2, forfaitCustomer: listForfait2})
            }
            else if(type!="driverPrice"){ 
              if(type=="taxi") {this.setState({classicTaxi: listClassic2, forfaitTaxi: listForfait2})}
              else this.setState({classic: listClassic2, forfait: listForfait2})
            } 
            else this.setState({classicDriver: listClassic2, forfaitDriver: listForfait2})

      

    }


  removeOldPricing= () => {
    console.log("removeOldPricing")
    this.setState({classicCustomer:[],forfaitCustomer:[], classicDriver:[], forfaitDriver:[] })
    
  }


   getPrice(){

      onValue(ref(getDatabase(firebase), "/pricing"), (value) => {
        console.log("ON pricing "+JSON.stringify(value).length)


        var val=value.val();

        if(val!=null){
          var tempList = Object.keys(val);
          var vtc={}
          var taxi={};
          var i;
          for (i = 0; i < tempList.length; i++) {
              if(val[tempList[i]].taxiMode==true) taxi[tempList[i]]=val[tempList[i]];
              else vtc[tempList[i]]=val[tempList[i]];
          }

          if(Object.keys(vtc).length>0) this.analysePrice(vtc,"vtc");
          if(Object.keys(taxi).length>0 ) this.analysePrice(taxi,"taxi");
          }



      });

  }

  	testCoordinateInPolygon(point, vs) {
	    var x = point[0], y = point[1];

	    var inside = false;
	    for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
	        var xi = vs[i].latitude, yi = vs[i].longitude;
	        var xj = vs[j].latitude, yj = vs[j].longitude;
	        var intersect = ((yi > y) != (yj > y))
	            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
	        if (intersect) inside = !inside;
	    }

	    return inside;
	
	};



  findDriver(){
    	this.setState({immediateMode:"findDriver"})
  }


  getProvisionPrice(){
	    if(info.disableProvision!=true){
        onValue(ref(getDatabase(firebase), '/pricingProvision'), (value) => {
          console.log("ON pricing provision"+JSON.stringify(value).length)
	        var val = value.val(); 
 

	        if(val!=null) this.setState({priceProvision:val})}





	      )
	    }
  }

  calcDateMin(){

  	var CalcVarMin=new Date();
    CalcVarMin=Date.parse(CalcVarMin);
    CalcVarMin+=this.state.delayRaceMin*60000;
    CalcVarMin=new Date(CalcVarMin);
    var dMin=(this.state.driver==false && this.state.partner==false)?CalcVarMin:new Date('2010-01-01T00:00:00')
    
    this.setState({dateMin:dMin});
    return dMin



  }



getSettings(){
      onValue(ref(getDatabase(firebase), '/settings'), (value) => {
        console.log("ONCE settings "+JSON.stringify(value).length)
        var val=value.val();
        if(val!=null){

          var st={}
          st.waitingSettings=false; 

          
          if(val.stripeInfo!=undefined) st.stripeInfo=val.stripeInfo;
          if(val.bicycling!=undefined) st.bicycling=val.bicycling;
          if(val.disableCancelButton!=undefined) st.disableCancelButton=val.disableCancelButton;
          if(val.pickUpLocation!=undefined) st.pickUpLocation=val.pickUpLocation;
          if(val.unavailableIfRace!=undefined) st.unavailableIfRace=val.unavailableIfRace;
          if(val.co2onBill!=undefined) st.co2onBill=val.co2onBill;
          if(val.co2onOrder!=undefined) st.co2onOrder=val.co2onOrder;
          if(val.multiStop!=undefined) st.multiStop=val.multiStop;
          if(val.addClientBook!=undefined) st.addClientBook=val.addClientBook;
          if(val.purposeReturn!=undefined) st.purposeReturn=val.purposeReturn;
          if(val.viewWaitingPaymentRace!=undefined) st.viewWaitingPaymentRace=val.viewWaitingPaymentRace;
          if(val.seePOIMap!=undefined) st.seePOIMap=val.seePOIMap;
          if(val.viewKarhooForDrivers!=undefined) st.viewKarhooForDrivers=val.viewKarhooForDrivers;
          if(val.viewPartnerForDrivers!=undefined) st.viewPartnerForDrivers=val.viewPartnerForDrivers;
          
          if(val.hidePhoneApp!=undefined) st.hidePhoneApp=val.hidePhoneApp;

          if(val.geolocDriverPrecise!=undefined) st.geolocDriverPrecise=val.geolocDriverPrecise; 

          
          

          if(val.sendMessageIfPaiementError!=undefined) st.sendMessageIfPaiementError=val.sendMessageIfPaiementError; 
          if(val.enableFlightTrainVerif!=undefined) st.enableFlightTrainVerif=val.enableFlightTrainVerif;
          if(val.enableDriverNameInRace!=undefined) st.enableDriverNameInRace=val.enableDriverNameInRace;
          if(val.contactFavoriteDriver!=undefined) st.contactFavoriteDriver=val.contactFavoriteDriver;

          
          if(val.partnerPartialAccessPhoneBook!=undefined) st.partnerPartialAccessPhoneBook=val.partnerPartialAccessPhoneBook;
          if(val.autorizeChangeDriverFavoritePrice!=undefined) st.autorizeChangeDriverFavoritePrice=val.autorizeChangeDriverFavoritePrice;
          
          if(val.basicDriverAddRace!=undefined) st.basicDriverAddRace=val.basicDriverAddRace;
          if(val.autoriseDriverSeeRace!=undefined) st.autoriseDriverSeeRace=val.autoriseDriverSeeRace;
          if(val.messageBeforeBook!=undefined) st.messageBeforeBook=val.messageBeforeBook;
          if(val.messageEstimation!=undefined) st.messageEstimation=val.messageEstimation;
          
          
          if(val.saveRemovedRace!=undefined) st.saveRemovedRace=val.saveRemovedRace;
          if(val.delayRaceMin!=undefined) st.delayRaceMin=val.delayRaceMin;
          if(val.immediateMode!=undefined) st.immediateModeOrder=val.immediateMode;
          if(val.durationMin!=undefined) st.durationMin=val.durationMin;
          if(val.kilometerMax!=undefined) st.kilometerMax=val.kilometerMax;
          if(val.viewCalcPrice!=undefined) st.viewCalcPrice=val.viewCalcPrice;
          if(val.hideMajoration!=undefined) st.hideMajoration=val.hideMajoration;
          if(val.hideParticularRqs!=undefined) st.hideParticularRqs=val.hideParticularRqs;
          
          if(val.wheelchair!=undefined) st.wheelchair=val.wheelchair;
          if(val.extraEUMode!=undefined) st.extraEUMode=val.extraEUMode;
          if(val.disabledPromoCode!=undefined) st.disabledPromoCode=val.disabledPromoCode;
          if(val.debugRevenue!=undefined) st.debugRevenue=val.debugRevenue;
          if(val.activateCustomerNotation!=undefined) st.activateCustomerNotation=val.activateCustomerNotation;
          if(val.activateDriverNotation!=undefined) st.activateDriverNotation=val.activateDriverNotation;
          if(val.activateComment!=undefined) st.activateComment=val.activateComment;
          if(val.sendMailToAdmin!=undefined) st.sendMailToAdmin=val.sendMailToAdmin;
          if(val.enableTimezone!=undefined) st.enableTimezone=val.enableTimezone;
          if(val.customerMessageFreeCancel!=undefined) st.customerMessageFreeCancel=val.customerMessageFreeCancel;
          if(val.vipMode!=undefined) st.vipMode=val.vipMode;
          if(val.optionalOrder!=undefined) st.optionalOrder=val.optionalOrder;
          if(val.carDriverColor!=undefined) st.carDriverColor=val.carDriverColor;
          if(val.driverApproachingColor!=undefined) st.driverApproachingColor=val.driverApproachingColor;
          if(val.hideOtherCarIfRaceInProgress!=undefined) st.hideOtherCarIfRaceInProgress=val.hideOtherCarIfRaceInProgress;
          if(val.taxiMode!=undefined) st.taxiMode=val.taxiMode;
          if(val.forceManualDispatch!=undefined) st.forceManualDispatch=val.forceManualDispatch;
          if(val.takingTraffic!=undefined) st.takingTraffic=val.takingTraffic;
          if(val.onlyOneRaceBySlots!=undefined) st.onlyOneRaceBySlots=val.onlyOneRaceBySlots;
          if(val.viewTrajetCustomerDriver!=undefined) st.viewTrajetCustomerDriver=val.viewTrajetCustomerDriver;


          if(val.childSeats!=undefined) st.childSeats=val.childSeats;
          if(val.animal!=undefined) st.animal=val.animal;
          if(val.boosterSeats!=undefined) st.boosterSeats=val.boosterSeats;
          if(val.hideHoursMajoration!=undefined) st.hideHoursMajoration=val.hideHoursMajoration;
          if(val.luggageOption!=undefined) st.luggageOption=val.luggageOption;
          if(val.removeRace5minutes!=undefined) st.removeRace5minutes=val.removeRace5minutes;
          if(val.removeFavoriteDriver30!=undefined) st.removeFavoriteDriver30=val.removeFavoriteDriver30;
          if(val.pricingPrecise!=undefined) st.pricingPrecise=val.pricingPrecise;
          if(val.viewMajorationDynamicDriver!=undefined) st.viewMajorationDynamicDriver=val.viewMajorationDynamicDriver;
          if(val.enableRealPosition!=undefined) st.enableRealPosition=val.enableRealPosition;
          if(val.disabledOldRace!=undefined) st.disabledOldRace=val.disabledOldRace;
          if(val.providerFixeCommission!=undefined) st.providerFixeCommission=val.providerFixeCommission;
          if(val.multipleCarProvision!=undefined) st.multipleCarProvision=val.multipleCarProvision;
          

          if(val.activateGoogleMyBusiness!=undefined) st.activateGoogleMyBusiness=val.activateGoogleMyBusiness;
          if(val.googleMyBusinessText!=undefined) st.googleMyBusinessText=val.googleMyBusinessText;
          if(val.disableAutomaticMapFrom!=undefined) st.disableAutomaticMapFrom=val.disableAutomaticMapFrom; 
          
          if(val.picturesCar!=undefined && val.picturesCar.carAvailable!=undefined && val.picturesCar.carUsed!=undefined) st.picturesCar=val.picturesCar;

          if( (info.disableFavoriteDriverForCustomer==false || info.disableFavoriteDriverForAdmin==false) && val.driverPricing==true) st.driverPricing=true;
          else st.driverPricing=false;

          if(st.driverPricing===true){
             timer.setTimeout("driverPricing", () => {
               this.getDriverPrice();
            }, 5000);
          }

         
          

          if(val.priceNetForDriver!=undefined) st.priceNetForDriver=val.priceNetForDriver;
          if(val.addCommissionFixe!=undefined) st.addCommissionFixe=val.addCommissionFixe;
          if(val.addCommissionFixeAmount!=undefined) st.addCommissionFixeAmount=val.addCommissionFixeAmount;
          if(val.addCommissionVariable!=undefined) st.addCommissionVariable=val.addCommissionVariable;
          if(val.addCommissionVariableAmount!=undefined) st.addCommissionVariableAmount=val.addCommissionVariableAmount;

          if(val.hidePriceRaceForDriver!=undefined) st.hidePriceRaceForDriver=val.hidePriceRaceForDriver;
          if(val.defineColorForCustomer!=undefined) st.defineColorForCustomer=val.defineColorForCustomer; 
            


          
          
          if(val.viewRealDriver!=undefined) st.viewRealDriver=val.viewRealDriver;
          if(val.viewRealDriverForDriver!=undefined) st.viewRealDriverForDriver=val.viewRealDriverForDriver;

          if(val.hideMAV!=undefined) st.hideMAV=val.hideMAV; 
          
          if(val.viewAccurency!=undefined) st.viewAccurency=val.viewAccurency;
          if(val.viewAccurencyList!=undefined) st.viewAccurencyList=val.viewAccurencyList;
          if(val.billWithoutDetail!=undefined) st.billWithoutDetail=val.billWithoutDetail;



          

          if(val.adsFullScreen!=undefined && this.state.vaas!=true){

              timer.setTimeout("adsFullScreen", () => {
                  var list=Object.keys(val.adsFullScreen)
                  var adsFinal=undefined
                  for(i=0;i<list.length;i++){

                      if(adsFinal==undefined){
                          if(val.adsFullScreen[list[i]].target!=undefined){
                              if(!( (this.state.provider==true && val.adsFullScreen[list[i]].target[2]==false) || ( (this.state.partner==true || this.state.driver==true) && val.adsFullScreen[list[i]].target[1]==false) || (this.state.partner==false && this.state.driver==false && this.state.provider==false && val.adsFullScreen[list[i]].target[0]==false)  ) ) adsFinal=val.adsFullScreen[list[i]]
                          }
                          else adsFinal=val.adsFullScreen[list[i]]
                      }
                  }
                  if(adsFinal!=undefined) this.setState({adsFullScreen:adsFinal})

              }, 5000);
            
          }



          if(val.ads!=undefined && this.state.vaas!=true){

              timer.setTimeout("ads", () => {
                    var i;
                    var list=Object.keys(val.ads)
                    var adsFinal={}
                    var adsGood=true;

                    for(i=0;i<list.length;i++){
                          if(val.ads[list[i]].index==undefined) val.ads[list[i]].index=i;
                          val.ads[list[i]].duration=((val.ads[list[i]].duration==undefined)?5:parseInt(val.ads[list[i]].duration))*1000;
                          if(val.ads[list[i]].duration.toString()=="NaN") val.ads[list[i]].duration=5000;

                          if(val.ads[list[i]].target!=undefined){
                              if( (this.state.provider==true && val.ads[list[i]].target[2]==false) || ( (this.state.partner==true || this.state.driver==true) && val.ads[list[i]].target[1]==false) || (this.state.partner==false && this.state.driver==false && this.state.provider==false && val.ads[list[i]].target[0]==false)  ) adsGood=false
                          }

                        if(adsGood==true) adsFinal[list[i]]=val.ads[list[i]]
                    }
                    
                    Object.keys(adsFinal).sort(function(a, b){
                        if(adsFinal[a] < adsFinal[b]) return -1;
                        if(adsFinal[a] > adsFinal[b]) return 1;
                        return 0;
                    });

                    var val3=[]
                    var list=Object.keys(adsFinal).sort( function ( a, b ) { return adsFinal[a].index - adsFinal[b].index  } )

                    for(i=0;i<list.length;i++){
                      val3.push(adsFinal[list[i]]);
                    }

                    
                    this.setState({ads:val3},() =>{ if(this.state.ads.length>0) this.nextAds();  });
                     


              }, 3000);



          }


          this.setState(st,() =>{
              this.calcDateMin(); 
              
              timer.setTimeout("testHide", () => {


              
            
                  if(this.state.defineColorForCustomer==true && (this.state.partner==true || this.state.driver==true || this.state.manager==true)) {
                    get(child(ref(getDatabase(firebase)), '/usersColor')).then(value => {
                      var val=value.val(); 
                      if(val!=null){
                        val["karhooProvider"]={color:"#FE0082"};
                        console.log("usersColor")
                        console.log(val)
                      } this.setState({usersColor:val}); 
                    })
                  }


                 if(this.state.hidePriceRaceForDriver==true && (this.state.driver==true || (this.state.partner==true && this.state.privilegeDriver!="basic" && this.state.privilegeDriver!="standard"))) this.setState({hidePriceRaceForDriver:false});
  
                 if(this.state.driver==true && val.MAVincident=="paiement") this.alert.onAlert({title:"Incident de paiement", subTitle:"Votre paiement à Mon Appli VTC a echoué ou n'est pas actif. Merci de contacter Mon Appli VTC pour régler ce problème. (Seuls les administrateurs peuvent voir ce message)" });
                 else if(this.state.driver==true && val.MAVincident=="chauffeur") this.alert.onAlert({title:"Vous avez trop de chauffeur", subTitle:"Merci de contacter Mon Appli VTC afin de faire un point sur votre situation. (Seuls les administrateurs peuvent voir ce message)" });

              }, 2000);

               if(this.state.activateCustomerNotation==true || this.state.activateDriverNotation==true){
                timer.setTimeout("myNoteWait", () => {this.getMyNote();}, 3000);
              }

              

              


            })

         
        }
        
      })

  
  }

  nextAds(){

      console.log("nextads start")

	    timer.setTimeout("ads", () => {

        if(this.state.dispenser.enabled==true) this.setState({ads:[]})
	      else {
          var select=this.state.adsSelected+1;
	        if(select==this.state.ads.length) select=0;
	        this.setState({adsSelected:select},() =>{this.nextAds();})
        }

	      
	    }, this.state.ads[this.state.adsSelected].duration);

  }

  getFavoriteGlobal(){
    get(child(ref(getDatabase(firebase)), '/favorite')).then(value => {
        console.log("ONCE favorite globale "+JSON.stringify(value).length)
	      var val=value.val();
	      if(val!=null){

	        var val2 = value.val();

	        var i;
	        var list=Object.keys(val2)
	        for(i=0;i<list.length;i++){
	              if(val2[list[i]].index==undefined) val2[list[i]].index=i;
	        }
	         
	        var val3={}

	        Object.keys(val2).sort(function(a, b){

	            if(val2[a] < val2[b]) return -1;
	            if(val2[a] > val2[b]) return 1;
	            return 0;
	        });

	        var val3={}
	        var list=Object.keys(val2).sort( function ( a, b ) { return val2[a].index - val2[b].index  } )

	        for(i=0;i<list.length;i++){
	          val3[list[i]]=val2[list[i]];
	        }

	        if(val2!=null) this.setState({favoriteGlobal:val3})
	        
	      }
	    })
  }

  animateCars(num) {

	    var actu=this.state.animateCarsList[num].actual+1;
	    if(actu==this.state.animateCarsList[num].coordinate.length) actu=0;

	    var animateCarsList=this.state.animateCarsList;
	    animateCarsList[num].actual=actu;
	    this.setState({animateCarsList:animateCarsList})
	    
	    const { coordinate } = this.state.markersCars[num];
	    const newCoordinate=this.state.animateCarsList[num].coordinate[actu];

	    timer.setTimeout(generateUUID(), () => {this.animateCars(num)}, (newCoordinate!=undefined)?newCoordinate.duration:10000);

	    coordinate.timing(newCoordinate).start();
    
  }

 animateMyDriverCar(){


      if(this.state.immediateMode!="driverArrivate"){

      if(this.state.myDriver!=undefined && this.state.myDriver!=""){
        var actu=this.state.myDriverAnimate.actual+1;
        if(actu<0)actu=0;
        if(actu>(this.state.myDriverAnimate.coordinate.length-1)) actu=this.state.myDriverAnimate.coordinate.length-2;


        if(this.state.myDriverAnimate.coordinate.length>5){
            var myDriverAnimate=JSON.parse(JSON.stringify(this.state.myDriverAnimate))
            myDriverAnimate.actual=actu;

            this.setState({myDriverAnimate:myDriverAnimate,myDriverAnimateBefore:JSON.parse(JSON.stringify(this.state.myDriverAnimate.coordinate)).splice(0,actu) })
            const { coordinate } = this.state.myDriver;

            const newCoordinate=this.state.myDriverAnimate.coordinate[actu];
            timer.setTimeout(generateUUID(), () => {if(this.state.myDriverAnimate.actual==actu) this.animateMyDriverCar()}, (newCoordinate!=undefined)?newCoordinate.duration:10000);
            if(Platform.OS!="web") coordinate.timing(newCoordinate).start(); 
            
        } 
        
      }
  
    } else {
        if(this.state.myDriver!=undefined && this.state.myDriver!="" && this.state.myDriverAnimate!=undefined){
            var  actu=this.state.myDriverAnimate.coordinate.length-1; 
            const newCoordinate=this.state.myDriverAnimate.coordinate[actu];
            
            this.setState({myDriverAnimate:undefined, myDriver:{coordinate:{latitude:newCoordinate.latitude, longitude:newCoordinate.longitude, rotation:0}} }) 


        }
    }

  }



  getDriversPosition(){

      if(Platform.OS!="web"){
      /*Voir les vrais chauffeurs sur la carte
        Activez l'affichage des infos du chauffeur 
      */

      var infoGDP={
        uuid:(getAuth(firebase).currentUser!=null)?getAuth(firebase).currentUser.uid:""
      }
      if(this.state.driver==true && this.state.viewRealDriverForDriver==true ) {infoGDP.driver=true; infoGDP.infoPartner=true; infoGDP.viewOffline=true;}
      else if(this.state.manager==true && this.state.managerInfo.phonebook==true && this.state.viewRealDriverForDriver==true ) {infoGDP.manager=true; infoGDP.infoPartner=true; infoGDP.viewOffline=true;}
      else if(this.state.partner==true && this.state.privilegeDriver=="max" && this.state.viewRealDriverForDriver==true  ) {infoGDP.partner=true; infoGDP.infoPartner=true;}

      if(Object.keys(this.state.picturesCar.carAvailable).length>0) info.withCarModel=true; 
      
      console.log(infoGDP)
	    if((this.state.viewRealDriver==true || (this.state.driver==true && this.state.viewRealDriverForDriver==true ) || (this.state.manager==true && this.state.managerInfo.phonebook==true && this.state.viewRealDriverForDriver==true ) || (this.state.partner==true && this.state.privilegeDriver=="max" && this.state.viewRealDriverForDriver==true  ) )  && getAuth(firebase).currentUser!=null && !((this.state.driver==true || this.state.manager==true) && Platform.OS=="web") ) fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/getDriversPosition", {
	        body: JSON.stringify(infoGDP),
	        headers: {"Content-Type": "application/json"},method: "POST"}).then((response) => response.json())
	                  .then((responseJson) => { 
                      
          	          var res=responseJson;
                      console.log("getDriversPosition repond")
                      console.log(res)
                      var i;
                      for(i=0;i<res.length;i++){
                        if(res[i].positionDate!=undefined){
                          var da=new Date(res[i].positionDate);

                          var pd=((da.getDate()<10)?"0":"")+da.getDate()+"/"+(((da.getMonth()+1)<10)?"0":"")+(da.getMonth()+1)+"/"+da.getFullYear()+" - "+((da.getHours()<10)?"0":"")+da.getHours()+":"+((da.getMinutes()<10)?"0":"")+da.getMinutes();
                          res[i].date=pd;
                        }
                      }
          	          this.setState({markersCarsReal:res})
	        }).catch((err) => { console.log("error getDriversPosition"); console.log(err); timer.setTimeout("getDriversPosition", () => { this.getDriversPosition();  }, 2000);   })

                  }

  }

  getWaitingRace(testWaitingRace){
      
	    if( (this.state.driver==true || this.state.partner==true || (this.state.manager==true && this.state.managerInfo.dispatch==true )) && getAuth(firebase).currentUser != null && Platform.OS!="web" ){
	      
        


      onValue(query(ref(getDatabase(firebase), '/race'), orderByChild('status'), startAt("waiting"), endAt("waiting")), value => {


          console.log("ON getWaitingRace "+JSON.stringify(value).length)
	          var val=value.val();
	          var length=0;
	          var newObj={}
	          var immediateWaitingRace="";

	          var raceToValidate=0;

	          if(val!=null){

	            if(this.state.driver==true || this.state.manager==true) newObj=val
	            else if(this.state.partner==true){
	              console.log("je suis partenaire");

	              var li=Object.keys(val);
	              var i,j;
	              for(i=0;i<li.length;i++){

                    if(val[li[i]].desiredDriver==undefined || ( val[li[i]].desiredDriver.forceManualDispatch!=true && val[li[i]].desiredDriver.noPartner!=true && val[li[i]].desiredDriver.id==getAuth(firebase).currentUser.uid  )  ) {
                      newObj[li[i]]= val[li[i]]
                    }
                    else if (val[li[i]].desiredDriver!=undefined && val[li[i]].desiredDriver.forceManualDispatch!=true &&  val[li[i]].desiredDriver.other!=undefined && (val[li[i]].desiredDriver.id==undefined || val[li[i]].desiredDriver.noPartner==true) ){
                          for(j=0;j<val[li[i]].desiredDriver.other.length;j++){
                            if(val[li[i]].desiredDriver.other[j].id==getAuth(firebase).currentUser.uid && (val[li[i]].desiredDriverDecline==undefined || val[li[i]].desiredDriverDecline[getAuth(firebase).currentUser.uid]==undefined || val[li[i]].desiredDriverDecline[getAuth(firebase).currentUser.uid].decline!=true)){console.log("je suis dans la step 3"); newObj[li[i]]= val[li[i]]} 
                          }
                      }
	              }
	              


	            }
	            

	          }
	          

	          
	          if(Object.keys(newObj).length>0 && Object.keys(newObj).length>Object.keys(this.state.raceWaiting).length){
	            if(immediateWaitingRace!="" && this.state.immediateMode=="" && testWaitingRace==undefined) console.log("bon j'ai pas de course en cours et j'ai une course immediate, je peux la proposer")
	            else if(this!=undefined && this.alert!=undefined) {this.alert.onAlert({title:strings.raceInWaiting,buttons:[
	              {text: strings.viewRace,onPress: () => {
                  this.props.navigation.navigate('CalendarWait', {findRace: true, info:this.state })
	               }},
	              {text: strings.close, style:"cancel",onPress: () => {}}
	              ],});
	            }
	          } 

	          this.setState({raceWaiting:newObj, })
	          


	    })


	    }

  }

  copyToClipboard(code){
 	 	Clipboard.setString(code);
 	 }

   geolocalisationPrecise(){
    
    if(this.state.driver!=true && this.state.partner!=true && this.state.immediateInfo!=undefined && this.state.immediateInfo!="" && this.state.immediateInfo.uuid!=undefined) {
      this.getRaceInProgressStartPrecise(this.state.immediateInfo.uuid); 
      console.log("je lance getRaceInProgressStartPrecise Bis")
    }

    if(this.state.geolocalisationPreciseEnabled!=true){
      console.log("start pos pre")
        timer.setInterval("preciseCustomer", () => { 
            if(this.state.driver!=true && this.state.partner!=true && this.state.immediateMode!="raceInProgress") { 
               Geolocation.getCurrentPosition(position => { this.setState({markerGeo:{coordinates:{latitude: position.coords.latitude,longitude: position.coords.longitude,accuracy:position.coords.accuracy, } } }); },error => {console.log("error loc users") }, { enableHighAccuracy: true, maximumAge: 5000 } ); 

          }

        },this.state.geolocDriverPrecise.customer);


        timer.setInterval("positionDuringRace", () => { 
          if(this.state.driver==true || this.state.partner==true) this.updatePositionDuringRaceAction() 
        },this.state.geolocDriverPrecise.driver);

        this.setState({geolocalisationPreciseEnabled:true})
    }
    
   
   }

   
  getPersonnalInformations = (infoGetPerso) => { 
      
      this.setState({goToBook:(infoGetPerso!=undefined && infoGetPerso.goToBook==true)?true:false},() =>{

        if(getAuth(firebase).currentUser!=null){


            onValue(ref(getDatabase(firebase), '/users/'+getAuth(firebase).currentUser.uid), (value) => {
            console.log("ON get personnal info "+JSON.stringify(value).length)


            if(getAuth(firebase).currentUser!=null){
              var val=value.val();
              if(val!=null){

                var st={name:val.name,lastName:val.lastName,phone:val.phone,email:val.email,id:getAuth(firebase).currentUser.uid,vip:(val.vip==true)?true:false, driver:false,provider:false,customerPro:false,partner:false,enterprise:val.enterprise}
                st.waitingPersonnalInfo=false; 

                if(val.adressBill!=undefined) st.adressBill=val.adressBill;
                if(val.cityBill!=undefined) st.cityBill=val.cityBill;

                if(val.lastCopiedPrice!=undefined){
                  const date1 = Date.parse(new Date());
                  if((date1-val.lastCopiedPrice.date)>7200000){
                    timer.setTimeout(generateUUID(), () => {  
                      const fireInfo={} 
                      fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/lastCopiedPrice"]=null
                      update(ref(getDatabase(firebase)), fireInfo)

                    }, 10000);
                  }
                }
              


                if(val.driver==true) {st.driver=true;  st.adminNotRace=(val.adminNotRace==true)?true:false ; if(Platform.OS=="web") st.viewAdminMode=true }
                else if(val.manager==true){st.manager=true; st.managerInfo=(val.managerInfo!=undefined)?val.managerInfo:{}; if(Platform.OS=="web") st.viewAdminMode=true }
                else if(val.partner==true) {st.partner=true; if(val.billMode!=undefined) st.billMode=val.billMode }
                else if(val.provider==true) {
                  st.provider=true;
                  if(val.privilegeProvider!=undefined) st.privilegeProvider=val.privilegeProvider;
                
                }
                else if(val.customerPro==true) st.customerPro=true;
                if(val.commission!=undefined && val.commission>0) st.commission=val.commission;
                if(val.viewPhone!=undefined) st.viewPhone=val.viewPhone;


                if(val.noVAT==true) st.noVAT=true;
                if(val.tvaNumber!=undefined) st.tvaNumber=val.tvaNumber;
                
                



              

                if(val.dispenserMode!=undefined){



                  st.dispenser={enabled:(val.dispenserMode[devInfo]!=undefined && val.dispenserMode[devInfo].actif==true)?true:false, step:"Start", adress:val.dispenserMode.adress};
                 
                  if(val.dispenserMode[devInfo]!=undefined && val.dispenserMode[devInfo].actif==true){
                    
                    this.props.navigation.setOptions({headerShown:false }) 
                    st.kmEstimation=''; st.provisionDuration=''; st.priceEstimation=''; st.estimatePriceGo=''; st.estimatePriceGoTaxi=""; st.date=''; st.integerDate='';  st.endAddress=''; 
                  
                  }
                  if(val.dispenserMode.adress!=undefined) this.setState({mapFrom:val.dispenserMode.adress, providerAdress:val.dispenserMode.adress})


                    
                }
              
              



                if(val.privilegeDriver!=undefined) st.privilegeDriver=val.privilegeDriver;

                if(val.driver==true || (val.partner==true && val.privilegeDriver!=undefined && val.privilegeDriver!="basic" && val.privilegeDriver!="standard")) st.hidePriceRaceForDriver=false;
                if(val.favoriteDriver!=undefined) st.favoriteDriver=val.favoriteDriver;
                if(val.blackList!=undefined) st.blackList=val.blackList;
                if(val.carModel!=undefined) st.car=val.carModel
                else if(val.car!=undefined) st.car={0:val.car};

                if(val.chatMainProv!=undefined){
                    this.setState({chatMainProv:val.chatMainProv}); 
                    timer.setTimeout(generateUUID(), () => { 

                      const fireInfo={} 
                      fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/chatMainProv"]=null
                      update(ref(getDatabase(firebase)), fireInfo)
                   }, 7000);
                }

                if(val.chatInfoProv!=undefined && this.state.chatInfoProv==undefined){
                    this.setState({chatInfoProv:"no"})
                    
                    /*je récupère les infos de la course*/
                    get(child(ref(getDatabase(firebase)), "race/"+val.chatInfoProv.raceID)).then(valueRaceMessage => {
                        var valRaceMessage=valueRaceMessage.val();

                        if(valRaceMessage!=null){
                          var dateChatRace=new Date(valRaceMessage.raceDate); 
                          dateChatRace=((dateChatRace.getDate()<10)?"0":"")+dateChatRace.getDate()+"/"+((dateChatRace.getMonth()<9)?"0":"")+(dateChatRace.getMonth()+1)+" "+strings.at.toLowerCase()+" "+((dateChatRace.getHours()<10)?"0":"")+dateChatRace.getHours()+":"+((dateChatRace.getMinutes()<10)?"0":"")+dateChatRace.getMinutes();
                         
                          timer.setTimeout(generateUUID(), () => {  

                          this.alert.onAlert({
                              title:strings.newMessage,
                              subTitle:strings.newMessageForRace+" "+dateChatRace+' : "'+val.chatInfoProv.message+'"',
                              buttons:[{text: strings.seeChat,onPress: () => {  this.startChatClient({sender:(val.driver==true || val.partner==true)?(valRaceMessage.clientName+" "+valRaceMessage.clientLastName):valRaceMessage.attributedPartner.text,raceID:val.chatInfoProv.raceID ,senderID:(val.driver==true || val.partner==true)?valRaceMessage.clientID:valRaceMessage.attributedPartner.id})
                              }},{text: strings.close, style:"cancel", onPress: () => {}}]

                            });

                        }, 3000);

                        }
                    })
                    /*je supprime ça après*/
                    timer.setTimeout(generateUUID(), () => { 
                        const fireInfo={} 
                        fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/chatInfoProv"]=null
                        update(ref(getDatabase(firebase)), fireInfo) 
                        this.setState({chatInfoProv:undefined})
                    }, 6000);
                    

                }

                if(info.enableOnOffButton==true && val.partner==true){

                  if(val.partnerOnline!=undefined){
                    st.partnerOnline=val.partnerOnline
                  } else st.partnerOnline=true; 

                  if(Platform.OS!="web") {
                    this.props.navigation.setOptions({ title:(st.partnerOnline==true)?strings.online:strings.offline , headerRight: props => <HeaderRight enablePartner={true} partnerOnline={(st.partnerOnline==true)?true:false} {...props} /> })
                    if(this.state.controlePanelOpen==true)this.props.navigation.setOptions({headerShown:false});
 
                    
                   
                  }

              } else if(Platform.OS!="web") console.log("hide Switch")

              
                  
              if(val.waitNowPayment!=undefined){
                console.log("waitNowPayment existe !!!!!!!!! ")
                var driverID=Object.keys(val.waitNowPayment)[0];
                var infoWaitPay=val.waitNowPayment[driverID]; 
                if(infoWaitPay.removed==true && this.state.waitNowPaymentOpen==true && infoWaitPay.finish!=true){
                      this.setState({waitNowPaymentOpen:false});
                      if(this.afterRacePay!=undefined && this.afterRacePay.close!=undefined) this.afterRacePay.close()
                }

                if(Date.parse(new Date())>infoWaitPay.date || infoWaitPay.removed==true) {
                  this.setState({waitNowPaymentOpen:false});
                  timer.setTimeout(generateUUID(), () => {
                    const fireInfo={} 
                    fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/waitNowPayment"]=null
                    update(ref(getDatabase(firebase)), fireInfo)

                  }, 6000);
                }
                else {
                  /*display info*/
                 if(this.state.waitNowPaymentOpen!=true && infoWaitPay.removed!=true && val.waitingStripeValidation==undefined){
                      this.setState({waitNowPaymentOpen:true},() =>{
                        
                        var money=this.findMoney(infoWaitPay.currency); 
                        
                        timer.setTimeout(generateUUID(), () => {console.log("fin timeout"); console.log(typeof(this.afterRacePay.onInfo)); this.afterRacePay.onInfo({driver:false, driverID:driverID, raceID:infoWaitPay.raceID, amount:infoWaitPay.amount ,currency:money }); }, 1000);
                      })

                      
                      
                  }
                  

                }

              }
                

              
              if(val.reviewRaceID!=undefined && (this.state.reviewRaceID==undefined || this.state.reviewRaceID=="")){
                this.setState({reviewRaceID:val.reviewRaceID})
                /*je vais chercher l'info de la course*/

                console.log("reviewRaceID test")

                timer.setTimeout(generateUUID(), () => {  

                  if(this.notation!=null) {
                      var refe=(val.partner==true || val.driver==true)?"/race/":('/usersRace/'+getAuth(firebase).currentUser.uid+"/")

                      get(child(ref(getDatabase(firebase)), refe+val.reviewRaceID)).then(valueRRI => {
                        console.log("ONCE notation "+JSON.stringify(valueRRI).length)
                          var valRRI=valueRRI.val();

                          if(valRRI!=null){

                            var infoRace={ noteCustomer:((val.partner==true || val.driver==true)?true:false), activateComment:this.state.activateComment,raceDate:new Date(valRRI.raceDate),driverName:valRRI.attributedPartner.text,clientName:valRRI.clientName}
                            console.log("notat")
                            this.notation.onNotation(infoRace) 

                          } else {
                            this.setState({reviewRaceID:""},() =>{  
                              const fireInfo={} 
                              fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/reviewRaceID"]=null
                              update(ref(getDatabase(firebase)), fireInfo)

                            })
                          
                          }
                      })
                  }
                }, 5000);

              }



              if(val.waitingStripeValidation!=undefined){
                console.log("ah on a un waiting invoice ! ");
                var wsvlist=Object.keys(val.waitingStripeValidation)
                var waitValid=val.waitingStripeValidation[wsvlist[0]];
                if(waitValid.status=="waiting" && waitValid.date!=undefined && (Date.parse(new Date()) - waitValid.date)>10800000 ) {
                  const fireInfo={} 
                  fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/waitingStripeValidation/"+wsvlist[0]]=null
                  update(ref(getDatabase(firebase)), fireInfo)

                }
                
                else if(waitValid.status=="waiting" && waitValid.type=="afterRaceApp" && val.waitNowPayment==undefined){
                  this.setState({waiting3DSecure:true,waiting3DSecureStatus:"fail", waiting3DSecureUrlRedirect:undefined})
                  timer.setTimeout(generateUUID(), () => {
                      const fireInfo={} 
                      fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/waitingStripeValidation/"+wsvlist[0]]=null
                      update(ref(getDatabase(firebase)), fireInfo)
                  }, 2500);
                }
                else if(waitValid.status=="waiting") this.setState({waiting3DSecure:true,waiting3DSecureStatus:"waiting", waiting3DSecureUrlRedirect:(waitValid.urlRedirect!=undefined)?waitValid.urlRedirect:undefined})
                else if((waitValid.status=="validate" || waitValid.status=="fail") && waitValid.waitingValidation!=true) {
                  const fireInfo={} 
                  fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/waitingStripeValidation/"+wsvlist[0]]=null
                  update(ref(getDatabase(firebase)), fireInfo)
                }
                
                else if(waitValid.status=="validate" || waitValid.status=="fail"){
                    this.setState({waiting3DSecure:true,waiting3DSecureStatus:waitValid.status, waiting3DSecureUrlRedirect:undefined})
                    console.log("3 secondes après, j'efface, ce qui déclenra l'arret de la notif")

                    timer.setTimeout(generateUUID(), () => {  
                        if(waitValid.status=="validate" && waitValid.type=="recharge"){
                          console.log("ok la recharge est : "+wsvlist[0])
                          const fireInfo={} 
                          fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/waitingStripeValidation/"+wsvlist[0]]=null
                          update(ref(getDatabase(firebase)), fireInfo)

                           this.alert.onAlert({
                              title:strings.yourRechargeCode,
                              subTitle:strings.rechargeNowOrGive,
                              code:wsvlist[0],
                              buttons:[{text: strings.copy,onPress: () => {this.copyToClipboard(wsvlist[0])}},{text: strings.close, onPress: () => {}}]

                            });
                        }
                        else if(waitValid.status=="fail" && waitValid.type=="recharge"){ 
                          const fireInfo={} 
                          fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/waitingStripeValidation/"+wsvlist[0]]=null
                          update(ref(getDatabase(firebase)), fireInfo)
                        }
                        else if(waitValid.status=="validate" && (waitValid.type=="afterRace" || waitValid.type=="afterRaceApp")){
                            const fireInfo={} 
                            fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/waitingStripeValidation/"+wsvlist[0]]=null
                            update(ref(getDatabase(firebase)), fireInfo)
                            

                        }

                        else if(waitValid.status=="validate" && waitValid.type=="race"){
                            if(this.alert!=null && this.alert!=undefined && this.alert.onAlert!=null && this.alert.onAlert!=undefined) this.alert.onAlert({title:strings.thanksWeWillReceiveAnConfirmationEmail,buttons:[{text:strings.ok,onPress: () => {}}],});
                            const fireInfo={} 
                            fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/waitingStripeValidation/"+wsvlist[0]]=null
                            update(ref(getDatabase(firebase)), fireInfo)

                        }
                        else if(waitValid.status=="fail" && waitValid.type=="race"){ 
                              if(this.alert!=null && this.alert!=undefined && this.alert.onAlert!=null && this.alert.onAlert!=undefined)  this.alert.onAlert({title:strings.errorCard,subTitle:strings.errorCardNoRace,buttons:[{text:strings.ok,onPress: () => {}}],});
                              const fireInfo={} 
                              fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/waitingStripeValidation/"+wsvlist[0]]=null
                              update(ref(getDatabase(firebase)), fireInfo)

                        } 
                        


                    }, 2500);

                    

                }



              } else this.setState({waiting3DSecure:false,waiting3DSecureStatus:""})


              if(val.favorite!=undefined) {
                  var i;
                  var list=Object.keys(val.favorite)
                  for(i=0;i<list.length;i++){
                        if(val.favorite[list[i]].index==undefined) val.favorite[list[i]].index=i;
                  }
                  Object.keys(val.favorite).sort(function(a, b){
                      if(val.favorite[a] < val.favorite[b]) return -1;
                      if(val.favorite[a] > val.favorite[b]) return 1;
                      return 0;
                  });

                  var val3={}
                  var list=Object.keys(val.favorite).sort( function ( a, b ) { return val.favorite[a].index - val.favorite[b].index  } )

                  for(i=0;i<list.length;i++){
                    val3[list[i]]=val.favorite[list[i]];
                    val3[list[i]].icon="customerFavorite";
                  }
                  st.favorite=val3;

              }

              if(val.previousSearch!=undefined && (val.dispenserMode==undefined || val.dispenserMode[devInfo]==undefined || (val.dispenserMode!=undefined && val.dispenserMode[devInfo].actif!=true) )){
                st.previousSearch=val.previousSearch;

                var newPS={};
                var arrayPS=Object.keys(val.previousSearch).reverse().forEach(function(key) { 
                  newPS[key]=val.previousSearch[key]
                  if(newPS[key].icon==undefined) newPS[key].icon="previous";
                  newPS[key].previous=true;
                });

                st.previousSearchDisplay=newPS;
                

              } else st.previousSearchDisplay={}; 


              var oldDriver=this.state.driver;
              var oldPartner=this.state.partner;
              var oldManager=this.state.manager;
               

              this.setState(st,() =>{
                if(this.state.geolocDriverPrecise!=false){
                  this.geolocalisationPrecise()
                }

                if(Platform.OS!="web"){
                    if(this.state.adsNotificationOld==undefined || this.state.adsNotificationOld!=this.state.adsNotification)this.gestionTopic();
                    this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true,headerLeft: props => <HeaderLeft goBackEnabled={(this.state.viewMultiStop==true)?true:false} enableDrawer={true} openDrawer={this._openDrawer} hideMultiStop={this.hideMultiStop} createAccount={this._createAccount} {...props} />, headerRight: props => <HeaderRight hideMultiStop={this.hideMultiStop} enablePartner={(info.enableOnOffButton==true && val.partner==true)?true:false} partnerOnline={(st.partnerOnline==true)?true:false} goBackEnabled={ (this.state.viewMultiStop==true)?true:false}  {...props} /> })
                    if(this.state.controlePanelOpen==true)this.props.navigation.setOptions({headerShown:false});
                } 

                if((this.state.partner==true && oldPartner!=true) || (this.state.driver==true && oldDriver!=true) || (this.state.manager==true && this.state.managerInfo.dispatch==true && oldManager!=true)  ) this.getWaitingRace(val.raceInProgress)
                else if(this.state.goToBook==true){
                  console.log("je suis en goToBook")
                  this.setState({goToBook:false})
                  const style=styleInfo();
                  if(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax ){
                      this.setState({viewBook:true, controlePanelOpen:true});
                      if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false }) 
                  }
                  else {
                    this.props.navigation.navigate('Book', {navigate:(value,params) => { this.props.navigation.navigate(value,params); }, popToTop:() => {this.setState({viewBook:false,controlePanelOpen:false});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true })  }, goBack:() => {this.setState({viewBook:false,controlePanelOpen:false});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true }) ;}, purposeReturn:this.purposeReturn, data: this.state,start3DSecure:this.start3DSecure,saveBook:this.saveBook,updateAfterBook:this.updateAfterBook }); 
                  }


                }
              })





              if(val.accountClientDisabled!=undefined && val.accountClientDisabled==true) {this.alert.onAlert({title:strings.errorAccountDisabled}); signOut(getAuth(firebase))}
              else if((val.driver!=true && val.partner==true) && Platform.OS=="web")  {this.alert.onAlert({title:"Cette interface est réservé aux clients"}); signOut(getAuth(firebase));}

              if(val.raceInProgress!=undefined && this.state.immediateMode=="" ) {
                this.getRaceInProgress(val.raceInProgress);
              }

            }

        }

        })

      }
    })
  }

  getMajoration(){

      get(child(ref(getDatabase(firebase)), '/majoration')).then(valueMajo => {
        console.log("ONCE majoration "+JSON.stringify(valueMajo).length)
	        var valMajo = valueMajo.val();
	        if(valMajo!=null)this.setState({majoration:valMajo, globalMajorationReady:true})
	       	else this.setState({globalMajorationReady:true})
	    })
  }


gestionTopic= () => { 

      console.log("je lance la gestion des topics")
      /*on se désincrit des topics*/

      var i; 
      for(i=0; i<languageList.length;i++){
        messaging()
        
        messaging().unsubscribeFromTopic("ads"+languageList[i].id);
        messaging().unsubscribeFromTopic("adsPro"+languageList[i].id);
        messaging().unsubscribeFromTopic("adsProvider"+languageList[i].id);
        messaging().unsubscribeFromTopic("adsDriver"+languageList[i].id);
        
      }

      /*puis on s'inscrit uniquement au bon*/
      
      if(this.state.adsNotification!=false){
        if(this.state.customerPro==true) messaging().subscribeToTopic("adsPro"+strings.idLangue);
        else if(this.state.provider==true) messaging().subscribeToTopic("adsProvider"+strings.idLangue);
        else if(this.state.partner==true) messaging().subscribeToTopic("adsDriver"+strings.idLangue);
        else messaging().subscribeToTopic("ads"+strings.idLangue);
        
      }

      this.setState({adsNotificationOld:this.state.adsNotification})


}

                









startNotification= () => { 

   
  }
  
  gestionNotification= (notificationOpen) => {
          // Get the action triggered by the notification being opened
          console.log("notificationOpen")
          console.log(notificationOpen)

          if(notificationOpen!=undefined && notificationOpen!=null &&  notificationOpen.data!=undefined && Object.keys(notificationOpen.data).length>0 ){
            var data=notificationOpen.data;

            if(data.type=="Chat" && data.raceID!=undefined && data.raceID!=""){
              console.log("displayChatIfNotification")
              this.setState({notificationViewChat:data.raceID},() =>{ this.displayChatIfNotification() })
            }
            else if(data.type=="Race" && data.raceID!=undefined && data.raceID!=""){
              get(child(ref(getDatabase(firebase)), "/race/"+data.raceID)).then(value => {
                    var val=value.val();
                    

                    if(val!=null && data.cancel!="true"){
                      val.id=data.raceID;
                      this.props.navigation.navigate('RaceInfo',{viewMode:true, googleMyBusinessText:this.state.googleMyBusinessText, activateGoogleMyBusiness:this.state.activateGoogleMyBusiness,billMode:this.state.billMode,pricingView:{commissionDriver:this.state.commission,priceNetForDriver:this.state.priceNetForDriver,hidePriceRaceForDriver:this.state.hidePriceRaceForDriver, addCommissionFixe:this.state.addCommissionFixe, addCommissionFixeAmount:this.state.addCommissionFixeAmount, addCommissionVariable:this.state.addCommissionVariable, addCommissionVariableAmount:this.state.addCommissionVariableAmount},    viewPhone:this.state.viewPhone, privilegeDriver:this.state.privilegeDriver, actualUserCar:this.state.car, data:val,driver:this.state.driver,partner:this.state.partner  })
                    }
                    else {
                        if(data.messageTitle!=undefined && data.messageTitle!="") this.alert.onAlert({title:data.messageTitle, subTitle:data.messageSubtitle})
                    }

                  })



            }
            else {
              console.log("notif type "+data.type)

            }



          }
          /*
          firebaseNotif.notifications().removeAllDeliveredNotifications();*/

        }

 
  displayChatIfNotification= () => { 

    if(this.state.immediateInfo!=undefined && this.state.immediateInfo!="" && this.state.immediateInfo.uuid!=undefined && this.state.immediateInfo.uuid!="" ){
      if(this.state.immediateInfo.uuid===this.state.notificationViewChat){
          var inf={
            contactMessage:this.contactMessage,
            raceID:this.state.immediateInfo.uuid,
          }
          if(this.state.driver==true || this.state.partner==true){
            inf.partner=true;
            inf.sender=this.state.immediateInfo.clientName;
            inf.senderPhone=this.state.immediateInfo.clientPhone;
            inf.senderID=this.state.immediateInfo.clientID
          }
          else {
            inf.sender=this.state.immediateInfo.text;
            inf.senderPhone=this.state.immediateInfo.driverPhone;
            inf.senderID=this.state.immediateInfo.driverID
          }
          console.log("j'ouvre chat")
          this.props.navigation.navigate("Chat",inf)
          

      }

      this.setState({notificationViewChat:""})

    }   

  }

  searchProximityCoor(){
    var test=true;
    var cursor;
    var distanceTotal=100000000000;
    var cursorTotal;
    var calc;
      for(cursor=0;cursor<this.state.myDriverAnimate.coordinate.length;cursor++){
          calc=this.distance(this.state.immediateInfo.coor.latitude, this.state.immediateInfo.coor.longitude, this.state.myDriverAnimate.coordinate[cursor].latitude, this.state.myDriverAnimate.coordinate[cursor].longitude, "K") 
          
          if(calc<distanceTotal){distanceTotal=calc;
            cursorTotal=cursor;
          }

          
      }
      console.log("searchProximityCoor à trouver "+cursorTotal+" pour "+distanceTotal)
      if(distanceTotal<0.25) return cursorTotal
      else return false;


  }

calculateArrivalDate= rowData => {

    console.log("calculateArrivalDate lancé")

    if(rowData!=undefined || (this.state.immediateInfo!=undefined && this.state.immediateInfo!="" && this.state.immediateInfo.arrivalDate==undefined )){
      
      var lat, lon;
      if(rowData!=undefined){
        lat=rowData.latitude;
        lon=rowData.longitude; 
      }
      else {
        lat=this.state.immediateInfo.coor.latitude;
        lon=this.state.immediateInfo.coor.longitude; 
      }

    var fetchURLparams={origin:lat +',' +lon ,key: info.googleMapsKey,destination:this.state.immediateInfo.racePlaceStartName}
        var fetchURL=Qs.stringify(fetchURLparams)
        var body={paramsRqs:fetchURL, type:"directions" }
        var getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(body),method: "POST"})

        getDir.then(response => response.json())
              .then(responseJson => {
                if(typeof(responseJson)!="object") responseJson=JSON.parse(responseJson);
                if (responseJson.status != 'ZERO_RESULTS' && responseJson.routes.length){
                  var duration=responseJson.routes[0].legs[0].duration.value;
                  var lastPosition;
                  if(rowData!=undefined) lastPosition=rowData.lastPosition;
                  else lastPosition=this.state.immediateInfo.lastPositionDate;
                  var calcArrivalDateTotal=new Date(lastPosition+duration*1000);
                  var calcArrivalDate=((calcArrivalDateTotal.getHours()<10)?"0":"")+ calcArrivalDateTotal.getHours()+":"+((calcArrivalDateTotal.getMinutes()<10)?"0":"")+ calcArrivalDateTotal.getMinutes()
                  var viewRaceInProgress; 
                  if(rowData!=undefined && (this.state.immediateInfo==undefined || this.state.immediateInfo=="")) viewRaceInProgress={arrivalDate:calcArrivalDateTotal};
                  else {
                    viewRaceInProgress=this.state.immediateInfo;
                    viewRaceInProgress.arrivalDate=(rowData!=undefined)?calcArrivalDateTotal:calcArrivalDate;
                  }
                 

                  var coordDriver=this.decode(responseJson.routes[0].overview_polyline.points)
                  viewRaceInProgress.coordDriver=coordDriver;

                  if(rowData==undefined){
                      var mapRegion={}
                      mapRegion.latitude=this.state.immediateInfo.coor.latitude+((coordDriver[coordDriver.length-1].latitude-this.state.immediateInfo.coor.latitude)/2);
                      mapRegion.longitude=this.state.immediateInfo.coor.longitude+((coordDriver[coordDriver.length-1].longitude-this.state.immediateInfo.coor.longitude)/2);
                      mapRegion.latitudeDelta=Math.abs(coordDriver[coordDriver.length-1].latitude-this.state.immediateInfo.coor.latitude)*3+0.02;
                      mapRegion.longitudeDelta=Math.abs(coordDriver[coordDriver.length-1].longitude-this.state.immediateInfo.coor.longitude)*3+0.02;
                      viewRaceInProgress.mapRegion=mapRegion
                  }
                  
                  viewRaceInProgress.lastArrivateDate=Date.parse(new Date())
                  this.setState({immediateInfo:viewRaceInProgress })
                  if(this.state.geolocDriverPrecise!=false){

                          var iti=[]
                          var stPoint=responseJson.routes[0].legs[0]["steps"];
                          var stCount=0;
                          var stProv=0;

                          for(stCount=0; stCount<stPoint.length; stCount++){
                              stProv=this.decode(stPoint[stCount].polyline.points);
                              iti = iti.concat(stProv)

                          }

                    this.setState({geolocDriverPreciseCoord:iti    })

                  }

                }
              }).catch((err) => { console.log("error calculateArrivalDate"); console.log(err); timer.setTimeout("calculateArrivalDate", () => { this.calculateArrivalDate(rowData);  }, 2000);   })

            }

  }

  

  viewDriverCarOnCard(){

    var dateTest=Date.parse(new Date())
    console.log("viewDriverCarOnCard")



    if(dateTest>(this.state.directionsLastUpdate+3000) ){
      this.setState({directionsLastUpdate:dateTest}, () => {
        var i; 
        var testObli=true;
          if(this.state.immediateMode=="driverNavigateToCustomer"){


            var fetchURLparams={type:"directions", minimizeRequest:true,origin:this.state.immediateInfo.coor.latitude.toFixed(4) +',' +this.state.immediateInfo.coor.longitude.toFixed(4) ,key: info.googleMapsKey,destination:this.state.immediateInfo.racePlaceStartName}
            if(this.state.bicycling==true)  fetchURLparams.mode="bicycling";
            var fetchURL=Qs.stringify(fetchURLparams)
            var getDir;
           
            if(this.state.myDriver!=undefined && this.state.myDriver.coordinate!=undefined){
              var testProx=this.searchProximityCoor(); 
              if(testProx!==false ){
                testObli=false;
                var myDriverAnimate=this.state.myDriverAnimate
                myDriverAnimate.actual=testProx;
                

                this.setState({myDriverAnimate:myDriverAnimate}, () =>{this.animateMyDriverCar()} )

              }
            }
            if(testObli==true) {


             /* if(Platform.OS=="web"){
                var body={paramsRqs:fetchURL, type:"directions" }
                getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(body),method: "POST"})
              }
              else getDir=fetch('https://maps.googleapis.com/maps/api/directions/json?'+fetchURL) */
                var body={paramsRqs:fetchURL, type:"directions" }
                getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(fetchURLparams),method: "POST"})

                console.log("je lance du maps.googleapis 4")
              getDir.then(response => response.json())
                      .then(responseJson => {
                        console.log("j'ai lancé l'api 2")
                        if(typeof(responseJson)!="object") responseJson=JSON.parse(responseJson);
                        if (responseJson.status != 'ZERO_RESULTS' && responseJson.routes.length){

                          var position=-1; 
                          var lastDate=Date.parse(new Date())-Date.parse(new Date(this.state.immediateInfo.lastPositionDate))
                          var iti=[]
                          var stPoint=responseJson.routes[0].legs[0]["steps"];
                          var stCount=0;
                          var stProv=0;
                          var stDur=0;
                          var stI=0;
                          var totalDur=0; 
                          console.log("lastDate = "+lastDate)

                         

                          for(stCount=0; stCount<stPoint.length; stCount++){
                              stProv=this.decode(stPoint[stCount].polyline.points); 
                              
                              stDur=stPoint[stCount].duration.value*1000;
                              
                              for(stI=0;stI<stProv.length;stI++){

                                


                                stProv[stI].duration=stDur/stProv.length; 
                                totalDur+=stProv[stI].duration;
                                if(position==-1 && totalDur>lastDate) position=iti.length+stI
                                if(stI==0){
                                  if(iti.length>0) stProv[stI].rotation=this.angle(iti[iti.length-1].latitude,iti[iti.length-1].longitude,stProv[0].latitude,stProv[0].longitude)
                                }
                                else {
                                 
                                  stProv[stI].rotation=this.angle(stProv[stI-1].latitude,stProv[stI-1].longitude,stProv[stI].latitude,stProv[stI].longitude)
                                }
                              }

                              iti = iti.concat(stProv)

                          }
                         

                          var duration=responseJson.routes[0].legs[0].duration.value;
                          var calcArrivalDate=new Date(this.state.immediateInfo.lastPositionDate+duration*1000);
                          console.log("le chauffeur arrivera à " +calcArrivalDate)

                         if(position==-1) position=parseInt(iti.length/2);
                          if(position>iti.length) position=iti.length-5;
                          position--;
                          if(position<0) position=0; 
                          var immediateInfo=JSON.parse(JSON.stringify(this.state.immediateInfo));
                          immediateInfo.arrivalDate=calcArrivalDate;
                          console.log("immediateInfo.arrivalDate "+immediateInfo.arrivalDate)

                          
                          var mapRegion={}

                          console.log("iti[position]")
                          console.log(iti)
                          console.log(position)
                          
                          mapRegion.latitude=iti[position].latitude
                          mapRegion.longitude=iti[position].longitude
                          mapRegion.latitudeDelta=0.02;
                          mapRegion.longitudeDelta=0.02;
                          
                          console.log("update dans le bon")
                          console.log(immediateInfo); 
                          
                          if(Platform.OS=="web") this.setState({immediateInfo:immediateInfo});
                          else this.setState({immediateInfo:immediateInfo,mapRegion:mapRegion, myDriver:{coordinate: new MapView.AnimatedRegion({latitude: iti[position].latitude,longitude: iti[position].longitude,latitudeDelta: 0,longitudeDelta: 0,})},myDriverAnimate:{coordinate:iti,actual:position,}       },() =>{this.animateMyDriverCar()})
                        }
                      })

              }
            }
          else if(this.state.immediateMode=="raceInProgress" && this.state.immediateInfo.coor!=undefined){
            var destination=this.state.immediateInfo.racePlaceEndName; 
              
            if(this.state.immediateInfo.stopListActu!=undefined && this.state.immediateInfo.stopList!=undefined) 
            destination=this.state.immediateInfo.stopList[this.state.immediateInfo.stopListActu]
           
            console.log("raceInProgress destination "+destination)
            console.log("this.state.immediateInfo.coor")
            console.log(this.state.immediateInfo.coor)

            var fetchURLparams={origin:this.state.immediateInfo.coor.latitude.toFixed(4) +',' +this.state.immediateInfo.coor.longitude.toFixed(4) ,key: info.googleMapsKey,destination:destination, type:"directions", minimizeRequest:true,}
            var fetchURL=Qs.stringify(fetchURLparams)
            var getDir;

            
            if(this.state.myDriver!=undefined && this.state.myDriver.coordinate!=undefined && this.state.myDriverAnimate!=undefined){
              var testProx=this.searchProximityCoor(); 
              if(testProx!=false ){
                testObli=false;

                var myDriverAnimate=this.state.myDriverAnimate
                myDriverAnimate.actual=testProx;
                this.setState({myDriverAnimate:myDriverAnimate}, () =>{this.animateMyDriverCar()} )

              }
            }
            if(testObli==true) {
              /*
                if(Platform.OS=="web"){
                  var body={paramsRqs:fetchURL, type:"directions" }
                  getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(body),method: "POST"})
                }
                else getDir=fetch('https://maps.googleapis.com/maps/api/directions/json?'+fetchURL)

                  */

                  getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(fetchURLparams),method: "POST"})
            console.log("je lance du maps.googleapis")
                getDir.then(response => response.json())
                      .then(responseJson => {
                        console.log("j'ai lancé l'api 3")
                        if(typeof(responseJson)!="object") responseJson=JSON.parse(responseJson);
                        if (responseJson.status != 'ZERO_RESULTS' && responseJson.routes.length){
                          var iti=this.decode(responseJson.routes[0].overview_polyline.points);
                          var duration=responseJson.routes[0].legs[0].duration.value;
                          var calcArrivalDate=new Date(this.state.immediateInfo.lastPositionDate+duration*1000);
                          for(i=1;i<iti.length;i++){
                            iti[i].duration=(duration*1000)/iti.length;
                            iti[i].rotation=this.angle(iti[i-1].latitude,iti[i-1].longitude,iti[i].latitude,iti[i].longitude)

                          }

                          var position=Math.round(iti.length*((Date.parse(new Date())-Date.parse(new Date(this.state.immediateInfo.lastPositionDate)) )/(duration*1000)))
                          if(position>iti.length) position=iti.length-5;
                          position--;
                          if(position<0) position=0; 
                          var immediateInfo=this.state.immediateInfo;
                          immediateInfo.arrivalDate=calcArrivalDate;

                          var mapRegion={}
                          console.log("iti") 
                          console.log(iti) 
                          console.log(position)

                          mapRegion.latitude=iti[position].latitude
                          mapRegion.longitude=iti[position].longitude
                          mapRegion.latitudeDelta=0.02;
                          mapRegion.longitudeDelta=0.02;


                          if(Platform.OS=="web") this.setState({immediateInfo:immediateInfo});
                          else this.setState({immediateInfo:immediateInfo,mapRegion:mapRegion, myDriver:{coordinate: new MapView.AnimatedRegion({latitude: iti[position].latitude,longitude: iti[position].longitude,latitudeDelta: 0,longitudeDelta: 0,})},myDriverAnimate:{coordinate:iti,actual:position,}       },() =>{this.animateMyDriverCar()})
                        }
                      })
                    }
          }
          else if(this.state.immediateMode=="raceReturnInProgress"){

            var fetchURLparams={type:"directions", minimizeRequest:true,origin:this.state.immediateInfo.coor.latitude.toFixed(4) +',' +this.state.immediateInfo.coor.longitude.toFixed(4) ,key: info.googleMapsKey,destination:this.state.immediateInfo.racePlaceStartName}
            var fetchURL=Qs.stringify(fetchURLparams)
            var getDir;

            if(this.state.myDriver!=undefined && this.state.myDriver.coordinate!=undefined){
              var testProx=this.searchProximityCoor(); 
              if(testProx!=false ){
                testObli=false;
                var myDriverAnimate=this.state.myDriverAnimate
                myDriverAnimate.actual=testProx;
                this.setState({myDriverAnimate:myDriverAnimate}, () =>{this.animateMyDriverCar()} )

              }
            }
            if(testObli==true) {

                /*
                if(Platform.OS=="web"){
                  var body={paramsRqs:fetchURL, type:"directions" }
                  getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(body),method: "POST"})
                }
                else getDir=fetch('https://maps.googleapis.com/maps/api/directions/json?'+fetchURL)*/
                  
                  getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(fetchURLparams),method: "POST"})
                  console.log("je lance du maps.googleapis")
                getDir.then(response => response.json())
                      .then(responseJson => {
                        console.log("j'ai lancé l'api 4")
                        if(typeof(responseJson)!="object") responseJson=JSON.parse(responseJson);
                        if (responseJson.status != 'ZERO_RESULTS' && responseJson.routes.length){
                          var iti=this.decode(responseJson.routes[0].overview_polyline.points);
                          var duration=responseJson.routes[0].legs[0].duration.value;
                          var calcArrivalDate=new Date(this.state.immediateInfo.lastPositionDate+duration*1000);
                          for(i=1;i<iti.length;i++){
                            iti[i].duration=(duration*1000)/iti.length;
                            iti[i].rotation=this.angle(iti[i-1].latitude,iti[i-1].longitude,iti[i].latitude,iti[i].longitude)

                          }

                          var position=Math.round(iti.length*((Date.parse(new Date())-Date.parse(new Date(this.state.immediateInfo.lastPositionDate)) )/(duration*1000)))
                          if(position>iti.length) position=iti.length-5;
                          position--;
                          var immediateInfo=this.state.immediateInfo;
                          immediateInfo.arrivalDate=calcArrivalDate;
                          if(Platform.OS=="web") this.setState({immediateInfo:immediateInfo});
                          else this.setState({immediateInfo:immediateInfo,myDriver:{coordinate: new MapView.AnimatedRegion({latitude: iti[0].latitude,longitude: iti[0].longitude,latitudeDelta: 0,longitudeDelta: 0,})},myDriverAnimate:{coordinate:iti,actual:position,}       },() =>{this.animateMyDriverCar()})
                        }
                      })
                }
          }


          else{
            this.setState({myDriver:undefined})
          }

        })
    }

  }

  viewDriverNavigateToDestination(){
    
    if(this.state.latitude!=undefined && this.state.immediateMode!="driverArrivate" && this.state.immediateMode!=""){
      var dateTest=Date.parse(new Date())

      
      if(dateTest>(this.state.directionsLastUpdate+3000) ){

          this.setState({directionsLastUpdate:dateTest}, () => {

            var desti=(this.state.immediateMode=="raceInProgress" && this.state.immediateInfo.stopListActu!=undefined && this.state.immediateInfo.stopList!=undefined)?this.state.immediateInfo.stopList[this.state.immediateInfo.stopListActu]:((this.state.immediateMode=="raceInProgress")?this.state.immediateInfo.racePlaceEndName:this.state.immediateInfo.racePlaceStartName)
 
            console.log("viewDriverNavigateToDestination desti = "+desti)
            var fetchURLparams={type:"directions", minimizeRequest:true,origin:this.state.latitude.toFixed(4) +',' +this.state.longitude.toFixed(4) ,key: info.googleMapsKey,destination:desti}
            if(this.state.bicycling==true)  fetchURLparams.mode="bicycling";
            var fetchURL=Qs.stringify(fetchURLparams)
            var body={paramsRqs:fetchURL, type:"directions" }
            var getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(fetchURLparams),method: "POST"})
            /*
            if(Platform.OS=="web"){
              var body={paramsRqs:fetchURL, type:"directions" }
              getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(body),method: "POST"})
            }
            else getDir=fetch('https://maps.googleapis.com/maps/api/directions/json?'+fetchURL)
              */
              console.log("je lance du maps.googleapis")
            getDir.then(response => response.json())
            .then(responseJson => {
              if(typeof(responseJson)!="object") responseJson=JSON.parse(responseJson);
              if (responseJson.status != 'ZERO_RESULTS' && responseJson.routes.length){
                console.log("j'ai lancé l'api 1")

                var iti=[]
                var stPoint=responseJson.routes[0].legs[0]["steps"];
                var stCount=0;
                for(stCount=0; stCount<stPoint.length; stCount++){
                    iti = iti.concat(this.decode(stPoint[stCount].polyline.points))
                }

                this.setState({driverNavigateTo:iti});
                this.updatePositionDuringRaceAction();
                
              }
            })
          })
        }
      }
    else if(this.state.latitude==undefined && this.state.immediateMode!=""){
        timer.setTimeout("latitudeTentative", () => {this.viewDriverNavigateToDestination()}, 5000)
      }
    else if(this.state.latitude==undefined && this.state.immediateMode=="driverArrivate"){
        /*je recentre la carte sur le point de prise en charge */
        this.updatePosition();
    }


      else this.setState({driverNavigateTo:""})

         
  }





testDateRace(date,dateTxt){
  this.setState({waiting:true});
  if(this.state.timeEstimation==undefined || this.state.timeEstimation=="" || this.state.timeEstimation<10) this.alert.onAlert({title:strings.incorrectPricingEnd});
  else {
    var body={raceDate:date,timeEstimation:this.state.timeEstimation}
    console.log("je fais body "+JSON.stringify(body))
    fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/testRace", {
        body: JSON.stringify(body),method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                    console.log(responseJson)
                    this.setState({waiting:false})

                    if(responseJson.ok==true){
                        this.setState(() => ({date:dateTxt,integerDate:date}),function(){this.calculateMajoration()})
                    }
                    else{
                      var buttons=[];
                      var txt;

                      if(responseJson.dateMin>(this.state.dateMin-60000)){
                        txt=new Date(responseJson.dateMin);
                        txt=((txt.getHours()<10)?"0":"")+txt.getHours()+":"+((txt.getMinutes()<10)?"0":"")+txt.getMinutes()
                        buttons.push({text: txt,onPress: (value) => {  
                            txt=new Date(responseJson.dateMin);
                            txt=((txt.getDate()<10)?"0":"")+txt.getDate()+"/"+(((txt.getMonth()+1)<10)?"0":"")+(txt.getMonth()+1)+"/"+txt.getFullYear()+" - "+((txt.getHours()<10)?"0":"")+txt.getHours()+":"+((txt.getMinutes()<10)?"0":"")+txt.getMinutes()
                            this.setState(() => ({date:txt,integerDate:responseJson.dateMax}),function(){this.calculateMajoration()})

                        }})

                     }

                      txt=new Date(responseJson.dateMax);
                      txt=((txt.getHours()<10)?"0":"")+txt.getHours()+":"+((txt.getMinutes()<10)?"0":"")+txt.getMinutes()
                      buttons.push({text: txt,onPress: (value) => { 
                        txt=new Date(responseJson.dateMax);
                        txt=((txt.getDate()<10)?"0":"")+txt.getDate()+"/"+(((txt.getMonth()+1)<10)?"0":"")+(txt.getMonth()+1)+"/"+txt.getFullYear()+" - "+((txt.getHours()<10)?"0":"")+txt.getHours()+":"+((txt.getMinutes()<10)?"0":"")+txt.getMinutes()
                        this.setState(() => ({date:txt,integerDate:responseJson.dateMax}),function(){this.calculateMajoration()})

                        }})

                      buttons.push({text: strings.cancel, style:"cancel",onPress: () => {}} )

                      if(this.alert!=undefined) this.alert.onAlert({title:strings.noDriverAvaiable,subTitle:strings.shouldyouTakeRace, buttons:buttons})


                       


                    }
                    



        }).catch((err) => { console.log("error testRace"); console.log(err); timer.setTimeout("testRace", () => { this.testDateRace(date,dateTxt)  }, 2000);   })
    }
  }

  getRaceInProgressStartPrecise= uuid => { 
    if(this.state.driver!=true && this.state.partner!=true){
      onValue(ref(getDatabase(firebase), '/raceLocationPrecise/'+uuid), (value) => {
              var val=value.val();
              if(val!=null && this.state.driver!=true && this.state.partner!=true){
               
                if(this.state.geolocDriverPrecise!=false){
                    this.setState({myDriver:{coordinate:{latitude:val.coor.latitude, longitude:val.coor.longitude, rotation:0}} },() =>{
                      

                      if(this.state.immediateMode=="driverNavigateToCustomer" && (this.state.immediateInfo==undefined || this.state.immediateInfo.lastArrivateDate==undefined || (this.state.immediateInfo.lastArrivateDate-Date.parse(new Date())>350000) )){
                          this.calculateArrivalDate({latitude:val.coor.latitude, longitude:val.coor.longitude,lastPosition:val.lastPositionDate });
                      }

                      })

                } else {

                  if(this.state.trackingUUID!=undefined){
                      if(this.state.immediateMode=="driverNavigateToCustomer" && this.state.immediateInfo!=undefined && this.state.immediateInfo.attributedPartner!=undefined) {
                          
                          var immediateInfo=JSON.parse(JSON.stringify(this.state.immediateInfo)); 
                          immediateInfo.lastPositionDate=val.lastPositionDate; immediateInfo.coor=val.coor; if(immediateInfo.arrivalDate!=undefined) immediateInfo.arrivalDate=new Date(immediateInfo.arrivalDate);  
                          console.log("coor")
                          console.log(immediateInfo);
                          this.setState({immediateInfo:immediateInfo},() =>{ if(this.state.immediateInfo==undefined || this.state.immediateInfo.lastArrivateDate==undefined || (this.state.immediateInfo.lastArrivateDate-Date.parse(new Date())>180000) ) this.calculateArrivalDate(); }) 

                      }
                  } else {
                    var immediateInfo=JSON.parse(JSON.stringify(this.state.immediateInfo)); 
                    console.log(immediateInfo);  
                    immediateInfo.lastPositionDate=val.lastPositionDate; 
                    immediateInfo.coor=val.coor; 
                    if(immediateInfo.arrivalDate!=undefined) immediateInfo.arrivalDate=new Date(immediateInfo.arrivalDate); 

                    if(this.state.immediateMode=="driverArrivate") this.setState({immediateInfo:immediateInfo, myDriver:{coordinate:{latitude:val.coor.latitude, longitude:val.coor.longitude, rotation:0}} }) 
                    else this.setState({immediateInfo:immediateInfo},() =>{this.viewDriverCarOnCard() })  
                  }



                }

                
              }
          })
    
    }
  }
  
 getRaceInProgress = uuid => { 
      console.log("je vais faire getRaceInProgress "+this.state.geolocDriverPrecise)
      var calcArrivalDate=false

      
      timer.setTimeout("getRaceInProgressStartPrecise", () => {this.getRaceInProgressStartPrecise(uuid); }, 1000)

      

        

      var valueGetRaceInP=onValue(ref(getDatabase(firebase), "/race/"+uuid), (value) => {
        console.log("ON race in progress nouvelle info"+JSON.stringify(value).length)

        var val=value.val();


        var dateAct=new Date(); 

        
        if(this.state.geolocDriverPrecise!=undefined || this.state.lastUpdatePositionDuringRaceDriver==undefined || this.state.lastUpdatePositionDuringRaceDriver=="" || ((dateAct-this.state.lastUpdatePositionDuringRaceDriver)>2000) ){
          
        if(val!=null){
            var date=new Date(val.raceDate)
            var date2=new Date(val.raceDate+1000*val.estimateTimeValue)
            var dateInfo=((date.getDate()<10)?"0":"")+date.getDate()+" "+( (strings.monthList[date.getMonth()]!=undefined)?strings.monthList[date.getMonth()].toLowerCase():("/ "+(date.getMonth()+1) )     ) 
            console.log("dateInfo "+dateInfo)
            var hour=((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()
            var hourDestination=((date2.getHours()<10)?"0":"")+date2.getHours()+":"+((date2.getMinutes()<10)?"0":"")+date2.getMinutes()
            
        }
        
        var toOldRace=false;
        if(val!=null){

          var oorRace=new Date(val.raceDate);
          if(((dateAct - oorRace)>43200000)  && (val.attributedPartner==undefined || val.attributedPartner.lastPositionDate==undefined || (dateAct - new Date(val.attributedPartner.lastPositionDate)>43200000))   ) toOldRace=true;


        }

        if(this.state.trackingUUID!=undefined && val==null) this.setState({trackingUUID:"error"})
        

        else if(this.state.trackingUUID==undefined && (val==null || (val.attributedPartner!=undefined && val.attributedPartner.id!=getAuth(firebase).currentUser.uid && (this.state.driver==true || this.state.partner==true)) || val.status=="invoiced" || val.status=="finish" || val.status=="cancel" || val.status=="remove" || toOldRace==true)) {
          console.log("je vais tester "+this.state.trackingUUID)
          if(this.state.trackingUUID==undefined){
              this.setState({immediateMode:"",immediateInfo:{},myDriver:"",driverNavigateTo:""});
              const fireInfo={} 
              fireInfo["/users/"+getAuth(firebase).currentUser.uid+"/raceInProgress"]=null
              update(ref(getDatabase(firebase)), fireInfo)
              if(this.state.valueGetRaceInP!=undefined) this.state.valueGetRaceInP(); 
              if(val!=null && val.status=="cancel"){

               if(this.alert!=undefined && val.noShow==undefined)  this.alert.onAlert({title:strings.noDriver, subTitle:strings.contactUrgency,buttons:[{text: strings.ok,onPress: () => { } }, {text: strings.contactUs,onPress: () => { this.closeControlPanel("Contact") } }  ] }); 


                
              }
              else if(val!=null && (val.status=="remove" || val.status=="cancel")){
                this.alert.onAlert({title:strings.raceHasBeenCanceled})
              }
          }

         
        }
        else if(val!=null && val.status=="waiting"){
          this.findDriver(); 
          if(this.state.trackingUUID!=undefined){
            var immInfo={racePlaceStartName:val.racePlaceStartName, date:dateInfo, hour:hour, hourDestination:hourDestination, status:"waiting"}
            if(val.racePlaceEndName!=undefined) immInfo.racePlaceEndName=val.racePlaceEndName;
            this.setState({immediateInfo:immInfo})
          }

        } 
        else if(val.status=="validate" || ( (val.status=="invoiced" || val.status=="finish") && this.state.trackingUUID!=undefined)){
          console.log("la course est "+uuid)
          
          if(this.state.driver==true || (this.state.partner==true && this.state.viewPhone=="always") && val.driverPhone==undefined){
              const fireInfo={} 
              fireInfo['users/' + this.state.clientID+"/dispenserMode/driverPhone"]=this.state.phone
              update(ref(getDatabase(firebase)), fireInfo)

          }

          var immInfo=this.state.immediateInfo;
          if(immInfo.arrivateDate!=undefined) immInfo.arrivateDate=new Date(immInfo.arrivateDate);
          if(immInfo=="" || immInfo==undefined) immInfo={};
          immInfo.uuid=uuid;
          immInfo.status=val.status;

          if(val.charge!=undefined) immInfo.charge=val.charge;
          if(val.deferredPayment==true) immInfo.deferredPayment=true;
          if(val.customerPro==true || val.providerID!=undefined || val.viaAPI==true || val.karhooProvider==true) immInfo.noChat=true;

          if(this.state.trackingUUID!=undefined){
              immInfo.racePlaceStartName=val.racePlaceStartName;
              immInfo.date=dateInfo 
              immInfo.hour=hour; 
              immInfo.hourDestination=hourDestination;
              if(val.racePlaceEndName!=undefined) immInfo.racePlaceEndName=val.racePlaceEndName;
              immInfo.raceInProgress=val.raceInProgress;
              immInfo.immediateMode=val.immediateMode;
              immInfo.attributedPartner=val.attributedPartner;
              immInfo.driverNavigateDate=val.driverNavigateDate
              immInfo.realRaceDate=val.realRaceDate
              immInfo.dropOffDate=val.dropOffDate;
              immInfo.sla=val.sla
              
              

              if(this.state.immediateInfo!=false) {
                immInfo.arrivalDate=this.state.immediateInfo.arrivalDate;
                immInfo.coordDriver=this.state.immediateInfo.coordDriver;
                immInfo.mapRegion=this.state.immediateInfo.mapRegion;
                immInfo.lastArrivateDate=this.state.immediateInfo.lastArrivateDate;
              }
          }

          if(val.attributedPartner!=undefined){
            immInfo.text=val.attributedPartner.text;
            immInfo.clientPhone=val.clientPhone;
            immInfo.carName=val.carName; 
            immInfo.clientName=val.clientName+" "+val.clientLastName;
            immInfo.clientUName=val.clientName
            immInfo.clientLastName=val.clientLastName;
            if(val.clientNote!=undefined) immInfo.clientNote=val.clientNote;
            if(val.partnerNote!=undefined) immInfo.partnerNote=val.partnerNote;
            immInfo.driverID=val.attributedPartner.id
            immInfo.clientID=val.clientID
            if(val.taxiMode==true) immInfo.taxiMode=true;
            if(val.goReturnTaxi==true) immInfo.goReturnTaxi=true;

            if(val.numTrain!=undefined) immInfo.numTrain=val.numTrain
            if(val.numFlight!=undefined) immInfo.numFlight=val.numFlight
            
            immInfo.raceDate=val.raceDate

            immInfo.picture="https://firebasestorage.googleapis.com/v0/b/"+info.firebaseProjectID+".appspot.com/o/partners%2F"+val.attributedPartner.id+"%2Fpicture.jpg?alt=media"
            if(val.attributedPartner.car!=undefined && val.attributedPartner.car.brand!=undefined) immInfo.car=val.attributedPartner.car.brand+" "+val.attributedPartner.car.model;
            if(val.attributedPartner.car!=undefined && val.attributedPartner.car.immatriculation!=undefined) immInfo.immatriculation=val.attributedPartner.car.immatriculation;

            if(val.attributedPartner.coor!=undefined && val.attributedPartner.coor!=null) {immInfo.coor=val.attributedPartner.coor; immInfo.lastPositionDate=val.attributedPartner.lastPositionDate}

            immInfo.racePlaceStartName=val.racePlaceStartName;

            var finalAdress=(val.immediateMode=="raceInProgress" && val.sla!=undefined && val.stopList!=undefined)?(val.stopList[val.sla]):(        (val.immediateMode=="raceInProgress")?val.racePlaceEndName:val.racePlaceStartName)
            
            
            if(finalAdress!=undefined) immInfo.splitAdress=finalAdress.split(', ');


            if(val.karhooProvider==true) immInfo.karhooProvider=true;

            if(val.stopList!=undefined) immInfo.stopList=val.stopList; 
            if(val.sla!=undefined) immInfo.stopListActu=val.sla; 


            if(val.racePlaceEndName!=undefined) immInfo.racePlaceEndName=val.racePlaceEndName;
            if(val.arrivateDate!=undefined) immInfo.arrivateDate=new Date(val.arrivateDate); 
            immInfo.driverPhone=(val.driverPhone!=undefined)?val.driverPhone:""
            
            
          } 
          
          var OldimmediateMode=this.state.immediateMode; 

          if(val.raceInProgress==false && this.state.trackingUUID==undefined){
            this.setState({immediateMode:"",immediateInfo:{},myDriver:"",driverNavigateTo:""})
          }
          else this.setState({immediateMode:val.immediateMode,immediateInfo:immInfo},() =>{
            this.displayChatIfNotification();
            this.setState({kmEstimation:'', provisionDuration:'',priceEstimation:'',estimatePriceGo:'', estimatePriceGoTaxi:"", date:'', integerDate:'',  markers:[],startAddress:'',endAddress:'',coords: [],mapFrom:{ description: '',userDescription:'' },mapIntermediate:[],mapTo: { description: '',userDescription:''}})

            if(this.state.driver==true || this.state.partner==true){
              /* chauffeur */
              val.id=uuid;
              this.setState({infoRace:val},() =>{ if(val.sla!=undefined) this.changeStopListActu(val.sla)  })
              
              if(OldimmediateMode!=this.state.immediateMode) this.viewDriverNavigateToDestination();
            }
            
          })
          

        }

      }

      else { console.log("toh ! ") }

      })

    this.setState({valueGetRaceInP:valueGetRaceInP}); 

    
  }


 _openDrawer = () => {
  this.setState({adsFullScreen:undefined})
 	this.openControlPanel();
    console.log("open drawer")
    

  }

  changeStopListActu= (newValue) => {
    /*passager pas encore à prendre en charge gris clair*/
    /*passager à prendre en charge : gras */
    /*passager à bord normal */
    /*passager disparu => barré */

    /*affiche en noir si pas de start et pas de end ou si step=="travel"*/
    if(this.state.infoRace.passagersList!=undefined && this.state.infoRace.passagersList.length>0){

      var i,j; 
      var passagerTake="";
      var passagerLeave="";
      var passagersList=JSON.parse(JSON.stringify(this.state.infoRace.passagersList))
      var cli;
      for(i=0;i<this.state.infoRace.passagersList.length;i++){
        cli=(this.state.infoRace.passagersList[i].name==undefined && this.state.infoRace.passagersList[i].lastName==undefined)?(strings.customer+" "+i):(this.state.infoRace.passagersList[i].name+" "+this.state.infoRace.passagersList[i].lastName) 

        if(this.state.infoRace.passagersList[i].start!=undefined && this.state.infoRace.passagersList[i].start==this.state.immediateInfo.stopList[newValue]){
            if(passagerTake=="") passagerTake=strings.priceCharge+" : "+cli;
            else passagerTake+=" + "+cli;

              passagersList[i].step="priceCharge";

        }
        if(this.state.infoRace.passagersList[i].start!=undefined && this.state.infoRace.passagersList[i].start!=this.state.immediateInfo.stopList[newValue]){
              if(this.state.infoRace.passagersList[i].step=="priceCharge") passagersList[i].step="travel";
              else {
                  for(j=0; j<newValue;j++){
                    if(this.state.infoRace.passagersList[i].start==this.state.immediateInfo.stopList[j]) passagersList[i].step="travel";
                  }
              }

        }
        if(this.state.infoRace.passagersList[i].end!=undefined && this.state.infoRace.passagersList[i].end==this.state.immediateInfo.stopList[newValue]){
            if(passagerLeave=="") passagerLeave=strings.dropOff+" : "+cli;
            else passagerLeave+=" + "+cli;

            passagersList[i].step="dropOff"; 
        }
        if(this.state.infoRace.passagersList[i].end!=undefined && this.state.infoRace.passagersList[i].end!=this.state.immediateInfo.stopList[newValue]){
            if(this.state.infoRace.passagersList[i].step=="dropOff") passagersList[i].step="leave"; 
            else {
              for(j=newValue-1; j>-1;j--){
                    if(this.state.infoRace.passagersList[i].end==this.state.immediateInfo.stopList[j]) passagersList[i].step="leave";
                  }

            }

        }



      }
      console.log("passagersList")
      console.log(passagersList)
      var infoRace=JSON.parse(JSON.stringify(this.state.infoRace))
      infoRace.passagersList=passagersList;

      this.setState({passagerTake:passagerTake,passagerLeave:passagerLeave, infoRace:infoRace })

    }

  }

  hideMultiStop = () => {

    this.setState({viewMultiStop:false})

    if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true, title: (info.enableOnOffButton==true && this.state.partner==true)?((this.state.partnerOnline==true)?strings.online:strings.offline):strings.maps,  headerLeft: props => <HeaderLeft goBackEnabled={false} openDrawer={this._openDrawer} createAccount={this._createAccount} enableDrawer={(getAuth(firebase).currentUser!=null)?true:false}  /> })

  }

  _createAccount = () => {
  console.log("createAccount")
  const style=styleInfo();
  if(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax ){
    this.setState({viewCreateAccount:"firstConnexion", controlePanelOpen:true});

    if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false }) 
  }
  else this.props.navigation.navigate('CreateAccount',{goToBook:() => {console.log("je suis dans goToBook2"); this.props.navigation.popToTop(); this.getPersonnalInformations();   }    });


  }

  clickOnAdd= (ads,full ) => {

        if(ads.link!=undefined && ads.link!="" && (ads.action==undefined || ads.action=="web") ) {Linking.openURL(ads.link); if(full==true) this.setState({adsFullScreen:undefined, }) }
        else if(ads.action==="contact") {this.closeControlPanel("Contact", {description:ads.link}); if(full==true) this.setState({adsFullScreen:undefined, }) }
        else if(ads.action==="clipboard") {
            if(Platform.OS=="web" && this.alert!=undefined) this.alert.onAlert({title:ads.link })
            else {
              this.copyToClipboard(ads.link)
              if(this.alert!=undefined) this.alert.onAlert({title:strings.copiedClipboard }) 
            }
            
            if(full==true) this.setState({adsFullScreen:undefined, }) 
          }

  }



  
  findMoney(value){
    if(value==undefined) value="eu";
    var final="";
    var i;
    for(i=0;i<moneyList.length;i++){
      if(final==""){
        if(moneyList[i].id==value) final=moneyList[i];
      }
    }
    return final
  }

  getMyNote= already => {

    if(getAuth(firebase).currentUser!=undefined){
      if(this.state.name==undefined && already!=true){ timer.setTimeout("getMyNote", () => {this.getMyNote(true) }, 2000); } 

      else {
        if( (this.state.partner==true && this.state.activateDriverNotation==true) ||  (this.state.partner!=true && this.state.activateCustomerNotation==true)  ) {

          get(child(ref(getDatabase(firebase)), '/reviews/users/'+getAuth(firebase).currentUser.uid+"/infos")).then(value => {
            console.log("ONCE get My note "+JSON.stringify(value).length)
            var val=value.val();
            if(val!=undefined){
              this.setState({note:val})
            }

         })
      }

      } 
    }
  }




  componentDidMount() {

    
    if(Platform.OS!="web"){
      var i;
       

      for(i=0;i<this.state.animateCarsList.length;i++){
      
      this.animateCars(i);
    }

    

    }
    


    if(Platform.OS!="web"){
      this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true, title: strings.maps, headerLeft: props => <HeaderLeft goBackEnabled={(this.state.viewMultiStop==true)?true:false} enableDrawer={false} hideMultiStop={this.hideMultiStop} openDrawer={this._openDrawer} createAccount={this._createAccount} {...props} />, headerRight: props => <HeaderRight hideMultiStop={this.hideMultiStop} enablePartner={false} goBackEnabled={ (this.state.viewMultiStop==true)?true:false}  {...props} /> })
      if(this.state.controlePanelOpen==true)this.props.navigation.setOptions({headerShown:false});
      
    }


    if(this.state.trackingUUID!=undefined) this.getRaceInProgress(this.state.trackingUUID);
    else {
      
      this.getProvisionPrice();
      this.getPrice();
      this.getFavoriteGlobal();
      this.getMajoration();
      this.getSettings()
      if(getAuth(firebase).currentUser==null){
        /*c'est que c'est pas gérér par welcome */
        onAuthStateChanged(getAuth(firebase), user => { 
          console.log("ca a changé")
            if(user){
                if(this.state.name==undefined) this.getCustomerPrice();
                timer.setTimeout("getPersoInfo", () => {if(this.state.name==undefined) {this.getPersonnalInformations(); this.startNotification();}  }, 1000);
                if(this.state.goToCreateAccount==true) this.setState({viewCreateAccount:false, goToCreateAccount:false,controlePanelOpen:false})
            } 
            else if(Platform.OS=="web"){ this._drawer.close(); this.updateAfterBook(); this.setState({immediateMode:""})   }
            else if(this.state.name!=undefined) this.props.navigation.dispatch(CommonActions.reset({index: 0,routes: [{ name: 'Main' },],}) );


      });


    } else {
        this.getPersonnalInformations();
        this.startNotification();
        this.getCustomerPrice();
    }
    timer.setTimeout("getDriversPosition", () => {
      this.getDriversPosition(); 
      if(this.state.driver==true) timer.setInterval("updateMyPositionStartInter", () => {this.getDriversPosition() }, 180000);


    }, 5000);
  }

    timer.setTimeout("updateMyPositionStart", () => {this.updatePosition() }, 2000);
    
    if(this.state.goToCreateAccount==true) this._createAccount(); 


      
    
    
   

    

    


  }
  updatePositionDuringRaceAction(){


    if(( this.state.partner==true || this.state.driver==true) && this.state.immediateMode!="") {
      console.log("updatePositionDuringRaceAction verif passé")
      Geolocation.getCurrentPosition(position => {console.log("lance updatePosition");this.setState({errorGeolocalisation:false}); this.lastUpdatePosition(position) },error => {
         

          this.setState({errorGeolocalisation:true}) 
        }, { enableHighAccuracy: true, maximumAge: 5000 } ); 

       

      }
  }


  lastUpdatePosition(position){
      
      
      this.setState({markerGeo:{coordinates:position.coords} })
      var dateAct=new Date(); 
      var oldDate=this.state.lastUpdatePositionDuringRaceDriver;
      if(oldDate==undefined) oldDate=new Date("Wed Apr 15 2020 10:00:00");
      if(this.state.geolocDriverPrecise!=false || (this.state.immediateMode!="" && (dateAct-oldDate)>15000) ){
          if(this.state.immediateMode!="" && (dateAct-oldDate)>15000 && this.state.latitude==undefined) this.setState({latitude:position.coords.latitude, longitude:position.coords.longitude})
            this.setState({lastUpdatePositionDuringRaceDriver:new Date()},() =>{
              const fireInfo={} 
              fireInfo['/raceLocationPrecise/'+this.state.immediateInfo.uuid+"/coor"]={latitude: position.coords.latitude,longitude: position.coords.longitude,}; 
              fireInfo['/raceLocationPrecise/'+this.state.immediateInfo.uuid+"/lastPositionDate"]=Date.parse(new Date());

              update(ref(getDatabase(firebase)), fireInfo)
            }) 
      }

  }


          

 


  
  updatePosition(oldValue){
      
  		if(oldValue===true){
  			timer.setTimeout("oldMyPositionValue", () => { this.updatePositionData(this.state.oldMyPositionValue); }, 2000);
  			

  		}
  		else if(this.state.provider!=true || this.state.providerAdress==undefined){
      	
	      Geolocation.getCurrentPosition(position => {
		        var t = new Array();
		        t[0] = new Object();

            console.log("position actualisée")
            console.log(position)
		        
		        t[0].coordinates = {
		          latitude: position.coords.latitude,
		          longitude: position.coords.longitude,
              accuracy:position.coords.accuracy,
		        };

		       

		        var r={coordinates:{latitude: position.coords.latitude,longitude: position.coords.longitude},markers:t}

		        if(this.state.partner==true || this.state.driver==true || this.state.enableRealPosition!=true || Platform.OS=="web"){

		        		r.description=strings.myPosition
		        		r.userDescription=strings.myPosition
		        		r.descriptionPosition=true;
		        		this.updatePositionData(r)

		        }
		        else {
              console.log("je lance du maps.googleapis")
		        	fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' +position.coords.latitude +',' +position.coords.longitude +'&key='+info.googleMapsKey)
			          .then(response => response.json())
			          .then(responseJson => {
			          	r.description=responseJson.results[0]["formatted_address"]
			          	r.userDescription=responseJson.results[0]["formatted_address"]
			          	r.descriptionPosition=false;
			          	this.updatePositionData(r)
			          })

		        }
	      },
	      error => {
	        console.log("erreur geoloc "); console.log(error); 
	      },{ enableHighAccuracy: false, timeout: 25000, maximumAge: 5000 });
	  }
    
  }


  updatePositionData(data){	

  	

  		if(data.description!=undefined && data.coordinates!=undefined){


  			var r={
  				description:data.description,
  				userDescription:data.userDescription,
  				coordinates:data.coordinates,
  				descriptionPosition:(data.descriptionPosition==true)?true:false,
  				iconDark:require('../assets/favorite/target_white.png'),
          iconLight:require('../assets/favorite/target_black.png'),

  			}
        var sendState={
          latitude: data.coordinates.latitude,
          longitude: data.coordinates.longitude,
          error: null,
          markerGeo:{coordinates:data.markers[0].coordinates},
        }
        console.log("azerty update position")
        if(this.state.immediateMode=="" || this.state.immediateMode==undefined || this.state.immediateInfo==undefined || this.state.immediateInfo=="" || this.state.myDriverAnimate==undefined || this.state.myDriverAnimate=="") sendState.mapRegion= {latitude:data.coordinates.latitude,longitude: data.coordinates.longitude,latitudeDelta: 0.0922,longitudeDelta: 0.0421}

        this.setState(sendState, () => {

          if( (this.state.partner==true || (this.state.driver==true && this.state.adminNotRace!=true) ) && getAuth(firebase).currentUser!=null){
            const fireInfo={} 
            fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/lastDriverPositionLatitude"]=data.coordinates.latitude; 
            fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/lastDriverPositionLongitude"]=data.coordinates.longitude; 
            fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/lastDriverPositionDate"]=Date.parse(new Date()); 
            update(ref(getDatabase(firebase)), fireInfo)            
          }

        })
        

         



        var data2=JSON.stringify(data);
        data2=JSON.parse(data2)

        console.log("immediateModeOrder = "+this.state.immediateModeOrder)
        if(this.state.mapFrom.description==strings.myPosition || this.state.markers.length==0){
          if(this.state.disableAutomaticMapFrom!=true && this.state.saveBook.returnAlready!=true ) this.setState({mapFrom: r})
          this.setState({markers: data.markers,oldMyPositionValue:data2})    
        }
              

        }      
              

  }

  saveBook = data => { 
    this.setState({saveBook:data})
  }

  purposeReturnValid = data => { 

            var saveReturnInfo=this.state.saveReturnInfo;
            var saveBook=saveReturnInfo.saveBook;
            saveBook.returnAlready=true; 
            var i;
            var saveProv;

            if(saveBook.passagersList!=undefined && saveBook.passagersList.length>0){
          
              for(i=0; i<saveBook.passagersList.length;i++){
                  if(saveBook.passagersList[i].start!=undefined){

                    if(saveBook.passagersList[i].end!=undefined) {
                      saveProv=saveBook.passagersList[i].end;
                      saveBook.passagersList[i].end=saveBook.passagersList[i].start;
                      saveBook.passagersList[i].start=saveProv;
                    }
                    else {
                      saveBook.passagersList[i].end=saveBook.passagersList[i].start
                      delete saveBook.passagersList[i].start
                    }
                  }
                  else if(saveBook.passagersList[i].end!=undefined){
                    saveBook.passagersList[i].start=saveBook.passagersList[i].end
                    delete saveBook.passagersList[i].end;
                  }
              }
            }

            saveProv= this.state.saveReturnInfo.mapTo;

            var mapIntermediate=[];
            if(this.state.saveReturnInfo.mapIntermediate!=undefined && this.state.saveReturnInfo.mapIntermediate.length>0){
              for(i=this.state.saveReturnInfo.mapIntermediate.length; i>0; i--) 
                mapIntermediate.push(this.state.saveReturnInfo.mapIntermediate[i-1]);

            }


            this.setState({
                saveBook:saveBook,
                destinationTypeVerif:(this.state.saveReturnInfo.mapFrom.icon!=undefined)?this.state.saveReturnInfo.mapFrom.icon:false,
                destinationID:(this.state.saveReturnInfo.mapFrom.id!=undefined)?this.state.saveReturnInfo.mapFrom.id:"" ,
                mapTo: this.state.saveReturnInfo.mapFrom, 
                mapFrom: saveProv,
                mapIntermediate:mapIntermediate 


            },()=>{this.drawRoute();  }); 

  }

  purposeReturn= data => { 

      if(data!=undefined) this.purposeReturnValid(data)
      else if(this.alert!=undefined)this.alert.onAlert({title:strings.wantCreateReturn,buttons:[{text: strings.yes,onPress: () => { this.purposeReturnValid() }},{text: strings.no,onPress: () => { this.setState({saveBook:{name:"",lastName:"",phone:"",email:"",enterprise:"",adressBill:"",cityBill:"", description:"",passagerNumber:1}}) }}  ],});

  }

  updateAfterBook = data => { 



    console.log("je start updateAfterBook")
    console.log(data)

	    if(data!=undefined && typeof(data)=="object" && data.immediate==true) {
	      this.findDriver(); 
	      timer.setTimeout(generateUUID(), () => {this.getRaceInProgress(data.raceUUID)  }, 2000);
	      
	    }
	    else this.setState({ saveReturnInfo:{mapFrom:this.state.mapFrom, mapTo:this.state.mapTo, mapIntermediate:this.state.mapIntermediate, saveBook:this.state.saveBook},       kmEstimation:'', stopList:[],  saveBook:{name:"",lastName:"",phone:"",email:"",enterprise:"",adressBill:"",cityBill:"",description:"",}, immediateMode:"", provisionDuration:'',priceEstimation:'',estimatePriceGo:'', estimatePriceGoTaxi:"", date:'', integerDate:'',  markers:[],startAddress:'',endAddress:'',coords: [],mapFrom:{ description: '',userDescription:'' },mapIntermediate:[], mapTo: { description: '',userDescription:'' }},() =>{ if(this.state.provider==true && this.state.providerAdress!=undefined) this.setState({mapFrom:this.state.providerAdress}); else this.updatePosition(true)})
	  }

  start3DSecure = data => { 
    this.setState({waiting3DSecure:true})
  }

  findPhoneIID(test){
    if(test!=undefined) test=test.replace("+","00")
    var final="";
    var i,j;
    var n;
    var list=Object.keys(countryList);
    for(i=0;i<list.length;i++){
      if(final==""){
          var testList=countryList[list[i]].list;
          for(j=0;j<testList.length;j++){ 
            if(test!=undefined){
              n=testList[j].idd.replace("+","00")
              n=test.search(n)
              if(n==0) final=testList[j]
            }
            else if(testList[j].id==info.countryCode) final=testList[j]
          }
      }
    }
    if(final=="") return {id:"fr",code:"+33"}
    else return {id:final.id,idd:final.idd, flag:final.flag}
    
  }


  contactMessage= data => {

	    if( (this.state.driver==true || (this.state.viewPhone=="always") || (this.state.viewPhone=="onlyManualClient" && this.state.immediateInfo!=undefined && this.state.immediateInfo.noChat==true)     ) || (this.state.driver==false && this.state.partner==false && this.state.immediateInfo.driverPhone!="") ){
        console.log("data testé "+data)
      var result=this.findPhoneIID(data)
      if(data[0]=="+" && result.idd!="+39" && data[result.idd.length]=="0" ) data=result.idd+data.slice(result.idd.length+1,data.length)
      else if(data[0]=="0" && data[1]=="0" && result.idd!="+39" && data[result.idd.length+1]=="0" ) data=result.idd+data.slice(result.idd.length+2,data.length)
        

	        if(this.alert!=undefined) this.alert.onAlert({title:strings.howContact,buttons:[
	              {text: strings.withSMS,onPress: () => {Linking.openURL("sms:"+data)  }},
	              {text: strings.withWhatsApp,onPress: () => {
	              	var phone=data;
            		if(phone!=undefined && phone[0]==0 && info.countryCode=="fr") phone="33"+phone;
      			  	Linking.openURL('whatsapp://send?text='+" "+((Platform.OS === 'ios')?"&":"?")+"phone="+phone )
      			  }},
	              {text: strings.withPhone,onPress: () => {Linking.openURL("tel:"+data)}},
	              {text: strings.cancel, style:"cancel",onPress: () => {}}
	              ],});
	    }
	    
      else {

	      if(this.alert!=undefined) this.alert.onAlert({title:strings.contactDispatcher,buttons:[
	              {text: strings.yes,onPress: () => {Linking.openURL("tel:"+info.companyPhone)  }},
	              {text: strings.cancel, style:"cancel",onPress: () => {}}
	              ],});

	    }

  }

  onChangeFrom = data => {
    
	    var t = this.state.markers;
	    t[0] = new Object();
	    t[0].coordinates = data.coordinates;
	    t[0].pinColor = '#ff0000';

      var saveBook=this.state.saveBook; 
      saveBook.trajetChange=true;
      delete saveBook.returnAlready; 

	    var mapRegion={}
	    mapRegion.latitude=data.coordinates.latitude;
	    mapRegion.longitude=data.coordinates.longitude;
	    mapRegion.latitudeDelta= 0.0922,
	    mapRegion.longitudeDelta= 0.0421,

	    this.setState({saveBook:saveBook,mapRegion:mapRegion, startTypeVerif:(data.icon!=undefined)?data.icon:false,  })
	    if(this.state.durationSelected!=true) this.setState({ mapFrom: data },()=>this.drawRoute()    ); 
	    else {this.setState({ mapFrom: data },()=>this.provisionCalc());}
    };
  
  

  onChangeTo = data => {
	    var t = this.state.markers;
	    t[1] = new Object();
	    t[1].coordinates = data.coordinates;
	    t[1].pinColor = '#00ff00';

      var saveBook=this.state.saveBook; 
      saveBook.trajetChange=true;
      delete saveBook.returnAlready; 



	    this.setState({saveBook:saveBook,destinationTypeVerif:(data.icon!=undefined)?data.icon:false,    durationSelected:false, waitDispenserResult:true, destinationID:(data.id!=undefined)?data.id:"" ,mapTo: data, provisionDuration:'' },()=>{this.drawRoute();  }); 
      

    };


    onChangeIntermediateStop = (data,id) => {

      var mapIntermediate=this.state.mapIntermediate; 
      if(id==-1) mapIntermediate.push(data); 
      else mapIntermediate[id]=data; 

      var saveBook=this.state.saveBook; 
      saveBook.trajetChange=true;
      delete saveBook.returnAlready; 

      this.setState({saveBook:saveBook,mapIntermediate:mapIntermediate },()=>{this.drawRoute();  }); 
      

     


    }


    clickOnCard= (typeOfDest,loc) => {
      console.log("je lance du maps.googleapis")
      fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' +loc.latitude +',' +loc.longitude +'&key='+info.googleMapsKey)
                .then(response => response.json())
                .then(responseJson => {

                  var sendTo={"coordinates": {"latitude": loc.latitude, "longitude": loc.longitude}, "description":responseJson.results[0]["formatted_address"] , "userDescription": responseJson.results[0]["formatted_address"]}
                  if(typeOfDest=="start") this.onChangeFrom(sendTo);
                  else this.onChangeTo(sendTo);
                  
                  
                })

    }

    addPreviousSearch = data => {
      if(getAuth(firebase).currentUser!=undefined && this.state.dispenser.enabled!=true){
          var psobj=this.state.previousSearch;
          var array=Object.keys(psobj);
          var i;
          for(i=0;i<array.length;i++){
            delete psobj[array[i]].previous;
            if(psobj[array[i]].icon=="previous") delete psobj[array[i]].icon;
            if(psobj[array[i]].description===data.description){
              delete psobj[array[i]];

            } 

          }
          psobj[Date.parse(new Date())]=data;
          if(array.length>9) delete psobj[array[0]];
          const fireInfo={} 
          fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/previousSearch"]=psobj
          update(ref(getDatabase(firebase)), fireInfo)
      }
    }

    removePreviousSearch = data => {
    	console.log("je veux supprimer "+data)
    	var psobj=this.state.previousSearch;
    	delete psobj[data];
      var i;
      var array=Object.keys(psobj);
      for(i=0;i<array.length;i++){
        delete psobj[array[i]].previous;
        if(psobj[array[i]].icon=="previous") delete psobj[array[i]].icon;
      }
    	const fireInfo={} 
      fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/previousSearch"]=psobj
      update(ref(getDatabase(firebase)), fireInfo)

    }
  
   
  changeDuration = data => {
	  	var mark=[];
	  	console.log("je lance change duration")
      console.log("markers state")
      console.log(this.state.markers)

	  	if( this.state.mapFrom!="" && this.state.mapFrom!=undefined && this.state.mapFrom.coordinates!=undefined) mark.push(this.state.mapFrom)

	  	this.setState({durationSelected:true, mapIntermediate:[],endAddress:"", provisionDuration: data,mapTo:'',kmEstimation:"", coords: [],markers:mark },()=>this.provisionCalc());

  }

  changeDate= data => {
  	console.log("changeDate dans le main");
    if(this.state.onlyOneRaceBySlots==true && this.state.driver!=true && this.state.partner!=true){
        if(data.immediate==true){
          data.date=new Date();
          data.dateTxt=((data.date.getDate()<10)?"0":"")+data.date.getDate()+"/"+((data.date.getMonth()<9)?"0":"")+(data.date.getMonth()+1)+"/"+data.date.getFullYear()+" - "+((data.date.getHours()<10)?"0":"")+data.date.getHours()+":"+((data.date.getMinutes()<10)?"0":"")+data.date.getMinutes()
          data.date=Date.parse(data.date)
        }
        this.testDateRace(data.date,data.dateTxt)

    }
    else {
        if(data.immediate==true){
          var date=new Date();
          var dateTxt=((date.getDate()<10)?"0":"")+date.getDate()+"/"+((date.getMonth()<9)?"0":"")+(date.getMonth()+1)+"/"+date.getFullYear()+" - "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()
          this.setState({immediate:true,date:dateTxt ,integerDate:Date.parse(date)},() =>{this.calculateMajoration()} ) 
        }
        else { this.setState({immediate:false,integerDate:data.date ,date:data.dateTxt },() =>{this.calculateMajoration()})}
    }
  
  	


  }

  contactUs= data => {
    console.log("contact us lancé")
    this.closeControlPanel("Contact")

  }
  


  distance(lat1, lon1, lat2, lon2, unit) {
	    if(lat1==lat2 && lon1==lon2) return 0
	    else {

	      var radlat1 = Math.PI * lat1/180
	      var radlat2 = Math.PI * lat2/180
	      var theta = lon1-lon2
	      var radtheta = Math.PI * theta/180
	      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
	      dist = Math.acos(dist)
	      dist = dist * 180/Math.PI
	      dist = dist * 60 * 1.1515
	      if (unit=="K") { dist = dist * 1.609344 }
	      if (unit=="N") { dist = dist * 0.8684 }

	      return dist

	    }
    
  }


  testForfait(forfait){

      var stop=false;
      var result;
      var i=0;
      while(stop==false && i<forfait.length){

        var dist=this.distance(forfait[i].startLatitude,forfait[i].startLongitude,this.state.mapFrom.coordinates.latitude,this.state.mapFrom.coordinates.longitude,"K");
        var dist2=this.distance(forfait[i].endLatitude,forfait[i].endLongitude,this.state.mapFrom.coordinates.latitude,this.state.mapFrom.coordinates.longitude,"K");
        var poly=false;
        var poly2=false;
        if(forfait[i].startZoneDrawed==true) {
          poly=this.testCoordinateInPolygon([this.state.mapFrom.coordinates.latitude,this.state.mapFrom.coordinates.longitude],forfait[i].startZone ) 
        }
        if(forfait[i].goReturn==true && forfait[i].endZoneDrawed==true) poly2=this.testCoordinateInPolygon([this.state.mapFrom.coordinates.latitude,this.state.mapFrom.coordinates.longitude],forfait[i].endZone ) 
       
        if( ( ( forfait[i].startZoneDrawed==true || forfait[i].endZoneDrawed==true ) && (poly==true || poly2==true ) ) || (forfait[i].startZoneDrawed!=true && dist<forfait[i].startRadius ) || (forfait[i].endZoneDrawed!=true && forfait[i].goReturn==true && dist2<forfait[i].endRadius)   ){
          var whoseUsed=(poly==true || (forfait[i].startZoneDrawed!=true && dist<forfait[i].startRadius ) )?"start":"end"
          dist=this.distance(forfait[i].endLatitude,forfait[i].endLongitude,this.state.mapTo.coordinates.latitude,this.state.mapTo.coordinates.longitude,"K");
          dist2=this.distance(forfait[i].startLatitude,forfait[i].startLongitude,this.state.mapTo.coordinates.latitude,this.state.mapTo.coordinates.longitude,"K");

          poly=false;
          poly2=false;

          if(forfait[i].endZoneDrawed==true) {
            poly=this.testCoordinateInPolygon([this.state.mapTo.coordinates.latitude,this.state.mapTo.coordinates.longitude],forfait[i].endZone )
          }
          if(forfait[i].goReturn==true && forfait[i].startZoneDrawed==true) poly2=this.testCoordinateInPolygon([this.state.mapTo.coordinates.latitude,this.state.mapTo.coordinates.longitude],forfait[i].startZone ) 
          
          var hourValidity=true; 
          if(forfait[i].validityFrom!=undefined){
            if(this.state.date!=""){
              var d2=new Date(this.state.integerDate);
              var hour=d2.getHours()*60+d2.getMinutes();
              var hourFrom=(parseInt(forfait[i].validityFrom[0]+forfait[i].validityFrom[1]))*60+parseInt(forfait[i].validityFrom[3]+forfait[i].validityFrom[4])
              var hourTo=(parseInt(forfait[i].validityTo[0]+forfait[i].validityTo[1]))*60+parseInt(forfait[i].validityTo[3]+forfait[i].validityTo[4])
              if (!(  (hourFrom<hourTo  &&  hour>hourFrom && hour<hourTo) || (hourFrom>hourTo  && (hour>hourFrom || hour<hourTo) ) ) ) hourValidity=false;
            }
          }

        


          if((( ( forfait[i].startZoneDrawed==true || forfait[i].endZoneDrawed==true ) && ( (poly==true && whoseUsed=="start")  || ( poly2==true && whoseUsed=="end") ) ) || (forfait[i].endZoneDrawed!=true && dist<forfait[i].endRadius && whoseUsed=="start") || (forfait[i].goReturn==true && whoseUsed=="end" && forfait[i].startZoneDrawed!=true && dist2<forfait[i].startRadius)  ) && hourValidity==true){ stop=true;result=forfait[i];}

        }
        i++;
      }
      
      
      return {stop:stop,result:result}

  }

  testClassic(classic){
      var stop=false;
      var result;
      var noZone="";
      var i=0;

      while(stop==false && i<classic.length){
        var dist=this.distance(classic[i].latitude,classic[i].longitude,this.state.mapFrom.coordinates.latitude,this.state.mapFrom.coordinates.longitude,"K");
        var poly=false;

        if(classic[i].zoneDrawed==true) poly=this.testCoordinateInPolygon([this.state.mapFrom.coordinates.latitude,this.state.mapFrom.coordinates.longitude],classic[i].zone )
        
        var hourValidity=true; 
        if(classic[i].validityFrom!=undefined){
            if(this.state.date!=""){
              var d2=new Date(this.state.integerDate);
              var hour=d2.getHours()*60+d2.getMinutes();
              var hourFrom=(parseInt(classic[i].validityFrom[0]+classic[i].validityFrom[1]))*60+parseInt(classic[i].validityFrom[3]+classic[i].validityFrom[4])
              var hourTo=(parseInt(classic[i].validityTo[0]+classic[i].validityTo[1]))*60+parseInt(classic[i].validityTo[3]+classic[i].validityTo[4])
              if (!(  (hourFrom<hourTo  &&  hour>hourFrom && hour<hourTo) || (hourFrom>hourTo  && (hour>hourFrom || hour<hourTo) ) ) ) hourValidity=false;
            }
          }


        if( ((dist<classic[i].radius && classic[i].zoneDrawed!=true)  || poly==true) && hourValidity==true){
          stop=true;
          noZone=classic[i].id;
          result=classic[i];
          }
        i++;
      }
      return {stop:stop,result:result,noZone:noZone}
  }


  getZoneForfait(){

          var stop=false;
          var stopBis=false;
          var stopCusto=false;
          var noZone="";
          var result;
          var resultBis;
          var resultCusto;

          if(this.state.forfait!=undefined && this.state.mapIntermediate.length==0){ var res=this.testForfait(this.state.forfait); stop=res.stop; result=res.result;  }

          if(this.state.classic!=undefined){ 
            var res=this.testClassic(this.state.classic);
            if(res.stop==true && stop==false) {stop=true; result=res.result;  }
            if(res.stop==true) noZone=res.noZone;

          }



          this.setState({noZone:noZone})

          if(this.state.forfaitDriver!=undefined && this.state.forfaitDriver.length>0 && this.state.mapIntermediate.length==0) { var res=this.testForfait(this.state.forfaitDriver); stopCusto=res.stop; resultCusto=res.result}

          if(this.state.classicDriver!=undefined){
            var res=this.testClassic(this.state.classicDriver);

            if(res.stop==true && stopBis==false) {stopBis=true; resultBis=res.result;}
          }

          if(stopBis==true){result=resultBis; stop=true};

          

          if(this.state.forfaitCustomer!=undefined && this.state.forfaitCustomer.length>0 && this.state.mapIntermediate.length==0) { var res=this.testForfait(this.state.forfaitCustomer); stopCusto=res.stop; resultCusto=res.result}

          if(this.state.classicCustomer!=undefined){
            var res=this.testClassic(this.state.classicCustomer);

            if(res.stop==true && stopCusto==false) {stopCusto=true; resultCusto=res.result;}
          }

          if(stopCusto==true){result=resultCusto; stop=true};


          return {result:result, stop:stop}


  }

  getZoneForfaitTaxi(){
          var stopTaxi=false;
          var resultTaxi;
          var noZoneTaxi="";

          if(this.state.taxiMode==true){

            if(this.state.forfaitTaxi!=undefined && this.state.mapIntermediate.length==0){ var res=this.testForfait(this.state.forfaitTaxi); stopTaxi=res.stop; resultTaxi=res.result; }
            if(this.state.classicTaxi!=undefined){ 
            var res=this.testClassic(this.state.classicTaxi);

            if(res.stop==true && stopTaxi==false) {stopTaxi=true; resultTaxi=res.result }
            if(res.stop==true) {noZoneTaxi=res.noZone; this.setState({noZoneTaxi:noZoneTaxi})}


            }

          }

          return {stop:stopTaxi, result:resultTaxi}
  }


  drawRoute= () => {
    console.log("j'appelle drawroute")
      //On vérifie que le point de départ, se situe dans une bonne zone géographique
      if(this.state.mapFrom.description!='' && this.state.mapTo.description!=''){
          //Je commence par regarder les forfaits  
          var i=0;

          var getZoneForfait=this.getZoneForfait()
          var stop=getZoneForfait.stop;
          var result=getZoneForfait.result;

          

          var getZoneForfaitTaxi=this.getZoneForfaitTaxi()
          var stopTaxi=getZoneForfaitTaxi.stop;
          var resultTaxi=getZoneForfaitTaxi.result;

          


          if(stop==false && stopTaxi==false){ 
            if(this.state.dispenser.enabled==true){
              if(this.alert!=undefined) this.alert.onAlert({title:strings.noDriverService,maxiMode:this.state.dispenser.enabled}); 
              this.setState({waitDispenserResult:false})

            }
            else if(this.state.driver==false && this.state.partner==false && this.alert!=undefined) this.alert.onAlert({title:strings.noDriverService,buttons:[
              {text: strings.ok,onPress: () => { } }, {text: strings.contactUs,onPress: () => { this.closeControlPanel("Contact") } }  ] }); 
            else if(this.state.viewAdminMode!=true && this.alert!=undefined) this.alert.onAlert({title:strings.noDriverService});  
            this.setState({priceEstimation:"",priceEstimationTaxi:"", estimatePriceGo:"", estimatePriceGoTaxi:""}) 
          }
          else {
            var fetchURLparams={origin:this.state.mapFrom.coordinates.latitude.toFixed(4) +',' +this.state.mapFrom.coordinates.longitude.toFixed(4) ,key: info.googleMapsKey,destination:this.state.mapTo.coordinates.latitude.toFixed(4) +',' +this.state.mapTo.coordinates.longitude.toFixed(4)}
            if(this.state.takingTraffic===true && this.state.immediateModeOrder===true) fetchURLparams["departure_time"]="now"
            else {fetchURLparams.type="directions"; fetchURLparams.minimizeRequest=true}

            if(this.state.mapIntermediate.length>0){
              fetchURLparams["waypoints"]=this.state.mapIntermediate[0].description;
              var iWay;
              for(iWay=1; iWay<this.state.mapIntermediate.length ; iWay++){
                  fetchURLparams["waypoints"]+=("|"+this.state.mapIntermediate[iWay].description)
              }
              
            }

            if(this.state.bicycling==true)  fetchURLparams.mode="bicycling";
            var fetchURL=Qs.stringify(fetchURLparams)
            var getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(fetchURLparams),method: "POST"});
            
            if(fetchURLparams["departure_time"]!=undefined){
              if(Platform.OS=="web"){
                var body={paramsRqs:fetchURL, type:"directions" }
                getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(body),method: "POST"})
              }
              else getDir=fetch('https://maps.googleapis.com/maps/api/directions/json?'+fetchURL) 
            }
          console.log(fetchURLparams)

            console.log("je lance du maps.googleapis")
            getDir.then(response => response.json()).then(responseJson => {
                    if(typeof(responseJson)!="object") responseJson=JSON.parse(responseJson);

                    if (responseJson.status == 'ZERO_RESULTS') {
                      if(this.state.viewAdminMode!=true && this.alert!=undefined) this.alert.onAlert({title:strings.noWayWasFound, maxiMode:this.state.dispenser.enabled});
                      this.setState({priceEstimation:"",priceEstimationTaxi:"", estimatePriceGo:"", estimatePriceGoTaxi:""}) 
                      if(this.state.dispenser.enabled==true) this.setState({waitDispenserResult:false})
                    }
                    else if (responseJson.routes.length) {
                      
                      var mapRegion={}
                      mapRegion.latitude=this.state.mapFrom.coordinates.latitude+((this.state.mapTo.coordinates.latitude-this.state.mapFrom.coordinates.latitude)/2);
                      mapRegion.longitude=this.state.mapFrom.coordinates.longitude+((this.state.mapTo.coordinates.longitude-this.state.mapFrom.coordinates.longitude)/2);
                      mapRegion.latitudeDelta=Math.abs(this.state.mapTo.coordinates.latitude-this.state.mapFrom.coordinates.latitude)*3+0.05;
                      mapRegion.longitudeDelta=Math.abs(this.state.mapTo.coordinates.longitude-this.state.mapFrom.coordinates.longitude)*3+0.05;


                      var infoTrajet=responseJson.routes[0].legs;
                      var timeEstimation=0;
                      var durationInTraffic=0; 
                      var kmEstimation=0; 
                      var stopList=[]; 

                      var iLegs;
                      for(iLegs=0; iLegs<infoTrajet.length;iLegs++){
                        timeEstimation+=infoTrajet[iLegs].duration.value
                        durationInTraffic+=((infoTrajet[iLegs]["duration_in_traffic"]!=undefined)?infoTrajet[iLegs]["duration_in_traffic"].value:infoTrajet[iLegs].duration.value)
                        kmEstimation+=infoTrajet[iLegs].distance.value
                        if(iLegs>0 && iLegs<infoTrajet.length) stopList.push(infoTrajet[iLegs]["start_address"])
                      }

                      kmEstimation=(kmEstimation/1000);

                      
                      

                      this.setState({
                        coords: this.decode(responseJson.routes[0].overview_polyline.points ),
                        mapRegion:mapRegion,
                        startAddress:(this.state.mapFrom.descriptionPosition!=true && this.state.mapFrom.description!=strings.myPosition )?this.state.mapFrom.description:infoTrajet[0]["start_address"],
                        stLat:infoTrajet[0]["start_location"].lat,
                        stLng:infoTrajet[0]["start_location"].lng,
                        endAddress:(this.state.mapTo.descriptionPosition!=true && this.state.mapTo.description!=strings.myPosition )?this.state.mapTo.description:infoTrajet[infoTrajet.length-1]["end_address"],
                        endLat:infoTrajet[infoTrajet.length-1]["end_location"].lat,
                        endLng:infoTrajet[infoTrajet.length-1]["end_location"].lng,
                        stopList:stopList,
                        timeEstimation:timeEstimation,
                        timeEstimationWithTrafic:durationInTraffic,
                        kmEstimation: kmEstimation.toFixed(1) +" km",
                      },() =>{this.updateDriverPricing(result); this.updateDriverPricingTaxi(resultTaxi) })



                   }
                 }).catch((err) => { console.log("error drawRoute"); console.log(err); timer.setTimeout("drawRoute", () => { this.drawRoute();  }, 2000);   })
                }
              }

  }


  updateDriverPricing(result){
    console.log("updateDriverPricing")

    if(result!=undefined){
        console.log("j'ai un résultat pour les vtc")


        var price=new Array;
        var priceEstimationWithTrafic=new Array;
        var i=0;
        var explicationPricing;


        var objPrice=Object.keys(result.price);
        var km=parseFloat(this.state.kmEstimation)
        var timeEstimation=this.state.timeEstimation; 
        
        for(i=0;i<objPrice.length;i++){

          

          if( this.state.driver==true || this.state.partner==true || this.state.vipMode==false || result.price[objPrice[i]].target==undefined || (result.price[objPrice[i]].target.pro!=false && this.state.customerPro==true) || (result.price[objPrice[i]].target.vip!=false && this.state.vip==true) || (result.price[objPrice[i]].target.standard!=false && this.state.customerPro!=true && this.state.vip!=true)    ){

            if(result.type=="classic"){
              
                explicationPricing={type:"classic",validityFrom:result.validityFrom, validityTo:result.validityTo, tarifName:result.name, minPrice:result.price[objPrice[i]].minPrice,base:result.price[objPrice[i]].base,distance:(km).toFixed(2),pricingDistance:result.price[objPrice[i]].km,duration:(timeEstimation /60).toFixed(2), pricingDuration:result.price[objPrice[i]].minute   }

                var pr =result.price[objPrice[i]].base +km *result.price[objPrice[i]].km +timeEstimation /60 *result.price[objPrice[i]].minute;
                
                
                var prT=result.price[objPrice[i]].base +km *result.price[objPrice[i]].km + this.state.timeEstimationWithTrafic /60 *result.price[objPrice[i]].minute;
                
                

                

                var oldPr=pr;
                if(km>0 && km<26 && this.state.majoration.zeroTwentyFive!=undefined) { pr=pr*this.state.majoration.zeroTwentyFive; prT=prT*this.state.majoration.zeroTwentyFive; explicationPricing.kilometerMajoration={type:"zeroTwentyFive",price:(pr-oldPr), majoration:this.state.majoration.zeroTwentyFive };}
                else if(km>25 && km<51 && this.state.majoration.twentyFiveFifty!=undefined) { pr=pr*this.state.majoration.twentyFiveFifty; prT=prT*this.state.majoration.twentyFiveFifty; explicationPricing.kilometerMajoration={type:"zeroTwentyFive",price:(pr-oldPr), majoration:this.state.majoration.twentyFiveFifty };}
                else if(km>50 && km<101 && this.state.majoration.fiftyOneHundred!=undefined) { pr=pr*this.state.majoration.fiftyOneHundred; prT=prT*this.state.majoration.fiftyOneHundred; explicationPricing.kilometerMajoration={type:"fiftyOneHundred",price:(pr-oldPr), majoration:this.state.majoration.fiftyOneHundred };}
               
                else if(km>100 && km<151 && this.state.majoration.oneHundredFifty!=undefined) {pr=pr*this.state.majoration.oneHundredFifty; prT=prT*this.state.majoration.oneHundredFifty; explicationPricing.kilometerMajoration={type:"oneHundredFifty",price:(pr-oldPr), majoration:this.state.majoration.oneHundredFifty }  }
                else if(km>150 && km<201 && this.state.majoration.oneHundredTwoHundred!=undefined) {pr=pr*this.state.majoration.oneHundredTwoHundred; prT=prT*this.state.majoration.oneHundredTwoHundred; explicationPricing.kilometerMajoration={type:"oneHundredTwoHundred",price:(pr-oldPr), majoration:this.state.majoration.oneHundredTwoHundred }  }
                else if (km>200 && km<251 && this.state.majoration.twoHundredFifty!=undefined) {pr=pr*this.state.majoration.twoHundredFifty; prT=prT*this.state.majoration.twoHundredFifty;explicationPricing.kilometerMajoration={type:"twoHundredFifty",price:(pr-oldPr), majoration:this.state.majoration.twoHundredFifty }  }
                
                else if (km>250 && km<301 && this.state.majoration.twoHundredThreeHundred!=undefined) {pr=pr*this.state.majoration.twoHundredThreeHundred; prT=prT*this.state.majoration.twoHundredThreeHundred;explicationPricing.kilometerMajoration={type:"twoHundredThreeHundred",price:(pr-oldPr), majoration:this.state.majoration.twoHundredThreeHundred }  }
                else if (km>300 && this.state.majoration.moreThreeHundred!=undefined) {pr=pr*this.state.majoration.moreThreeHundred; prT=prT*this.state.majoration.moreThreeHundred; explicationPricing.kilometerMajoration={type:"moreThreeHundred",price:(pr-oldPr), majoration:this.state.majoration.moreThreeHundred } }
                

                var precision=(this.state.pricingPrecise===true)?100:1;

               
                if(typeof trancheKM !== 'undefined'){
                  var iTranche=0;
                  var finish=false;

                  for(iTranche=0;iTranche<trancheKM.length;iTranche++){
                      if(km<trancheKM[iTranche].to && finish==false){pr=trancheKM[iTranche].price;finish=true;}
                  }

                }
                
                



                if(Math.round(info.priceCoeffMin * pr)>result.price[objPrice[i]].minPrice){
                  if(info.priceCoeffMin!=info.priceCoeffMax) pr=(Math.round(info.priceCoeffMin * pr*precision)/precision)+"-"+(Math.round(info.priceCoeffMax * pr*precision)/precision);
                  else pr=(Math.round(info.priceCoeffMin * pr*precision)/precision);
                }
                else {pr=result.price[objPrice[i]].minPrice}


                if(Math.round(info.priceCoeffMin * prT)>result.price[objPrice[i]].minPrice){
                  if(info.priceCoeffMin!=info.priceCoeffMax) prT=(Math.round(info.priceCoeffMin * prT*precision)/precision)+"-"+(Math.round(info.priceCoeffMax * prT*precision)/precision);
                  else prT=(Math.round(info.priceCoeffMin * prT*precision)/precision);
                }

                else {prT=result.price[objPrice[i]].minPrice }

                if(this.state.noVAT==true) {

                  pr/=(1+info.tvaPercentClassic/100)
                  prT/=(1+info.tvaPercentClassic/100)
                }

                var raceInformation={price:pr,name:result.price[objPrice[i]].name,majoration:result.majoration,explicationPricing:explicationPricing  }
                var raceInformationWithTrafic={price:prT,name:result.price[objPrice[i]].name,majoration:result.majoration }

                if(result.price[objPrice[i]].passagers!=undefined) {raceInformation.passagers=result.price[objPrice[i]].passagers; raceInformationWithTrafic.passagers=result.price[objPrice[i]].passagers}
                if(result.price[objPrice[i]].passagersMin!=undefined) {raceInformation.passagersMin=result.price[objPrice[i]].passagersMin; raceInformationWithTrafic.passagersMin=result.price[objPrice[i]].passagers}
                
                if(result.price[objPrice[i]].co2!=undefined) {raceInformation.co2=parseInt(result.price[objPrice[i]].co2*km) ; raceInformationWithTrafic.co2=parseInt(result.price[objPrice[i]].co2*km)}
                if(result.price[objPrice[i]].provCom!=undefined && this.state.provider==true && this.state.providerFixeCommission==true) {  raceInformation.provCom=parseInt(result.price[objPrice[i]].provCom) ; raceInformationWithTrafic.co2=parseInt(result.price[objPrice[i]].provCom)}
          
                if(result.price[objPrice[i]].luggageMax!=undefined) {raceInformation.luggageMax=result.price[objPrice[i]].luggageMax; raceInformationWithTrafic.luggageMax=result.price[objPrice[i]].luggageMax}

                price.push(raceInformation)
                priceEstimationWithTrafic.push(raceInformationWithTrafic)



                
            } else{
              var pr =result.price[objPrice[i]].base;
              var prT=result.price[objPrice[i]].base;

              if(this.state.noVAT==true) {

                  pr/=(1+info.tvaPercentClassic/100)
                  prT/=(1+info.tvaPercentClassic/100)
                }

              explicationPricing={type:"forfait",validityFrom:result.validityFrom, validityTo:result.validityTo,tarifName:result.startName+( (result.goReturn==true)?" < > ":" > ")+result.endName,base:result.price[objPrice[i]].base}
              
              var raceInformation={explicationPricing:explicationPricing,price:pr,name:result.price[objPrice[i]].name,majoration:result.majoration }
              var raceInformationWithTrafic={price:pr,name:result.price[objPrice[i]].name,majoration:result.majoration }
              if(result.price[objPrice[i]].passagers!=undefined) {raceInformation.passagers=result.price[objPrice[i]].passagers; raceInformationWithTrafic.passagers=result.price[objPrice[i]].passagers}
              if(result.price[objPrice[i]].passagersMin!=undefined) {raceInformation.passagersMin=result.price[objPrice[i]].passagersMin; raceInformationWithTrafic.passagersMin=result.price[objPrice[i]].passagersMin}
              if(result.price[objPrice[i]].co2!=undefined) {  raceInformation.co2=parseInt(result.price[objPrice[i]].co2*km) ; raceInformationWithTrafic.co2=parseInt(result.price[objPrice[i]].co2*km)}
              if(result.price[objPrice[i]].provCom!=undefined && this.state.provider==true && this.state.providerFixeCommission==true) {  raceInformation.provCom=parseInt(result.price[objPrice[i]].provCom) ; raceInformationWithTrafic.co2=parseInt(result.price[objPrice[i]].provCom)}
          
              if(result.price[objPrice[i]].luggageMax!=undefined) {raceInformation.luggageMax=result.price[objPrice[i]].luggageMax; raceInformationWithTrafic.luggageMax=result.price[objPrice[i]].luggageMax}

              price.push(raceInformation)
              priceEstimationWithTrafic.push(raceInformationWithTrafic)
              
              
            }

        }

          
        }

        if(this.state.extraEUMode==true){
            var infoMoney=this.findMoney((result.price[objPrice[0]].moneyID!=undefined)?result.price[objPrice[0]].moneyID:"eu"); 
            this.setState({money:infoMoney})
        }
        this.setState({
            priceEstimation: price,
            priceEstimationWithTrafic:priceEstimationWithTrafic,
            selected:0,
          },() =>{ if(this.state.date!="") this.calculateMajoration() ; if(this.state.dispenser.enabled==true) {this.selectDate();this.setState({waitDispenserResult:false})}    })

    }
    else this.setState({priceEstimation:"", priceEstimationWithTrafic:"",estimatePriceGo:"", waitDispenserResult:false})

  }


  updateDriverPricingTaxi(resultTaxi){
    console.log("updateDriverPricingTaxi")
    if(resultTaxi!=undefined){
        console.log("j'ai un résultat pour les taxis")

        var objPrice=Object.keys(resultTaxi.price);
        var priceTaxi=new Array;
        var priceEstimationWithTraficTaxi=new Array;

        var kmEstimation=parseFloat(this.state.kmEstimation)
        var timeEstimation=this.state.timeEstimation;
        var explicationPricing;
        if(resultTaxi.type=="forfait"){
                var i; 
                for(i=0;i<objPrice.length;i++){

                  if( this.state.driver==true || this.state.partner==true || this.state.vipMode==false || resultTaxi.price[objPrice[i]].target==undefined || (resultTaxi.price[objPrice[i]].target.pro!=false && this.state.customerPro==true) || (resultTaxi.price[objPrice[i]].target.vip!=false && this.state.vip==true) || (resultTaxi.price[objPrice[i]].target.standard!=false && this.state.customerPro!=true && this.state.vip!=true)    ){

                
                      var pr =resultTaxi.price[objPrice[i]].base;
                      var prT=resultTaxi.price[objPrice[i]].base;

                      if(this.state.noVAT==true) {
                          pr/=(1+info.tvaPercentClassic/100)
                          prT/=(1+info.tvaPercentClassic/100)
                      }

                      explicationPricing={type:"forfait",validityFrom:resultTaxi.validityFrom, validityTo:resultTaxi.validityTo,taxiMode:true,tarifName:resultTaxi.startName+( (resultTaxi.goReturn==true)?" < > ":" > ")+resultTaxi.endName,base:resultTaxi.price[objPrice[i]].base, duration:(timeEstimation /60).toFixed(2)}
                      if(resultTaxi.tarifBDFrom!=undefined) {
                        explicationPricing.tarifBDFrom=resultTaxi.tarifBDFrom
                        explicationPricing.tarifBDTo=resultTaxi.tarifBDTo
                        explicationPricing.tarifBDSaturday=resultTaxi.tarifBDSaturday;
                        explicationPricing.tarifBDSunday=resultTaxi.tarifBDSunday;
                        explicationPricing.tarifBDFerie=resultTaxi.tarifBDFerie;
                       } 

                      var raceInformation={taxiMode:true,explicationPricing:explicationPricing,price:pr,name:resultTaxi.price[objPrice[i]].name }
                      var raceInformationWithTrafic={taxiMode:true,price:pr,name:resultTaxi.price[objPrice[i]].name }
                      
                      if(resultTaxi.price[objPrice[i]].cpam==true) {raceInformation.cpam=true}
                      

                      if(resultTaxi.price[objPrice[i]].passagers!=undefined) {raceInformation.passagers=resultTaxi.price[objPrice[i]].passagers; raceInformationWithTrafic.passagers=resultTaxi.price[objPrice[i]].passagers}
                      if(resultTaxi.price[objPrice[i]].passagersMin!=undefined) {raceInformation.passagersMin=resultTaxi.price[objPrice[i]].passagersMin; raceInformationWithTrafic.passagersMin=resultTaxi.price[objPrice[i]].passagersMin}
                      if(resultTaxi.price[objPrice[i]].co2!=undefined) {raceInformation.co2=parseInt(resultTaxi.price[objPrice[i]].co2*kmEstimation) ; raceInformationWithTrafic.co2=parseInt(resultTaxi.price[objPrice[i]].co2*kmEstimation)}
                      if(resultTaxi.price[objPrice[i]].provCom!=undefined && this.state.provider==true && this.state.providerFixeCommission==true) {  raceInformation.provCom=parseInt(resultTaxi.price[objPrice[i]].provCom) ; raceInformationWithTrafic.co2=parseInt(resultTaxi.price[objPrice[i]].provCom)}
          
                      if(resultTaxi.price[objPrice[i]].luggageMax!=undefined) {raceInformation.luggageMax=resultTaxi.price[objPrice[i]].luggageMax; raceInformationWithTrafic.luggageMax=resultTaxi.price[objPrice[i]].luggageMax}

                      if(resultTaxi.tarifBDFrom!=undefined) raceInformation.priceMajo=resultTaxi.price[objPrice[i]].baseMajo;
                        
                      

                      priceTaxi.push(raceInformation)
                      priceEstimationWithTraficTaxi.push(raceInformationWithTrafic)

                    }
                }

                if(this.state.extraEUMode==true){
                  var infoMoney=this.findMoney((resultTaxi.price[objPrice[0]].moneyID!=undefined)?resultTaxi.price[objPrice[0]].moneyID:"eu"); 
                  this.setState({moneyTaxi:infoMoney})
                }

               

                this.setState({
                      priceEstimationTaxi: priceTaxi,
                      priceEstimationWithTraficTaxi:priceEstimationWithTraficTaxi,
                      selected:0,
                    },() =>{ if(this.state.date!="") this.calculateMajoration(); if(this.state.dispenser.enabled==true && this.state.priceEstimation=="") {this.selectDate();this.setState({waitDispenserResult:false})}     })

            }

        else {

            var fetchURLTaxiParams={type:"directions", minimizeRequest:true, origin:resultTaxi.name  ,key: info.googleMapsKey,destination:this.state.mapFrom.coordinates.latitude.toFixed(4) +',' +this.state.mapFrom.coordinates.longitude.toFixed(4)}

            var fetchURLTaxi=Qs.stringify(fetchURLTaxiParams)
            var body={paramsRqs:fetchURLTaxi, type:"directions" }
            var getDirTaxi=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(fetchURLTaxiParams),method: "POST"});

            /*if(Platform.OS=="web"){
              var body={paramsRqs:fetchURLTaxi, type:"directions" }
              getDirTaxi=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(body),method: "POST"})
            /*}
            else getDirTaxi=fetch('https://maps.googleapis.com/maps/api/directions/json?'+fetchURLTaxi) */ 
              console.log("je lance du maps.googleapis")
            getDirTaxi.then(response => response.json()).then(responseJsonBorneToStart => {
                  if(typeof(responseJsonBorneToStart)!="object") responseJsonBorneToStart=JSON.parse(responseJsonBorneToStart);
                  var durationToClient=(responseJsonBorneToStart.routes[0].legs[0].distance.value /1000).toFixed(2)
                  
                  for(i=0;i<objPrice.length;i++){

                    if( this.state.driver==true || this.state.partner==true || this.state.vipMode==false || resultTaxi.price[objPrice[i]].target==undefined || (resultTaxi.price[objPrice[i]].target.pro!=false && this.state.customerPro==true) || (resultTaxi.price[objPrice[i]].target.vip!=false && this.state.vip==true) || (resultTaxi.price[objPrice[i]].target.standard!=false && this.state.customerPro!=true && this.state.vip!=true)    ){

                        explicationPricing={type:"classic",validityFrom:resultTaxi.validityFrom, validityTo:resultTaxi.validityTo,taxiMode:true, tarifName:resultTaxi.name, minPrice:resultTaxi.price[objPrice[i]].minPrice, base:resultTaxi.price[objPrice[i]].base,  coeffEnable:resultTaxi.coeffEnable,coeffPercent:resultTaxi.coeffPercent,tarifBDFrom:resultTaxi.tarifBDFrom,tarifBDTo:resultTaxi.tarifBDTo,tarifBDSaturday:resultTaxi.tarifBDSaturday,tarifBDSunday:resultTaxi.tarifBDSunday,tarifBDFerie:resultTaxi.tarifBDFerie,tarifA:resultTaxi.price[objPrice[i]].tarifA,tarifB:resultTaxi.price[objPrice[i]].tarifB,tarifC:resultTaxi.price[objPrice[i]].tarifC,tarifD:resultTaxi.price[objPrice[i]].tarifD,majoTaxiImmediate:resultTaxi.price[objPrice[i]].majoTaxiImmediate,majoTaxiAvance:resultTaxi.price[objPrice[i]].majoTaxiAvance,    distance:(kmEstimation).toFixed(2),duration:(timeEstimation /60).toFixed(2), durationToClient:durationToClient   }
                        
                        var priceA=resultTaxi.price[objPrice[i]].base+durationToClient * resultTaxi.price[objPrice[i]].tarifA +(2*(kmEstimation).toFixed(2) ) * resultTaxi.price[objPrice[i]].tarifA
                        var priceB=resultTaxi.price[objPrice[i]].base+durationToClient * resultTaxi.price[objPrice[i]].tarifA +(2*(kmEstimation).toFixed(2) ) * resultTaxi.price[objPrice[i]].tarifB
                        var priceC=resultTaxi.price[objPrice[i]].base+durationToClient * resultTaxi.price[objPrice[i]].tarifA +((kmEstimation).toFixed(2) ) * resultTaxi.price[objPrice[i]].tarifC
                        var priceD=resultTaxi.price[objPrice[i]].base+durationToClient * resultTaxi.price[objPrice[i]].tarifA +((kmEstimation).toFixed(2) ) * resultTaxi.price[objPrice[i]].tarifD
                        
                        if(this.state.noVAT==true) {
                          priceA/=(1+info.tvaPercentClassic/100)
                          priceB/=(1+info.tvaPercentClassic/100)
                          priceC/=(1+info.tvaPercentClassic/100)
                          priceD/=(1+info.tvaPercentClassic/100)
                        }

                        var raceInformation={priceA:priceA,priceB:priceB, priceC:priceC, priceD:priceD,name:resultTaxi.price[objPrice[i]].name,explicationPricing:explicationPricing  }
                        var raceInformationWithTrafic={priceA:priceA,priceB:priceB, priceC:priceC, priceD:priceD,name:resultTaxi.price[objPrice[i]].name,explicationPricing:explicationPricing  }
                        
                        if(resultTaxi.price[objPrice[i]].cpam==true) {raceInformation.cpam=true}
                        if(resultTaxi.price[objPrice[i]].passagers!=undefined) {raceInformation.passagers=resultTaxi.price[objPrice[i]].passagers; raceInformationWithTrafic.passagers=resultTaxi.price[objPrice[i]].passagers}
                        if(resultTaxi.price[objPrice[i]].passagersMin!=undefined) {raceInformation.passagersMin=resultTaxi.price[objPrice[i]].passagersMin; raceInformationWithTrafic.passagersMin=resultTaxi.price[objPrice[i]].passagersMin}
                        if(resultTaxi.price[objPrice[i]].co2!=undefined) {raceInformation.co2=parseInt(resultTaxi.price[objPrice[i]].co2*kmEstimation) ; raceInformationWithTrafic.co2=parseInt(resultTaxi.price[objPrice[i]].co2*kmEstimation)}
                        if(resultTaxi.price[objPrice[i]].provCom!=undefined && this.state.provider==true && this.state.providerFixeCommission==true) {  raceInformation.provCom=parseInt(resultTaxi.price[objPrice[i]].provCom) ; raceInformationWithTrafic.co2=parseInt(resultTaxi.price[objPrice[i]].provCom)}
      
                        if(resultTaxi.price[objPrice[i]].luggageMax!=undefined) {raceInformation.luggageMax=resultTaxi.price[objPrice[i]].luggageMax; raceInformationWithTrafic.luggageMax=resultTaxi.price[objPrice[i]].luggageMax}

                        priceTaxi.push(raceInformation)
                        priceEstimationWithTraficTaxi.push(raceInformationWithTrafic)
                      }

                  }

                  if(this.state.extraEUMode==true){
                        infoMoney=this.findMoney((resultTaxi.price[objPrice[0]].moneyID!=undefined)?resultTaxi.price[objPrice[0]].moneyID:"eu"); 
                        this.setState({moneyTaxi:infoMoney})
                  }

                   

                  this.setState({
                        priceEstimationTaxi: priceTaxi,
                        priceEstimationWithTraficTaxi:priceEstimationWithTraficTaxi,
                        selected:0,
                      },() =>{ if(this.state.date!="") this.calculateMajoration() ;     })


              }).catch((err) => { console.log("error updateDriverPricingTaxi"); console.log(err); timer.setTimeout("updateDriverPricingTaxi", () => { this.updateDriverPricingTaxi(resultTaxi)  }, 2000);   })

          }


          

        }
      else this.setState({priceEstimationTaxi:"", priceEstimationWithTraficTaxi:"",estimatePriceGoTaxi:""})

  }










  calculateMajoration(){
    console.log("je lance calculateMajoration")
    var precision=(this.state.pricingPrecise===true)?100:1;
    console.log("priceEstimation =")
    console.log(this.state.priceEstimation)
    var stop=false;
    var errorHourValidity=false; 
    var errorHourValidityTaxi=false; 


    if(this.state.priceEstimation!="" && this.state.date!=""){

      var list=this.state.priceEstimation;

      if(list[0].explicationPricing.validityFrom!=undefined){
          

          
              var d2=new Date(this.state.integerDate);
              var hour=d2.getHours()*60+d2.getMinutes();
              var hourFrom=(parseInt(list[0].explicationPricing.validityFrom[0]+list[0].explicationPricing.validityFrom[1]))*60+parseInt(list[0].explicationPricing.validityFrom[3]+list[0].explicationPricing.validityFrom[4])
              var hourTo=(parseInt(list[0].explicationPricing.validityTo[0]+list[0].explicationPricing.validityTo[1]))*60+parseInt(list[0].explicationPricing.validityTo[3]+list[0].explicationPricing.validityTo[4])
              if (!(  (hourFrom<hourTo  &&  hour>hourFrom && hour<hourTo) || (hourFrom>hourTo  && (hour>hourFrom || hour<hourTo) ) ) ) {
                  /*le pricing est pas bon*/
                  /*je relance une demande*/
                  errorHourValidity=true;

                  var getZoneForfait=this.getZoneForfait()
                  stop=getZoneForfait.stop;
                  var result=getZoneForfait.result;

                  if(stop==true){
                    /*j'ai retrouvé un forfait ou une zone ok */
                    this.updateDriverPricing(result);
                  } else {
                      this.setState({estimatePriceGo:"",}) 
                      if(this.state.priceEstimationTaxi==""){
                          /*c'est mort y a pas rien à proposer*/
                          if(this.state.dispenser.enabled==true){
                              if(this.alert!=undefined) this.alert.onAlert({title:strings.noDriverService,maxiMode:this.state.dispenser.enabled}); 
                              this.setState({waitDispenserResult:false})

                            }
                            else if(this.state.driver==false && this.state.partner==false && this.alert!=undefined) this.alert.onAlert({title:strings.noDriverService,buttons:[
                              {text: strings.ok,onPress: () => { } }, {text: strings.contactUs,onPress: () => { this.closeControlPanel("Contact") } }  ] }); 
                            else if(this.state.viewAdminMode!=true && this.alert!=undefined) this.alert.onAlert({title:strings.noDriverService});  
                            
                      }


                  }

              }
      }
  

      if(errorHourValidity==false) for(let i=0;i<list.length;i++){

          var dateMajoration=this.majorationPrice( this.state.priceEstimation[i] );
          var totalMajoration={};
          var price=this.state.priceEstimation[i].price.toString();
          var n = price.indexOf("-");

          if(n!=-1) {
            totalMajoration.priceBasic1=parseFloat(price.substring(0,n))
            totalMajoration.priceBasic2=parseFloat(price.substring(n+1,price.length))

            if(this.state.immediate==true){
                var pWRT=this.state.priceEstimationWithTrafic[0].price;
                pWRT=pWRT.toString().replace(this.state.money.symbole,"")
                var nRT = pWRT.indexOf("-");
                var pwRT1=parseFloat(pWRT.substring(0,nRT))
                var pwRT2=parseFloat(pWRT.substring(nRT+1,pWRT.length))
                totalMajoration.majorationRealTime1=parseFloat(pwRT1)-totalMajoration.priceBasic1
                if(totalMajoration.majorationRealTime1<0) totalMajoration.majorationRealTime1=0;
                totalMajoration.majorationRealTime1=Math.round(totalMajoration.majorationRealTime1*precision)/precision
                totalMajoration.majorationRealTime2=parseFloat(pwRT2)-totalMajoration.priceBasic2
                if(totalMajoration.majorationRealTime2<0) totalMajoration.majorationRealTime2=0;
                totalMajoration.majorationRealTime2=Math.round(totalMajoration.majorationRealTime2*precision)/precision
                totalMajoration.majorationRealTime=(totalMajoration.majorationRealTime1!=0)?( (totalMajoration.majorationRealTime1!=totalMajoration.majorationRealTime2) ? (totalMajoration.majorationRealTime1+"-"+totalMajoration.majorationRealTime2):totalMajoration.majorationRealTime1 ):0

            } else {totalMajoration.majorationRealTime1=0; totalMajoration.majorationRealTime2=0; totalMajoration.majorationRealTime=0;}

            if(dateMajoration.majoMax>1){
              totalMajoration.majorationDate1={amount:(totalMajoration.priceBasic1+totalMajoration.majorationRealTime1)*(dateMajoration.majoMax-1), name:dateMajoration.majoName}
              totalMajoration.majorationDate1.amount=Math.round(totalMajoration.majorationDate1.amount*precision)/precision
              totalMajoration.majorationDate2={amount:(totalMajoration.priceBasic2+totalMajoration.majorationRealTime2)*(dateMajoration.majoMax-1), name:dateMajoration.majoName}
              totalMajoration.majorationDate2.amount=Math.round(totalMajoration.majorationDate2.amount*precision)/precision
              totalMajoration.majorationDate={amount:totalMajoration.majorationDate1.amount+"-"+totalMajoration.majorationDate2.amount, name:dateMajoration.majoName}

            }
            else {totalMajoration.majorationDate1={amount:0, name:""};totalMajoration.majorationDate2={amount:0, name:""};totalMajoration.majorationDate={amount:0, name:""};}

            totalMajoration.avanceOrder1=0;
            totalMajoration.lastMinute1=0;
            totalMajoration.avanceOrder2=0;
            totalMajoration.lastMinute2=0;

            if(this.state.immediate==true){
              var amt=0;
              var amt2=0;
              if(dateMajoration.majoLastPercent>1){
                amt=Math.round(totalMajoration.priceBasic1*(dateMajoration.majoLastPercent-1)*precision)/precision  
                amt2=Math.round(totalMajoration.priceBasic2*(dateMajoration.majoLastPercent-1)*precision)/precision  
              } 
              if(dateMajoration.majoLast>0){ amt+=dateMajoration.majoLast; amt2+=dateMajoration.majoLast;}
              totalMajoration.lastMinute1=amt;
              totalMajoration.lastMinute2=amt2;

            }
            else {
              var amt=0;
              var amt2=0;

              if(dateMajoration.majoTwoHour>1 && dateMajoration.majoTwoHour>dateMajoration.majoAvancePercent){
                totalMajoration.lastMinute1=Math.round(totalMajoration.priceBasic1*(dateMajoration.majoTwoHour-1)*precision)/precision
                totalMajoration.lastMinute2=Math.round(totalMajoration.priceBasic2*(dateMajoration.majoTwoHour-1)*precision)/precision
              }
              else if(dateMajoration.majoAvancePercent>1){
                amt=Math.round(totalMajoration.priceBasic1*(dateMajoration.majoAvancePercent-1)*precision)/precision
                amt2=Math.round(totalMajoration.priceBasic2*(dateMajoration.majoAvancePercent-1)*precision)/precision
              }    
              if(dateMajoration.majoAvance>0) {amt+=dateMajoration.majoAvance; amt2+=dateMajoration.majoAvance;}
              totalMajoration.avanceOrder1=amt;
              totalMajoration.avanceOrder2=amt2;
              
            }


            if(dateMajoration.provCom>0){
              totalMajoration.provCom=dateMajoration.provCom;
            }

            totalMajoration.priceTotal1=totalMajoration.priceBasic1+dateMajoration.provCom+totalMajoration.majorationRealTime1+totalMajoration.majorationDate1.amount+totalMajoration.avanceOrder1+totalMajoration.lastMinute1
            totalMajoration.priceTotal1=Math.round(totalMajoration.priceTotal1*precision)/precision

            totalMajoration.priceTotal2=totalMajoration.priceBasic2+dateMajoration.provCom+totalMajoration.majorationRealTime2+totalMajoration.majorationDate2.amount+totalMajoration.avanceOrder2+totalMajoration.lastMinute2
            totalMajoration.priceTotal2=Math.round(totalMajoration.priceTotal2*precision)/precision

            totalMajoration.priceBasic=totalMajoration.priceBasic1+"-"+totalMajoration.priceBasic2
            totalMajoration.priceTotal=totalMajoration.priceTotal1+"-"+totalMajoration.priceTotal2
            
            totalMajoration.avanceOrder=(totalMajoration.avanceOrder1>0)?(totalMajoration.avanceOrder1+((totalMajoration.avanceOrder1!=totalMajoration.avanceOrder2)?("-"+totalMajoration.avanceOrder2):"")):0
            totalMajoration.lastMinute=(totalMajoration.lastMinute1>0)?(totalMajoration.lastMinute1+((totalMajoration.lastMinute1!=totalMajoration.lastMinute2)?("-"+totalMajoration.lastMinute2):"")):0
            
          }
          else {
            totalMajoration.priceBasic=parseFloat(price);
            totalMajoration.priceBasic=Math.round(totalMajoration.priceBasic*precision)/precision

            if(this.state.immediate===true){
              var pWRT=this.state.priceEstimationWithTrafic[i].price;
              pWRT=pWRT.toString().replace(this.state.money.symbole,"")

              totalMajoration.majorationRealTime=parseFloat(pWRT)-totalMajoration.priceBasic
              if(totalMajoration.majorationRealTime<0) totalMajoration.majorationRealTime=0;
              totalMajoration.majorationRealTime=Math.round(totalMajoration.majorationRealTime*precision)/precision

            } else totalMajoration.majorationRealTime=0;

            if(dateMajoration.majoMax>1){
              totalMajoration.majorationDate={amount:(totalMajoration.priceBasic+totalMajoration.majorationRealTime)*(dateMajoration.majoMax-1), name:dateMajoration.majoName}
              totalMajoration.majorationDate.amount=Math.round(totalMajoration.majorationDate.amount*precision)/precision
            }
            else totalMajoration.majorationDate={amount:0, name:""};

            totalMajoration.avanceOrder=0;
            totalMajoration.lastMinute=0;

            if(this.state.immediate==true){
              var amt=0;
              if(dateMajoration.majoLastPercent>1) amt=Math.round(totalMajoration.priceBasic*(dateMajoration.majoLastPercent-1)*precision)/precision  
              if(dateMajoration.majoLast>0) amt+=dateMajoration.majoLast;
              totalMajoration.lastMinute=amt;


            }
            else {
              var amt=0;
              if(dateMajoration.majoTwoHour>1 && dateMajoration.majoTwoHour>dateMajoration.majoAvancePercent){
                totalMajoration.lastMinute=Math.round(totalMajoration.priceBasic*(dateMajoration.majoTwoHour-1)*precision)/precision   

              }
              else if(dateMajoration.majoAvancePercent>1) amt=Math.round(totalMajoration.priceBasic*(dateMajoration.majoAvancePercent-1)*precision)/precision   
              if(dateMajoration.majoAvance>0) amt+=dateMajoration.majoAvance;
              totalMajoration.avanceOrder=amt;

            }

            

            totalMajoration.priceTotal=totalMajoration.priceBasic+dateMajoration.provCom+totalMajoration.majorationRealTime+totalMajoration.majorationDate.amount+totalMajoration.lastMinute+totalMajoration.avanceOrder
            totalMajoration.priceTotal=Math.round(totalMajoration.priceTotal*precision)/precision

          }

          list[i].realPrice=totalMajoration;
          
      }
      console.log("estimatePriceGo vtc")
      console.log(list)
      if(errorHourValidity==false) this.setState({estimatePriceGo: list })
  }

  /*Test des taxis*/

  console.log("je vais tester les taxis")

  if(this.state.priceEstimationTaxi!="" && this.state.date!=""){
      /*on doit déterminer si c'est un tarif C ou D */
      console.log("test des taxi ok")
      var d2=new Date(this.state.integerDate);
      var saturday=(d2.getDay()==6)?true:false
      var sunday=(d2.getDay()==0)?true:false;
      var ferie=this.testFerie(d2)
      var hour=d2.getHours()*60+d2.getMinutes();




      var listTaxi=this.state.priceEstimationTaxi;


      if(listTaxi[0].explicationPricing.validityFrom!=undefined){
        console.log("hawai")
        var hourFrom=(parseInt(listTaxi[0].explicationPricing.validityFrom[0]+listTaxi[0].explicationPricing.validityFrom[1]))*60+parseInt(listTaxi[0].explicationPricing.validityFrom[3]+listTaxi[0].explicationPricing.validityFrom[4])
        var hourTo=(parseInt(listTaxi[0].explicationPricing.validityTo[0]+listTaxi[0].explicationPricing.validityTo[1]))*60+parseInt(listTaxi[0].explicationPricing.validityTo[3]+listTaxi[0].explicationPricing.validityTo[4])
        if (!(  (hourFrom<hourTo  &&  hour>hourFrom && hour<hourTo) || (hourFrom>hourTo  && (hour>hourFrom || hour<hourTo) ) ) ) {
            /*le pricing est pas bon*/
            /*je relance une demande*/
            errorHourValidityTaxi=true;

            var getZoneForfaitTaxi=this.getZoneForfaitTaxi()
            stop=getZoneForfaitTaxi.stop;
            var result=getZoneForfaitTaxi.result;

            if(stop==true){
              /*j'ai retrouvé un forfait ou une zone ok */
              this.updateDriverPricingTaxi(result);
            } else {
                this.setState({estimatePriceGoTaxi:"",}) 
                if(this.state.errorHourValidity==true){
                    /*c'est mort y a pas rien à proposer*/
                    if(this.state.dispenser.enabled==true){
                        if(this.alert!=undefined) this.alert.onAlert({title:strings.noDriverService,maxiMode:this.state.dispenser.enabled}); 
                        this.setState({waitDispenserResult:false})

                      }
                      else if(this.state.driver==false && this.state.partner==false && this.alert!=undefined) this.alert.onAlert({title:strings.noDriverService,buttons:[
                        {text: strings.ok,onPress: () => { } }, {text: strings.contactUs,onPress: () => { this.closeControlPanel("Contact") } }  ] }); 
                      else if(this.state.viewAdminMode!=true && this.alert!=undefined) this.alert.onAlert({title:strings.noDriverService});  
                      
                }


            }
          }

      }




      if(errorHourValidityTaxi==false) for(let i=0;i<listTaxi.length;i++){


       var hourFrom=(listTaxi[i].explicationPricing.tarifBDFrom!=undefined)?(parseInt(listTaxi[i].explicationPricing.tarifBDFrom[0]+listTaxi[i].explicationPricing.tarifBDFrom[1])*60+parseInt(listTaxi[i].explicationPricing.tarifBDFrom[3]+listTaxi[i].explicationPricing.tarifBDFrom[4]) ):false
       var hourTo=(listTaxi[i].explicationPricing.tarifBDTo!=undefined)?(parseInt(listTaxi[i].explicationPricing.tarifBDTo[0]+listTaxi[i].explicationPricing.tarifBDTo[1])*60+parseInt(listTaxi[i].explicationPricing.tarifBDTo[3]+listTaxi[i].explicationPricing.tarifBDTo[4]) ):false

       console.log("hourFrom = "+hourFrom)



       if(listTaxi[i].explicationPricing.type=="forfait"){
        if(hourFrom!=false && ( (saturday==true && listTaxi[i].explicationPricing.tarifBDSaturday==true ) || (sunday==true && listTaxi[i].explicationPricing.tarifBDSunday==true ) || (ferie==true && listTaxi[i].explicationPricing.tarifBDFerie==true) || (hour>hourFrom ) || (hour<hourTo) ) ){
            listTaxi[i].realPrice={priceBasic:listTaxi[i].price,priceTotal:listTaxi[i].priceMajo} 
            listTaxi[i].realPriceIfReturn={priceBasic:listTaxi[i].price,priceTotal:listTaxi[i].priceMajo} 
        }
        else {
            listTaxi[i].realPrice={priceBasic:listTaxi[i].price,priceTotal:listTaxi[i].price} 
            listTaxi[i].realPriceIfReturn={priceBasic:listTaxi[i].price,priceTotal:listTaxi[i].price} 
        }

        
       }
       else {

          var percentMajo=((saturday==true && listTaxi[i].explicationPricing.tarifBDSaturday==true ) || (sunday==true && listTaxi[i].explicationPricing.tarifBDSunday==true ) || (ferie==true && listTaxi[i].explicationPricing.tarifBDFerie==true))?1:0; 
          if(saturday==true && listTaxi[i].explicationPricing.tarifBDSaturday==true ) listTaxi[i].explicationPricing.majorationWhy=strings.majoSaturday
          else if(sunday==true && listTaxi[i].explicationPricing.tarifBDSunday==true ) listTaxi[i].explicationPricing.majorationWhy=strings.majoSunday
          else if(ferie==true && listTaxi[i].explicationPricing.tarifBDFerie==true) listTaxi[i].explicationPricing.majorationWhy=strings.majoFerie

          if(hourFrom!=false && percentMajo==0){
              var hourEnd=hour+(this.state.timeEstimation/60)


              if(hourFrom>hourTo){
                if(hour<hourTo) percentMajo+=((hourEnd<hourTo)?hourEnd:hourTo)-hour; 
                
                if(hourEnd>hourFrom) percentMajo+=hourEnd-( (hour>hourFrom)?hour:hourFrom); 
                
                if(hourEnd>((24*60)+hourTo)) percentMajo-=hourEnd-(24*60+hourTo);
                percentMajo=percentMajo/(this.state.timeEstimation/60);
              } else {
                if(hourFrom>hour) percentMajo+=hourEnd-( (hour>hourFrom)?hour:hourFrom); 
                if(hourTo>hourEnd) percentMajo+=hourEnd-( (hour>hourFrom)?hour:hourFrom)
                
                percentMajo=percentMajo/(this.state.timeEstimation/60);

              }

          }

          listTaxi[i].explicationPricing.majorationWhy="";

          if(percentMajo>0) {
            listTaxi[i].tarifBD=true;
            listTaxi[i].explicationPricing.majorationWhy=strings.majoNight+" (partiel)";
          }
          if(percentMajo==1) listTaxi[i].explicationPricing.majorationWhy=strings.majoNight
          
          listTaxi[i].realPrice={priceBasic:(listTaxi[i].priceC*(1-percentMajo) ) + (listTaxi[i].priceD*percentMajo)   ,priceTotal:(listTaxi[i].priceC*(1-percentMajo) ) + (listTaxi[i].priceD*percentMajo)}
          listTaxi[i].realPriceIfReturn={priceBasic:(listTaxi[i].priceA*(1-percentMajo) ) + (listTaxi[i].priceB*percentMajo), priceTotal:(listTaxi[i].priceA*(1-percentMajo) ) + (listTaxi[i].priceB*percentMajo)}

          


       }


        listTaxi[i].explicationPricing.immediate=this.state.immediate
        
        if(listTaxi[i].explicationPricing.type!="forfait"){
          listTaxi[i].realPrice.priceTotal+=((this.state.immediate==true)?listTaxi[i].explicationPricing.majoTaxiImmediate :listTaxi[i].explicationPricing.majoTaxiAvance)
          if(listTaxi[i].realPrice.priceTotal<listTaxi[i].explicationPricing.minPrice) listTaxi[i].realPrice.priceTotal=listTaxi[i].explicationPricing.minPrice;
          listTaxi[i].realPrice.priceTotal=Math.round(listTaxi[i].realPrice.priceTotal*precision)/precision;
          listTaxi[i].realPrice.priceBasic=listTaxi[i].realPrice.priceTotal
          
        }
        if(listTaxi[i].explicationPricing.coeffEnable==true){
          
          listTaxi[i].realPrice.priceBasic1=Math.round(listTaxi[i].realPrice.priceTotal*(1-(listTaxi[i].explicationPricing.coeffPercent/100)))
          listTaxi[i].realPrice.priceBasic2=Math.round(listTaxi[i].realPrice.priceTotal*(1+(listTaxi[i].explicationPricing.coeffPercent/100)))
          listTaxi[i].realPrice.priceTotal= Math.round(listTaxi[i].realPrice.priceTotal*(1-(listTaxi[i].explicationPricing.coeffPercent/100)))+"-"+    Math.round(listTaxi[i].realPrice.priceTotal*(1+(listTaxi[i].explicationPricing.coeffPercent/100)))
        }

        listTaxi[i].realPriceIfReturn.priceTotal+=((this.state.immediate==true)?listTaxi[i].explicationPricing.majoTaxiImmediate :listTaxi[i].explicationPricing.majoTaxiAvance)
        if(listTaxi[i].realPriceIfReturn<listTaxi[i].explicationPricing.minPrice) listTaxi[i].realPriceIfReturn.priceTotal=listTaxi[i].explicationPricing.minPrice;
        listTaxi[i].realPriceIfReturn.priceTotal=Math.round(listTaxi[i].realPriceIfReturn.priceTotal*precision)/precision;
        
        if(listTaxi[i].explicationPricing.coeffEnable==true){
          
          listTaxi[i].realPriceIfReturn.priceBasic1=Math.round(listTaxi[i].realPriceIfReturn.priceTotal*(1-(listTaxi[i].explicationPricing.coeffPercent/100)))
          listTaxi[i].realPriceIfReturn.priceBasic2=Math.round(listTaxi[i].realPriceIfReturn.priceTotal*(1+(listTaxi[i].explicationPricing.coeffPercent/100)))
          listTaxi[i].realPriceIfReturn.priceTotal= Math.round(listTaxi[i].realPriceIfReturn.priceTotal*(1-(listTaxi[i].explicationPricing.coeffPercent/100)))+"-"+    Math.round(listTaxi[i].realPriceIfReturn.priceTotal*(1+(listTaxi[i].explicationPricing.coeffPercent/100)))
        }

      }


      if(errorHourValidityTaxi==false) this.setState({estimatePriceGoTaxi: listTaxi })

      




      
/*      
tarifBDTo
tarifBDSaturday
tarifBDSunday
tarifBDFerie

*/


  }






  if(true && this.state.viewAccurency===true && Object.keys(this.state.viewAccurencyRates).length==0) {
      fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/exchangeMoney", {
    headers: {"Content-Type": "application/json"},method: "GET"}).then((response) => response.json()).then((responseJson) => {
      if(responseJson.list!=undefined){

        this.setState({viewAccurencyRates:responseJson.list})
      }

    })

  }
}


testFerie(d2){
  console.log("je lance testFerie")
  var jourFerie=d2.getDate()+"/"+(d2.getMonth()+1);
  var jfFinal=(jourFerie=="1/1" || (jourFerie=="1/5" && info.countryCode=="fr") || (jourFerie=="8/5" && info.countryCode=="fr") || (jourFerie=="14/7" && info.countryCode=="fr") || (jourFerie=="1/8" && info.countryCode=="ch") || (jourFerie=="15/8" && info.countryCode=="fr") || (jourFerie=="1/11" && info.countryCode=="fr") || (jourFerie=="11/11" && info.countryCode=="fr") || jourFerie=="25/12")?true:false;
  if(jfFinal==false){
            var an=d2.getFullYear();
            var G = an%19
            var C = Math.floor(an/100)
            var H = (C - Math.floor(C/4) - Math.floor((8*C+13)/25) + 19*G + 15)%30
            var I = H - Math.floor(H/28)*(1 - Math.floor(H/28)*Math.floor(29/(H + 1))*Math.floor((21 - G)/11))
            var J = (an*1 + Math.floor(an/4) + I + 2 - C + Math.floor(C/4))%7
            var L = I - J
            var MoisPaques = 3 + Math.floor((L + 40)/44)
            var JourPaques = L + 28 - 31*Math.floor(MoisPaques/4)
            var Paques = new Date(an, MoisPaques-1, JourPaques)

            var VendrediSaint = new Date(an, MoisPaques-1, JourPaques-2)
            VendrediSaint=VendrediSaint.getDate()+"/"+(VendrediSaint.getMonth()+1)

            var LundiPaques = new Date(an, MoisPaques-1, JourPaques+1);
            LundiPaques=LundiPaques.getDate()+"/"+(LundiPaques.getMonth()+1)
            var Ascension = new Date(an, MoisPaques-1, JourPaques+39)
            Ascension=Ascension.getDate()+"/"+(Ascension.getMonth()+1)
            var LundiPentecote = new Date(an, MoisPaques-1, JourPaques+50)
            LundiPentecote=LundiPentecote.getDate()+"/"+(LundiPentecote.getMonth()+1)



             var lundiJeune=new Date()
             if(info.countryCode=="ch"){
                lundiJeune.setMonth(8)
                lundiJeune.setDate(1)
                lundiJeune.setHours(12)


                let day = lundiJeune.getDay();
                let toNextSun = day !== 0 ? 7 - day : 0;
                lundiJeune.setDate(lundiJeune.getDate() + toNextSun);
                lundiJeune.setDate(lundiJeune.getDate() + 2 * 7+1)
                lundiJeune=lundiJeune.getDate()+"/"+(lundiJeune.getMonth()+1)
             }
             console.log("je teste lundiJeune")
             console.log(lundiJeune)
             console.log(jourFerie+"=="+lundiJeune)



            if(jourFerie==LundiPentecote || jourFerie==LundiPaques || jourFerie==Ascension || (jourFerie==VendrediSaint && info.countryCode=="ch") || (jourFerie==lundiJeune && info.countryCode=="ch")  ) jfFinal=true;
      }

    return jfFinal;

}





majorationPrice(pricing){
      var d2=new Date(this.state.integerDate);
      var majoTwoHourTest=((d2 - new Date())<120*60000)
      
      if(this.state.enableTimezone!=false && d2.getTimezoneOffset()!=(-this.state.enableTimezone.value*60)){
        d2=new Date(Date.parse(d2)+(d2.getTimezoneOffset()*60000) + (this.state.enableTimezone.value*60*60000) );
          
      } 


      

      var saturday=(d2.getDay()==6)?true:false
      var sunday=(d2.getDay()==0)?true:false;

      var jfFinal=this.testFerie(d2)



      var morning=(d2.getHours()>6 && d2.getHours()<9)?true:false;
      var afternoon=(d2.getHours()>15 && d2.getHours()<19)?true:false;
      var afternoonBis=(d2.getHours()>16 && d2.getHours()<21)?true:false;
      var evening=(d2.getHours()>18 && d2.getHours()<21)?true:false;
      var night=(d2.getHours()>20 || d2.getHours()<7)?true:false;
      var majoCompleteNight=(d2.getHours()>18 || d2.getHours()<7)?true:false;
      
      var i;
      var majoMax=1;
      var majoName="";

      if(pricing.majoration==undefined) pricing.majoration={};

      if(  ((this.state.majoration.dynamic!=undefined)? (  (pricing.majoration.dynamic!=undefined &&  pricing.majoration.dynamic > this.state.majoration.dynamic)?  pricing.majoration.dynamic   :  this.state.majoration.dynamic    ) : pricing.majoration.dynamic) >majoMax){ majoMax=((this.state.majoration.dynamic!=undefined)? (  (pricing.majoration.dynamic!=undefined &&  pricing.majoration.dynamic > this.state.majoration.dynamic)?  pricing.majoration.dynamic   :  this.state.majoration.dynamic    ) : pricing.majoration.dynamic); majoName="dynamic";}
      if(majoMax==undefined) majoMax=1;
      
      if( morning==true &&  ((this.state.majoration.morning!=undefined)? (  (pricing.majoration.morning!=undefined &&  pricing.majoration.morning > this.state.majoration.morning)?  pricing.majoration.morning   :  this.state.majoration.morning    ) : pricing.majoration.morning) >majoMax){ majoMax=((this.state.majoration.morning!=undefined)? (  (pricing.majoration.morning!=undefined &&  pricing.majoration.morning > this.state.majoration.morning)?  pricing.majoration.morning   :  this.state.majoration.morning    ) : pricing.majoration.morning); majoName="morning";}
      if( evening==true &&  ((this.state.majoration.evening!=undefined)? (  (pricing.majoration.evening!=undefined &&  pricing.majoration.evening > this.state.majoration.evening)?  pricing.majoration.evening   :  this.state.majoration.evening    ) : pricing.majoration.evening) >majoMax){ majoMax=((this.state.majoration.evening!=undefined)? (  (pricing.majoration.evening!=undefined &&  pricing.majoration.evening > this.state.majoration.evening)?  pricing.majoration.evening   :  this.state.majoration.evening    ) : pricing.majoration.evening); majoName="evening";}
      if( afternoon==true &&  ((this.state.majoration.afternoon!=undefined)? (  (pricing.majoration.afternoon!=undefined &&  pricing.majoration.afternoon > this.state.majoration.afternoon)?  pricing.majoration.afternoon   :  this.state.majoration.afternoon    ) : pricing.majoration.afternoon) >majoMax){ majoMax=((this.state.majoration.afternoon!=undefined)? (  (pricing.majoration.afternoon!=undefined &&  pricing.majoration.afternoon > this.state.majoration.afternoon)?  pricing.majoration.afternoon   :  this.state.majoration.afternoon    ) : pricing.majoration.afternoon); majoName="afternoon";}
      
      if( saturday==true &&  ((this.state.majoration.saturday!=undefined)? (  (pricing.majoration.saturday!=undefined &&  pricing.majoration.saturday > this.state.majoration.saturday)?  pricing.majoration.saturday   :  this.state.majoration.saturday    ) : pricing.majoration.saturday) >majoMax){ majoMax=((this.state.majoration.saturday!=undefined)? (  (pricing.majoration.saturday!=undefined &&  pricing.majoration.saturday > this.state.majoration.saturday)?  pricing.majoration.saturday   :  this.state.majoration.saturday    ) : pricing.majoration.saturday); majoName="saturday";}
      if( sunday==true &&  ((this.state.majoration.sunday!=undefined)? (  (pricing.majoration.sunday!=undefined &&  pricing.majoration.sunday > this.state.majoration.sunday)?  pricing.majoration.sunday   :  this.state.majoration.sunday    ) : pricing.majoration.sunday) >majoMax){ majoMax=((this.state.majoration.sunday!=undefined)? (  (pricing.majoration.sunday!=undefined &&  pricing.majoration.sunday > this.state.majoration.sunday)?  pricing.majoration.sunday   :  this.state.majoration.sunday    ) : pricing.majoration.sunday) ; majoName="sunday";}
      if( night==true &&  ((this.state.majoration.night!=undefined)? (  (pricing.majoration.night!=undefined &&  pricing.majoration.night > this.state.majoration.night)?  pricing.majoration.night   :  this.state.majoration.night    ) : pricing.majoration.night) >majoMax){ majoMax=((this.state.majoration.night!=undefined)? (  (pricing.majoration.night!=undefined &&  pricing.majoration.night > this.state.majoration.night)?  pricing.majoration.night   :  this.state.majoration.night    ) : pricing.majoration.night); majoName="night";}
      if( jfFinal==true &&  ((this.state.majoration.ferie!=undefined)? (  (pricing.majoration.ferie!=undefined &&  pricing.majoration.ferie > this.state.majoration.ferie)?  pricing.majoration.ferie   :  this.state.majoration.ferie    ) : pricing.majoration.ferie) >majoMax){ majoMax=((this.state.majoration.ferie!=undefined)? (  (pricing.majoration.ferie!=undefined &&  pricing.majoration.ferie > this.state.majoration.ferie)?  pricing.majoration.ferie   :  this.state.majoration.ferie    ) : pricing.majoration.ferie); majoName="ferie";}

      if(majoMax==undefined) majoMax=1;

      if(this.state.majoration.majoOther!=undefined || pricing.majoration.majoOther!=undefined){
          console.log("majo Other test "+d2);
          var majoOther=(pricing.majoration.majoOther!=undefined)?pricing.majoration.majoOther:this.state.majoration.majoOther;
          var majoOtherList=(pricing.majoration.majoOther!=undefined)?Object.keys(pricing.majoration.majoOther):Object.keys(this.state.majoration.majoOther)
          var startDate,endDate, hourS, hourE; 
          var d3=new Date(this.state.integerDate);
          

          for(i=0; i<majoOtherList.length; i++){
            

            startDate=new Date(Date.parse(d3))
            hourS=majoOther[majoOtherList[i]].startDate[0]+majoOther[majoOtherList[i]].startDate[1]
            startDate.setHours(hourS); 
            startDate.setMinutes(majoOther[majoOtherList[i]].startDate[3]+majoOther[majoOtherList[i]].startDate[4]); 

            endDate=new Date(Date.parse(d3))
            hourE=majoOther[majoOtherList[i]].endDate[0]+majoOther[majoOtherList[i]].endDate[1];
            endDate.setHours(hourE); 
            endDate.setMinutes(majoOther[majoOtherList[i]].endDate[3]+majoOther[majoOtherList[i]].endDate[4]); 
            
            /*if(hourE<hourS) endDate.setDate(endDate.getDate()+1);*/
              var testMajoOther=false;

              if(hourE<hourS){
                endDate.setDate(endDate.getDate()+1);
                if (d3>startDate && d3<endDate) testMajoOther=true;
                else {
                  startDate.setDate(startDate.getDate()-1);
                  endDate.setDate(endDate.getDate()-1);
                  if (d3>startDate && d3<endDate) testMajoOther=true;
                }

              }
              else if (d3>startDate && d3<endDate) testMajoOther=true;


              if(majoOther[majoOtherList[i]].excludeDay!=undefined){
                var dayRef=d2.getDay()-1;
                if(dayRef==-1) dayRef=6;
                if(majoOther[majoOtherList[i]].excludeDay[dayRef]==true)  testMajoOther=false;

              }

              if(testMajoOther==true){
                  majoName="majoOther"; 
                  majoMax=majoOther[majoOtherList[i]].majoration;
              }



          }


      }




      /*je teste les majorations globales et local de highAffluence*/
      var d2parse=Date.parse(d2);
      if(this.state.majoration.highAffluence!=undefined){
            var highAffluenceList=Object.keys(this.state.majoration.highAffluence)

            for(i=0;i<highAffluenceList.length;i++){
              if(d2parse>this.state.majoration.highAffluence[highAffluenceList[i]].startDate && d2parse<this.state.majoration.highAffluence[highAffluenceList[i]].endDate && this.state.majoration.highAffluence[highAffluenceList[i]].majoration>majoMax ){
                  majoMax=this.state.majoration.highAffluence[highAffluenceList[i]].majoration
                  majoName="highAffluence"
              } 
            }
      }

      if(pricing.majoration.highAffluence!=undefined){
            var highAffluenceList=Object.keys(pricing.majoration.highAffluence)

            for(i=0;i<highAffluenceList.length;i++){
              if(d2parse>pricing.majoration.highAffluence[highAffluenceList[i]].startDate && d2parse<pricing.majoration.highAffluence[highAffluenceList[i]].endDate && pricing.majoration.highAffluence[highAffluenceList[i]].majoration>majoMax ){
                  majoMax=pricing.majoration.highAffluence[highAffluenceList[i]].majoration
                  majoName="highAffluence"
              } 
            }
      }
     





      if(majoMax==undefined) majoMax=1;

      var majoAvance=((this.state.majoration.majoAvance!=undefined)? (  (pricing.majoration.majoAvance!=undefined &&  pricing.majoration.majoAvance > this.state.majoration.majoAvance)?  pricing.majoration.majoAvance   :  this.state.majoration.majoAvance    ) : pricing.majoration.majoAvance)
      if(majoAvance==undefined) majoAvance=0;
      var majoLast=((this.state.majoration.majoLast!=undefined)? (  (pricing.majoration.majoLast!=undefined &&  pricing.majoration.majoLast > this.state.majoration.majoLast)?  pricing.majoration.majoLast   :  this.state.majoration.majoLast    ) : pricing.majoration.majoLast)
      if(majoLast==undefined) majoLast=0;
      var majoAvancePercent=((this.state.majoration.majoAvancePercent!=undefined)? (  (pricing.majoration.majoAvancePercent!=undefined &&  pricing.majoration.majoAvancePercent > this.state.majoration.majoAvancePercent)?  pricing.majoration.majoAvancePercent   :  this.state.majoration.majoAvancePercent    ) : pricing.majoration.majoAvancePercent)
      if(majoAvancePercent==undefined) majoAvancePercent=1;
      var majoLastPercent=((this.state.majoration.majoLastPercent!=undefined)? (  (pricing.majoration.majoLastPercent!=undefined &&  pricing.majoration.majoLastPercent > this.state.majoration.majoLastPercent)?  pricing.majoration.majoLastPercent   :  this.state.majoration.majoLastPercent    ) : pricing.majoration.majoLastPercent)
      if(majoLastPercent==undefined) majoLastPercent=1;
      
      var majoTwoHour=((this.state.majoration.majoTwoHour!=undefined)? (  (pricing.majoration.majoTwoHour!=undefined &&  pricing.majoration.majoTwoHour > this.state.majoration.majoTwoHour)?  pricing.majoration.majoTwoHour   :  this.state.majoration.majoTwoHour    ) : pricing.majoration.majoTwoHour)
      if(majoTwoHour==undefined || majoTwoHourTest==false) majoTwoHour=1;

      if( (this.state.majoration.noMajoForPro==true && this.state.customerPro==true) || (this.state.majoration.noMajoForProvider==true && this.state.provider==true)){
        majoMax=1; 
        majoName=""; 
      }


      return {majoMax:majoMax, provCom:(pricing.provCom!=undefined)?pricing.provCom:0, majoName:majoName,majoAvance:majoAvance,majoLast:majoLast,majoAvancePercent:majoAvancePercent,majoLastPercent:majoLastPercent,majoTwoHour:majoTwoHour };

}








  trajetMultiStop= (id, action) => {
    const style=styleInfo();
    if (this.state.lock==false) {
      this.setState({lock:true})
      timer.setTimeout(generateUUID(), () => {this.setState({lock:false})}, 2000);

      if(action!=undefined && action=="remove"){
          var mapIntermediate=this.state.mapIntermediate; 
          mapIntermediate.splice(id, 1)
          var saveBook=this.state.saveBook; 
          saveBook.trajetChange=true;
          this.setState({saveBook:saveBook,mapIntermediate:mapIntermediate },()=>{this.drawRoute();  }); 

      }
      else if( Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax){this.setState({viewTrajet:"stop",intermediateStopId:id,controlePanelOpen:true});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false }) ;}
      else this.props.navigation.navigate('Trajet', {favorite:Object.assign(this.state.previousSearchDisplay,this.state.favorite, this.state.favoriteGlobal),longitude: this.state.longitude,latitude: this.state.latitude,addPreviousSearch: this.addPreviousSearch, removePreviousSearch:this.removePreviousSearch, onChangeIntermediateStop: this.onChangeIntermediateStop, intermediateStop:id,mapTo: this.state.mapTo,mapFrom: this.state.mapFrom,});
      }
  }






  trajetToDestination(){
    const style=styleInfo();
    if (this.state.lock==false) {
      this.setState({lock:true})
      timer.setTimeout(generateUUID(), () => {this.setState({lock:false})}, 2000);
      if(this.state.dispenser.enabled==true){this.setState({viewTrajet:"to"}); }
      else if( Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax){this.setState({viewTrajet:"to",controlePanelOpen:true});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false }) ;}
      else this.props.navigation.navigate('Trajet', {durationSelected:this.state.durationSelected, duration:this.state.provisionDuration,durationMin:this.state.durationMin,changeDuration: this.changeDuration,choiceDuration:(info.disableProvision==true)?false:true,  favorite:Object.assign(this.state.previousSearchDisplay,this.state.favorite, this.state.favoriteGlobal),longitude: this.state.longitude,latitude: this.state.latitude,addPreviousSearch: this.addPreviousSearch, removePreviousSearch:this.removePreviousSearch, onChangeTo: this.onChangeTo,mapTo: this.state.mapTo,mapFrom: this.state.mapFrom,});
      }
  }

  selectDate(){
    const style=styleInfo();

    if(this.state.dispenser.enabled==true){
        var calcDate=this.calcDateMin(); console.log('viewTrajet:"date",dateMin:'+calcDate); this.setState({viewTrajet:"date",dateMin:calcDate});
    }
    else if(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax ) {var calcDate=this.calcDateMin(); this.setState({viewTrajet:"date",controlePanelOpen:true, dateMin:calcDate}); if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false }) ;}
    else this.props.navigation.navigate('MavSelectDate', {enableTimezone:this.state.enableTimezone, delayRaceMin:this.state.delayRaceMin, driver:(this.state.driver==true || this.state.manager==true)?true:false, partner:this.state.partner, contactUs:this.contactUs,changeDate: this.changeDate, navigate:true,immediate:this.state.immediate, immediateMode:this.state.immediateModeOrder,date:this.state.integerDate,dateMin:this.calcDateMin() });
                 
  }










  
  provisionCalc= () => {
  	console.log("je lance provisionCalc")
    if(this.state.mapFrom.description!='' && this.state.provisionDuration!=''){
      var price=new Array;
      if(this.state.priceProvision=="" && this.alert!=undefined) this.alert.onAlert({title:strings.noWayWasFound}); 
      else {
        console.log("testProvision");
        var provisionPrice; 

        if(this.state.priceProvision.typeZone!=undefined){
          var j; 
          var stop=false;
          for(j=0;j<this.state.priceProvision.typeZone.length;j++){
              if(stop==false){
                var dist=this.distance(this.state.priceProvision.typeZone[j].latitude,this.state.priceProvision.typeZone[j].longitude,this.state.mapFrom.coordinates.latitude,this.state.mapFrom.coordinates.longitude,"K");

                if(dist<this.state.priceProvision.typeZone[j].radius){
                    provisionPrice=this.state.priceProvision.typeZone[j].price;
                    stop=true;
                    
                }
              }
          }

          if(stop==false){
              provisionPrice=JSON.parse(JSON.stringify(this.state.priceProvision));
              delete provisionPrice.typeZone;
          }

          

        } else provisionPrice=this.state.priceProvision;


        var priceList=Object.keys(provisionPrice);


        

        var i;
        var explicationPricing;

        for(i=0;i<priceList.length;i++){
        	explicationPricing={type:"provision" }

          if( this.state.driver==true || this.state.partner==true || this.state.vipMode==false || provisionPrice[priceList[i]].target==undefined || (provisionPrice[priceList[i]].target.pro!=false && this.state.customerPro==true) || (provisionPrice[priceList[i]].target.vip!=false && this.state.vip==true) || (provisionPrice[priceList[i]].target.standard!=false && this.state.customerPro!=true && this.state.vip!=true)    ){

              var j=1;
              var value=this.state.provisionDuration;
              var stop=false;
              var priceForThisCar=0;
              
             
              while(stop==false){
                value-=3600;
                if(value<0) stop=true;
                else {

                  var calcP=(provisionPrice[priceList[i]][j]==undefined)?provisionPrice[priceList[i]]["more"]:provisionPrice[priceList[i]][j]
                  explicationPricing[j]=calcP
                  priceForThisCar+=calcP
                  j++; 
                }
              }

              
              value=value+3600;
              var calcP=(value/3600)*((provisionPrice[priceList[i]][j]==undefined)?provisionPrice[priceList[i]]["more"]:provisionPrice[priceList[i]][j])
              explicationPricing["other"]=calcP

              if(this.state.provisionDuration==1800 && provisionPrice[priceList[i]]["30min"]!=undefined) calcP=provisionPrice[priceList[i]]["30min"]; 

              var finalP=priceForThisCar+calcP;

              if(this.state.noVAT==true) finalP/=(1+info.tvaPercentDispo/100)

              var raceInformation={explicationPricing:explicationPricing,price:finalP,name:provisionPrice[priceList[i]].name}

              if(provisionPrice[priceList[i]].passagers!=undefined) {raceInformation.passagers=provisionPrice[priceList[i]].passagers;}
    	        if(provisionPrice[priceList[i]].passagersMin!=undefined) {raceInformation.passagersMin=provisionPrice[priceList[i]].passagersMin;}
              if(provisionPrice[priceList[i]].luggageMax!=undefined) {raceInformation.luggageMax=provisionPrice[priceList[i]].luggageMax;}

              price.push(raceInformation)
             }

        }

        console.log(price)
        /*détermination de la zone de départ*/
        var stop=false;
        var noZone="";
        i=0;
        if(this.state.classic!=undefined){
          while(stop==false && i<this.state.classic.length){
            var dist=this.distance(this.state.classic[i].latitude,this.state.classic[i].longitude,this.state.mapFrom.coordinates.latitude,this.state.mapFrom.coordinates.longitude,"K");
            if(dist<this.state.classic[i].radius){
              stop=true;
              noZone=this.state.classic[i].id;
              }

            i++;
          }
        }
        this.setState({noZone:noZone})

        if(this.state.extraEUMode==true){

            var infoMoney=this.findMoney((provisionPrice[priceList[0]].moneyID!=undefined)?provisionPrice[priceList[0]].moneyID:"eu"); 
            this.setState({money:infoMoney})
        }

        if(this.state.mapFrom.description!=strings.myPosition){
        	this.setState({
              startAddress:this.state.mapFrom.description,
              timeEstimation:this.state.provisionDuration,
              timeEstimationWithTrafic:this.state.provisionDuration,
              priceEstimation: price,
              priceEstimationWithTrafic:price,
              
              selected:0,
            },() =>{this.calculateMajoration()});

        }
        else{
          console.log("je lance du maps.googleapis")
        	fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' +this.state.mapFrom.coordinates.latitude +',' +this.state.mapFrom.coordinates.longitude +'&key='+info.googleMapsKey)
          .then(response => response.json())
          .then(responseJson => {
            this.setState({
              startAddress:responseJson.results[0]["formatted_address"],
              timeEstimation:this.state.provisionDuration,
              timeEstimationWithTrafic:this.state.provisionDuration,
              priceEstimation: price,
              priceEstimationWithTrafic:price,
              selected:0,
            },() =>{this.calculateMajoration()});
          })

        }

        	 


        
        }
      }
    }
  
  
  angle(cx, cy, ex, ey) {
    var dy = ey - cy;
    var dx = ex - cx;
    var theta = Math.atan2(dy, dx); // range (-PI, PI]
    theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    return theta;

  }


  decode(t, e) {
          for (
            var n,
              o,
              u = 0,
              l = 0,
              r = 0,
              d = [],
              h = 0,
              i = 0,
              a = null,
              c = Math.pow(10, e || 5);
            u < t.length;

          ) {
            (a = null), (h = 0), (i = 0);
            do
              (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
            while (a >= 32);
            (n = 1 & i ? ~(i >> 1) : i >> 1), (h = i = 0);
            do
              (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
            while (a >= 32);
            (o = 1 & i ? ~(i >> 1) : i >> 1), (l += n), (r += o), d.push([
              l / c,
              r / c,
            ]);
          }
          return (d = d.map(function(t) {
            return { latitude: t[0], longitude: t[1], lat:t[0], lng:t[1] };
          }));
  }



startChatClient= (force) => {
   const style=styleInfo();
   if(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax ){
                    this.setState({viewChat:true, controlePanelOpen:true, forceChat:force});
                    if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false })
                }
                else this.props.navigation.navigate("Chat",{outRace:(force==undefined)?undefined:true, contactUs:(force==undefined)?this.contactUs:undefined, sender:(force==undefined)?this.state.immediateInfo.text:force.sender,raceID:(force==undefined)?this.state.immediateInfo.uuid:force.raceID,senderPhone:(force==undefined)?this.state.immediateInfo.driverPhone:undefined,contactMessage:(force==undefined)?this.contactMessage:undefined,senderID:(force==undefined)?this.state.immediateInfo.driverID:force.senderID})
}
  




  disableDispenser= () => {
    if(this.alert!=undefined) this.alert.onAlert({title:strings.password,subTitle:strings.passwordToContinu, textInput:{placeholder:"*******", secureTextEntry:true,   }, buttons:[
                  {text: strings.validate,onPress: (value) => {
                   
                      var user = getAuth(firebase).currentUser;

                      var credential = EmailAuthProvider.credential(getAuth(firebase).currentUser.email,value)

                      reauthenticateWithCredential(getAuth(firebase).currentUser, credential).then(() => {
                             var disp=this.state.dispenser;
                             disp.enabled=false; 
                             this.setState({dispenser:disp}); 
                             const fireInfo={} 
                            fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/dispenserMode/"+devInfo]=null
                            update(ref(getDatabase(firebase)), fireInfo)

                             this.props.navigation.setOptions({headerShown:true }) 

                        }).catch(() => {
                          if(this.alert!=undefined) this.alert.onAlert({title:strings.errorDefault}); 
                        });
                  }},
                  {text: strings.cancel, style:"cancel",onPress: () => {}}
                  ]


                  });
  }


  closeControlPanel = (value,params) => {
    console.log("closeControlPanel")
    
    if(value=="Contact" && params!=undefined && params.source=="drawer" && (this.state.immediateMode=="raceInProgress" || this.state.immediateMode=="driverNavigateToCustomer" || this.state.immediateMode=="driverArrivate")){
      console.log("affichage spéciale pour course")
      if(Platform.OS=="web"){console.log('eded'); this._nativateView.close()}   
      else  this._drawer.close();
      this.startChatClient()
    }
    
    else if (value) {
        if(Platform.OS=="web"){

            if(params!=undefined) this._nativateView.open(value, params)
              else this._nativateView.open(value)
        }
        else {
          this._drawer.close();
          if(params!=undefined) this.props.navigation.navigate(value,params);
          else this.props.navigation.navigate(value);
        }

      
    } 
    else if(Platform.OS=="web"){console.log('eded'); this._nativateView.close()}   
    else  this._drawer.close();
  };
  openControlPanel = () => { 

    this._drawer.open();

  };
  _changeDrawerStateOpen = () => {

   this.setState({controlePanelOpen:true},() =>{if(Platform.OS!="web") Animated.timing(this.opacityCloseButton, {toValue: 0.5,duration: 800}).start();})
   
   if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false }); 

  };
  
  _changeDrawerStateClose = () => {
    if(Platform.OS=="web") this.setState({controlePanelOpen:false})
    else {
        Animated.timing(this.opacityCloseButton, {toValue: 0,duration: 200, useNativeDriver: false}).start();
        timer.setTimeout(generateUUID(), () => {
          this.setState({controlePanelOpen:false})
          this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true}); 

        }, 300);
        
    }


  }

  _handleMapRegionChange = (value) => {
    

    var zoomLevel=Math.log2(360 * ((Dimensions.get('window').width/256) / value.longitudeDelta)) + 1
    this.setState({mapRegion:undefined, mapZoom:zoomLevel})
  };


  changeState= (value) => {
    this.setState(value)
  }

   stopTracking= (value) => {

        if(this.state.immediateMode=="driverArrivate"){
            this.alert.onAlert({title:strings.quitRaceImmediate,subTitle:strings.quitRaceImmediateNextKarhoo,buttons:[
              {text: strings.yesAfter,onPress: () => { 
                const fireInfo={} 
                fireInfo['race/' + this.state.immediateInfo.uuid+"/raceInProgress"]=false;
                fireInfo['race/' + this.state.immediateInfo.uuid+"/driverPhone"]=null;
                update(ref(getDatabase(firebase)), fireInfo)
                if(this.state.valueGetRaceInP!=undefined) this.state.valueGetRaceInP(); 
              }},
              {text: strings.yesNoShow,onPress: () => { 
                const fireInfo={} 
                

                if(this.state.partner==false || (this.state.privilegeDriver!="basic" && this.state.privilegeDriver!="standard" )){
                    /*chauffeur avancé*/
                    
                    if(this.state.immediateInfo.karhooProvider==true){
                      fireInfo['race/' + this.state.immediateInfo.uuid+"/noShow"]=true;
                      fireInfo['race/' + this.state.immediateInfo.uuid+"/cancelRaceDate"]=Date.parse(new Date());
                      fireInfo['race/' + this.state.immediateInfo.uuid+"/cancelRaceDriver"]=this.state.name+" "+this.state.lastName 
                      fireInfo['race/' + this.state.immediateInfo.uuid+"/raceInProgress"]=false;
                      fireInfo['race/' + this.state.immediateInfo.uuid+"/driverPhone"]=null; 
                      fireInfo['race/' + this.state.immediateInfo.uuid+"/status"]="cancel";
                    } else {
                      /*je vais sur la page pour générer la facture*/
                      this.navigateToGenerateBill(true)
                    }

                }
                else {

                  /*chauffeur basic*/
                   fireInfo['race/' + this.state.immediateInfo.uuid+"/raceInProgress"]=false;
                   /*je signale à l'admin un no-show*/
                   fireInfo['race/' + this.state.immediateInfo.uuid+"/driverMessage/"+Date.parse(new Date())]={text:"Il y a eu un no-show pour cette course" }

                   /*j'envoi un mail aux admins */

                        getAuth(firebase).currentUser.getIdToken().then(token => {
                          console.log("this.state.immediateInfo.raceDate "+this.state.infoRace.raceDate)
                              var date=date=new Date(this.state.infoRace.raceDate)
                              date=((date.getDate()<10)?"0":"")+date.getDate()+"/"+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+"/"+date.getFullYear()+" - "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()

                              var message= "Bonjour, il y a eu un no-show pour la course en date du "+date+". Vous pouvez aussi retrouver ce message dans l'application ou dans l'interface web."
                              var body={
                                  userID:getAuth(firebase).currentUser.uid,
                                  bundleIdentifer:info.bundleIdentifer, 
                                  message:message,
                                  token:token,
                                  title:"Alerte no-show",
                                  bundleAdress:info.firebaseProjectID,
                                  onlyMessage:true,
                              }

                          console.log(JSON.stringify(body))
                          fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/sendMessageToAdmin", {
                                body:JSON.stringify(body),
                                method: "POST"})

                        })

                }

                
                
                update(ref(getDatabase(firebase)), fireInfo)
                if(this.state.valueGetRaceInP!=undefined) this.state.valueGetRaceInP();  
              }},
              {text: strings.no, style:"cancel",onPress: () => {}}
            ],});
        }
        else this.alert.onAlert({title:strings.quitRaceImmediate,subTitle:strings.quitRaceImmediateNext,buttons:[
          {text: strings.yes,onPress: () => { 

            const fireInfo={} 
            fireInfo['race/' + this.state.immediateInfo.uuid+"/raceInProgress"]=false;
            fireInfo['race/' + this.state.immediateInfo.uuid+"/driverPhone"]=null;
            update(ref(getDatabase(firebase)), fireInfo)
            if(this.state.valueGetRaceInP!=undefined) this.state.valueGetRaceInP(); 
          }},
          {text: strings.no, style:"cancel",onPress: () => {}}
          ],});

}

  navigateToGenerateBill= (forceNoShow) => {
              var calcDelay=this.state.infoRace.realRaceDate-((this.state.infoRace.arrivateDate>this.state.infoRace.raceDate)?this.state.infoRace.arrivateDate:this.state.infoRace.raceDate)
              console.log("calcDelay ="+calcDelay)

              if(forceNoShow!=true && (  (info.disableBill==true && this.state.immediateInfo.karhooProvider!=true) || (info.disableBillForBasic==true && this.state.privilegeDriver=="basic" && this.state.driver!=true ) || this.state.immediateInfo.taxiMode==true)){
                  const fireInfo={} 
                  fireInfo['race/' + this.state.immediateInfo.uuid+"/raceInProgress"]=false; 
                  fireInfo['race/' + this.state.immediateInfo.uuid+"/immediateMode"]=null; 
                  fireInfo['race/' + this.state.immediateInfo.uuid+"/dropOffDate"]=Date.parse(new Date()); 
                  if(info.disableBill==true || this.state.immediateInfo.taxiMode==true) fireInfo['race/' + this.state.immediateInfo.uuid+"/status"]="finish";
                  
                  update(ref(getDatabase(firebase)), fireInfo)

              } 
              else {
                
                var dataFinal=this.state.infoRace;

                if(forceNoShow!=true){
                    const fireInfo={} 
                    fireInfo['race/' + this.state.immediateInfo.uuid+"/dropOffDate"]=Date.parse(new Date()); 
                    update(ref(getDatabase(firebase)), fireInfo)
                } else dataFinal.noShow=true;
                
                dataFinal.driver=this.state.driver;
                dataFinal.partner=this.state.partner;
                dataFinal.privilegeDriver=this.state.privilegeDriver;
                dataFinal.hidePriceRaceForDriver=this.state.hidePriceRaceForDriver;

                var moneyID=(this.state.infoRace.moneyID!=undefined)?this.state.infoRace.moneyID:"eu";
                var money=this.findMoney(moneyID)
                dataFinal.money=money
                

                var driverPrice;
                var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 

                if(this.state.billMode=="double" || ( (this.state.immediateInfo.charge!=undefined || this.state.immediateInfo.deferredPayment==true || this.state.immediateInfo.karhooProvider==true) && this.state.billMode=="partnerCompany")){

                  var price=dataFinal.estimatePrice;
                  price=price.replace(money.symbole,'')
                  var n = price.indexOf("-");
                  if(n!=-1) {

                    var price1=parseFloat(price.substring(0,n))
                    var price2=parseFloat(price.substring(n+1,price.length))

                    if(this.state.addCommissionFixe===true && this.state.addCommissionFixeAmount>0){ price1-=this.state.addCommissionFixeAmount;price2-=this.state.addCommissionFixeAmount;}
                    if(this.state.addCommissionVariable===true && this.state.addCommissionVariableAmount>0) {price1=price1*((100-this.state.addCommissionVariableAmount)/100);price2=price2*((100-this.state.addCommissionVariableAmount)/100);}
                    
                    if(params.pricingView.commission>0) {price1=price1*((100-this.state.commission)/100);price2=price2*((100-this.state.commission)/100);}
                    price1=price1.toFixed(2);
                    price2=price2.toFixed(2);
                    driverPrice=price1+"-"+price2;


                  }else{
                    driverPrice=parseFloat(price);
                    if(this.state.addCommissionFixe===true && this.state.addCommissionFixeAmount>0) driverPrice-=this.state.addCommissionFixeAmount;
                    if(this.state.addCommissionVariable===true && this.state.addCommissionVariableAmount>0) driverPrice=driverPrice*((100-this.state.addCommissionFixeAmount)/100);
                    if(this.state.commission>0) driverPrice=driverPrice*((100-this.state.commission)/100);
                    driverPrice=driverPrice.toFixed(2);
                  }
                  if(dataFinal.forceDriverPrice!=undefined) driverPrice=dataFinal.forceDriverPrice;
                  driverPrice=((money.position=="left")?(money.symbole+" "):"")+driverPrice+((money.position=="right")?(money.symbole):"");
                }
                else {
                  driverPrice=dataFinal.estimatePrice;
                }

                dataFinal.driverPrice=driverPrice


                this.props.navigation.navigate("GenerateBill",{data:dataFinal,suggestedDelay:Math.round(calcDelay/60000),commission:{addCommissionFixe:this.state.addCommissionFixe,addCommissionFixeAmount:this.state.addCommissionFixeAmount, addCommissionVariable:this.state.addCommissionVariable,addCommissionVariableAmount:this.state.addCommissionVariableAmount,commissionDriver:this.state.commission, calculateCommission:(this.state.billMode=="double" || ( (this.state.immediateInfo.charge!=undefined || this.state.immediateInfo.deferredPayment==true) && this.state.billMode=="partnerCompany"))?true:false} })

              }

            }



  

  render() {
    this.opacityCloseButton = new Animated.Value(0);



    return (
      <StyleContext.Consumer>{style => 
       <NavigateView   ref={ref => (this._nativateView = ref)} styles={{drawer: {shadowOpacity: 0.3, shadowRadius: 2},}} >
       <View style={{flex:1,backgroundColor:style.backgroundColor}}>
        {(this.state.viewAdminMode==true) && <Admin purposeReturnValid={this.purposeReturnValid}  saveBook={this.saveBook} updateAfterBook={this.updateAfterBook} info={this.state} changeDate={this.changeDate} trajetMultiStop={this.trajetMultiStop} changeState={this.changeState} onChangeIntermediateStop={this.onChangeIntermediateStop} onChangeTo={this.onChangeTo} changeDuration={this.changeDuration} addPreviousSearch={this.addPreviousSearch} removePreviousSearch={this.removePreviousSearch} onChangeFrom={this.onChangeFrom} />}
        {this.state.trackingUUID!=undefined && <ScrollView style={{width:Dimensions.get('window').width,}}> 
              <BookingView contactMessage={() => { this.contactMessage(this.state.immediateInfo.driverPhone) }}  mode={(this.state.trackingUUID=="error")?"error":"liveBooking"} data={this.state.immediateInfo} style={{width:Dimensions.get('window').width*0.8, marginLeft:Dimensions.get('window').width*0.1}}/>
          </ScrollView>}

        {(this.state.viewAdminMode!=true && this.state.trackingUUID==undefined) && <Drawer

        tapToClose={true}
        close={this.closeControlPanel}
        onOpenStart={this._changeDrawerStateOpen}
        onCloseStart={this._changeDrawerStateClose}
        openDrawerOffset={((Dimensions.get('window').width>style.mobileSizeMax )?((Dimensions.get('window').width-style.minimizeWidth)/Dimensions.get('window').width):0.2)}
        ref={ref => (this._drawer = ref)}
        styles={{drawer: {shadowOpacity: 0.3, shadowRadius: 2},}}
        content={<DrawerContent ref={ref => (this.drawer = ref)} close={this.closeControlPanel} removeOldPricing={this.removeOldPricing} info={this.state} />}>
        <View style={{}}>


         
          


          {this.state.dispenser.enabled==true && <View style={{width:"100%", alignItems:"center"}}>
                {this.state.dispenser.step=="Start" && <View style={{width:"100%", alignItems:"center"}}>
                      <Image source={require("../assets/background.jpg")} style={{position:"absolute",height:Dimensions.get('window').height,width:Dimensions.get('window').width,resizeMode:"cover"}}/>

                      <View style={{ alignItems: 'center',marginTop:Dimensions.get('window').height*0.2,width:Dimensions.get('window').width*0.8}}>
                        <TouchableHighlight style={{ }} underlayColor={"#FFFFFF00"} onPress={() => { var newDate=new Date(); var disp=this.state.dispenser; disp.counter=(disp.counter==undefined)?0:disp.counter+1; if(disp.counterDate!=undefined && !(Date.parse(newDate)<(Date.parse(disp.counterDate)+10000))) {disp.counter=1; disp.counterDate=newDate} else if(disp.counter>4) {console.log("ah"); this.disableDispenser();disp.counter=0} else disp.counterDate=newDate; console.log(disp); this.setState({dispenser:disp})  }}> 
                            <Image source={require("../assets/welcome_logo.png")} style={{height:Dimensions.get('window').height*0.2,resizeMode:"contain"}}/>
                        </TouchableHighlight>
                      </View>


                      {this.state.waitDispenserResult!=true && <MavButton style={{marginTop:Dimensions.get('window').height*0.2}} maxiMode={true} text={strings.BookDriver} onlyButton={true} onPress={()=>{
                           this.trajetToDestination();
                      }}/>}



                </View>}


                {this.state.dispenser.step=="Destination" && <View style={{width:"100%", alignItems:"center"}}>

                  <MavButton style={{marginTop:Dimensions.get('window').height*0.2}} maxiMode={true} text={strings.BookDriver} onlyButton={true} onPress={()=>{
                }}/>

                </View>}



          </View>}


           {(this.state.dispenser.enabled!=true) && <MapView onLongPress={(e) => {
            var locInfo=e.nativeEvent.coordinate;

              if( (this.state.waitingSettings==false || this.state.waitingPersonnalInfo==false) && this.state.dispenser.enabled!=true && this.state.immediateMode=="" && (this.state.partner==false || (this.state.privilegeDriver!="basic" && this.state.privilegeDriver!="standard" ) || this.state.basicDriverAddRace==true )    ) this.alert.onAlert({title:strings.whatDoing,buttons:[
              {text: strings.startFromHere,onPress: () => {this.clickOnCard("start",locInfo) }},  
              {text: strings.goToHere,onPress: () => {this.clickOnCard("to",locInfo)}},
              {text: strings.cancel, style:"cancel",onPress: () => {}}
              ] })

            }} onPress={(e) => { if(this.state.viewSpecificPOI!=false) this.setState({viewSpecificPOI:false})  }} showsPointsOfInterest={(this.state.seePOIMap==true && Platform.OS!="web")?false:true} defaultZoom={info.initialRegion.defaultZoom}  showsCompass={false} initialRegion = {info.initialRegion}  style={{alignSelf: 'stretch',height: Dimensions.get('window').height,}} region={this.state.mapRegion} onRegionChangeComplete={(value) => this._handleMapRegionChange(value)} customMapStyle={((Platform.OS!="ios" && style.mode=="dark")?([{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]}, {"featureType": "poi","stylers": [{"visibility": (this.state.seePOIMap==true)?"off":"on"}]} ,{"featureType": "transit","stylers": [{"visibility": (this.state.seePOIMap==true)?"off":"on"}]} , {"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}]): (  (Platform.OS!="ios" && style.mode=="light")? ([{"featureType": "poi","stylers": [{"visibility": (this.state.seePOIMap==true)?"off":"on"}]} ,{"featureType": "transit","stylers": [{"visibility": (this.state.seePOIMap==true)?"off":"on"}]}])  :  ([])    )             ) }>

            {(Platform.OS!="web" && this.state.markerGeo!={} && this.state.markerGeo.coordinates!=undefined && this.state.markerGeo.coordinates.accuracy!=undefined) && <MapView.Circle key={(this.state.markerGeo.coordinates.latitude).toString()+(this.state.markerGeo.coordinates.longitude).toString()}  center={{latitude: this.state.markerGeo.coordinates.latitude,longitude: this.state.markerGeo.coordinates.longitude}} strokeColor={"rgba(21,162,255,0.2)"} fillColor={"rgba(21,162,255,0.2)"} radius={this.state.markerGeo.coordinates.accuracy} />}

            

            {(this.state.seePOIMap==true && Platform.OS!="web" && this.state.mapZoom>12) && Object.keys(this.state.favoriteGlobal).map(marker => (
              <MapView.Marker coordinate={this.state.favoriteGlobal[marker].coordinates} onPress={() => { if( (this.state.waitingSettings==false || this.state.waitingPersonnalInfo==false) && this.state.dispenser.enabled!=true && (this.state.manager==false || this.state.managerInfo.dispatch==true ) && this.state.immediateMode=="" && (this.state.partner==false || (this.state.privilegeDriver!="basic" && this.state.privilegeDriver!="standard" ) || this.state.basicDriverAddRace==true )    ) this.setState({viewSpecificPOI:false},() =>{ this.setState({viewSpecificPOI:this.state.favoriteGlobal[marker] })  })  }} >
              
                <View style={{alignItems:"center",justifyContent:"center"}}>  
                      <View style={{width:22, height:22, backgroundColor:((iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor!=undefined)?iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor:"#EFEFEF"), alignItems:"center", justifyContent:"center", borderRadius:11,shadowOpacity: 1, shadowColor:(style.mode=="dark")?'#000':"#FFFFFF", shadowRadius: 1,shadowOffset: {height: 0,width: 0},elevation: 1 }}>
                            <Image source={(this.state.favoriteGlobal[marker].icon!=undefined && iconTrajet[this.state.favoriteGlobal[marker].icon]!=undefined)?( (style.mode=="dark")?iconTrajet[this.state.favoriteGlobal[marker].icon].iconDark:iconTrajet[this.state.favoriteGlobal[marker].icon].iconLight ) : ((style.mode=="dark")? require('../assets/favorite/pin_white.png')  :require('../assets/favorite/pin_black.png'))} style={{resizeMode:"contain",height:13,width:13}}/>
                      </View>
                      <View style={{width:80,alignItems:"center"}}>
                        <Text numberOfLines={2} style={{position:"absolute",fontWeight: 'bold', textShadowColor: (style.mode=="dark")?'#000':"#FFFFFF", textShadowOffset: { width: 0, height: 0 }, textShadowRadius: 5,color: ((iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor!=undefined)?iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor:"#EFEFEF"),fontSize: style.textInputFontSize*0.7,textAlign: 'center'}}>{this.state.favoriteGlobal[marker].userDescription}</Text>
                        <Text numberOfLines={2} style={{position:"absolute",fontWeight: 'bold', textShadowColor: (style.mode=="dark")?'#000':"#FFFFFF", textShadowOffset: { width: 0.5, height: 0.5 }, textShadowRadius: 1,color: ((iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor!=undefined)?iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor:"#EFEFEF"),fontSize: style.textInputFontSize*0.7,textAlign: 'center'}}>{this.state.favoriteGlobal[marker].userDescription}</Text>
                        <Text numberOfLines={2} style={{position:"absolute",fontWeight: 'bold', textShadowColor: (style.mode=="dark")?'#000':"#FFFFFF", textShadowOffset: { width: -0.5, height: -0.5 }, textShadowRadius: 1,color: ((iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor!=undefined)?iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor:"#EFEFEF"),fontSize: style.textInputFontSize*0.7,textAlign: 'center'}}>{this.state.favoriteGlobal[marker].userDescription}</Text>
                        <Text numberOfLines={2} style={{position:"absolute",fontWeight: 'bold', textShadowColor: (style.mode=="dark")?'#000':"#FFFFFF", textShadowOffset: { width: 0.5, height: -0.5 }, textShadowRadius: 1,color: ((iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor!=undefined)?iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor:"#EFEFEF"),fontSize: style.textInputFontSize*0.7,textAlign: 'center'}}>{this.state.favoriteGlobal[marker].userDescription}</Text>
                        <Text numberOfLines={2} style={{position:"absolute",fontWeight: 'bold', textShadowColor: (style.mode=="dark")?'#000':"#FFFFFF", textShadowOffset: { width: -0.5, height: 0.5 }, textShadowRadius: 1,color: ((iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor!=undefined)?iconTrajet[this.state.favoriteGlobal[marker].icon].mapColor:"#EFEFEF"),fontSize: style.textInputFontSize*0.7,textAlign: 'center'}}>{this.state.favoriteGlobal[marker].userDescription}</Text>

                      </View>
                  </View>
              
            </MapView.Marker>
            ))}



            {this.state.markers.map(marker => (
              <MapView.Marker coordinate={marker.coordinates}  icon={(Platform.OS=="web")?require('../assets/pin.png'):null} >
                {(Platform.OS!="web") && <Image
                    source={require('../assets/pin.png')}
                    style={{resizeMode:"contain",height:(this.state.markerGeo=={} || this.state.markerGeo.coordinates==undefined || (this.state.markerGeo.coordinates.latitude!=marker.coordinates.latitude && this.state.markerGeo.coordinates.longitude!=marker.coordinates.longitude))?20:0,width:20}}
                />}
            </MapView.Marker>
            ))}






            {(Platform.OS!="web" && this.state.immediateMode=="" && (this.state.driver==true || this.state.partner==true) && this.state.viewMajorationDynamicDriver==true && this.state.globalMajorationReady==true) && this.state.classic.map(marker => (

            	  <View>
            	  	




            	  	{( ( (this.state.majoration.dynamic!=undefined && this.state.majoration.dynamic>1 ) || (marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1) ) &&       marker.latitude!="" && marker.radius!="" && marker.zoneDrawed!=true ) && <MapView.Circle key={(marker.latitude).toString()+(marker.longitude).toString()+this.state.radius}  center={{latitude: marker.latitude,longitude: marker.longitude}} strokeColor={"rgba(100,0,0,1)"} fillColor={"rgba(100,0,0,0.5)"} radius={parseFloat(marker.radius)*1000} />}

            	  	{ ( (this.state.majoration.dynamic!=undefined && this.state.majoration.dynamic>1 ) || (marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1) ) && (marker.latitude!="" && marker.zone!=undefined && marker.zone.length>0 && marker.zoneDrawed==true) && <MapView.Polygon coordinates={marker.zone} strokeColor={"rgba(100,0,0,1)"}  fillColor={"rgba(100,0,0,0.5)"}   />}


            	  	{( (this.state.majoration.dynamic!=undefined && this.state.majoration.dynamic>1 ) || (marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1) ) && <MapView.Marker coordinate={{latitude: marker.latitude,longitude: marker.longitude}}>
                     
                       <Text style={{fontSize:30}}>{"x"+ ((marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1 && (this.state.majoration.dynamic==undefined || this.state.majoration.dynamic<marker.majoration.dynamic) )?marker.majoration.dynamic:this.state.majoration.dynamic)}</Text>
                     

                     </MapView.Marker>}

            	  	</View>
        

            ))}

            {(Platform.OS!="web" && this.state.immediateMode=="" && (this.state.driver==true || this.state.partner==true) && this.state.viewMajorationDynamicDriver==true && this.state.globalMajorationReady==true) && this.state.forfait.map(marker => (

            	  <View>
              		
              		{( ( (this.state.majoration.dynamic!=undefined && this.state.majoration.dynamic>1 ) || (marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1) ) && marker.startLatitude!="" && marker.startRadius!="" && marker.startZoneDrawed==false) && <MapView.Circle key={(marker.startLatitude).toString()+(marker.startLongitude).toString()+marker.startRadius} center={{latitude: marker.startLatitude,longitude: marker.startLongitude}} strokeColor={"rgba(100,0,0,1)"} fillColor={"rgba(100,0,0,0.5)"} radius={parseFloat(marker.startRadius)*1000} />}
              		{(( (this.state.majoration.dynamic!=undefined && this.state.majoration.dynamic>1 ) || (marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1) ) &&  marker.startLatitude!="" && marker.startZone!=undefined && marker.startZone.length>0 && marker.startZoneDrawed==true) && <MapView.Polygon coordinates={marker.startZone} strokeColor={"rgba(100,0,0,1)"}  fillColor={"rgba(100,0,0,0.5)"}   />}
            	  	
            	  	{( (this.state.majoration.dynamic!=undefined && this.state.majoration.dynamic>1 ) || (marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1) ) && <MapView.Marker coordinate={{latitude: marker.startLatitude,longitude: marker.startLongitude}}>
                       <Text style={{fontSize:30}}>{"x"+ ((marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1 && (this.state.majoration.dynamic==undefined || this.state.majoration.dynamic<marker.majoration.dynamic) )?marker.majoration.dynamic:this.state.majoration.dynamic)}</Text>
                     </MapView.Marker>}


                     {( ( (this.state.majoration.dynamic!=undefined && this.state.majoration.dynamic>1 ) || (marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1) ) && marker.endLatitude!="" && marker.endRadius!="" && marker.endZoneDrawed==false ) && <MapView.Circle key={(marker.endLatitude).toString()+(marker.endLongitude).toString()+marker.endRadius} center={{latitude: marker.endLatitude,longitude: marker.endLongitude}} strokeColor={"rgba(100,0,0,1)"} fillColor={"rgba(100,0,0,0.5)"} radius={parseFloat(marker.endRadius)*1000} />}
                     {(( (this.state.majoration.dynamic!=undefined && this.state.majoration.dynamic>1 ) || (marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1) ) && marker.endLatitude!="" && marker.endZone!=undefined && marker.endZone.length>0 && marker.endZoneDrawed==true) && <MapView.Polygon coordinates={marker.endZone} strokeColor={"rgba(100,0,0,1)"}  fillColor={"rgba(100,0,0,0.5)"}   />}
                     
                     {( (this.state.majoration.dynamic!=undefined && this.state.majoration.dynamic>1 ) || (marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1) ) && <MapView.Marker coordinate={{latitude: marker.endLatitude,longitude: marker.endLongitude}}>
                       <Text style={{fontSize:30}}>{"x"+ ((marker.majoration!=undefined && marker.majoration.dynamic!=undefined && marker.majoration.dynamic>1 && (this.state.majoration.dynamic==undefined || this.state.majoration.dynamic<marker.majoration.dynamic) )?marker.majoration.dynamic:this.state.majoration.dynamic)}</Text>
                     </MapView.Marker>}

            	  	</View>
        

            ))}
            
            {(this.state.immediateMode!="" && this.state.immediateInfo!=undefined && this.state.immediateInfo!="" && this.state.immediateMode!="driverArrivate" && this.state.myDriverAnimate!=undefined && this.state.myDriverAnimate!="" && this.state.mapZoom>10) && 

               <MapView.Polyline
                    coordinates={[...this.state.myDriverAnimate.coordinate]}
                    path={[...this.state.myDriverAnimate.coordinate]}
                    strokeWidth={6}
                    strokeColor={style.backgroundColorContrast}
                    geodesic={true}
                    options={{strokeColor: style.color1,strokeWidth:6}}
                />

          }

          {(this.state.immediateMode!="" && this.state.immediateInfo!=undefined && this.state.immediateInfo!="" && this.state.immediateMode!="driverArrivate" && this.state.geolocDriverPreciseCoord!=undefined && this.state.geolocDriverPreciseCoord!="" && this.state.mapZoom>10) && 

               <MapView.Polyline
                    coordinates={[...this.state.geolocDriverPreciseCoord]}
                    path={[...this.state.geolocDriverPreciseCoord]}
                    strokeWidth={6}
                    strokeColor={style.color1}
                    geodesic={true}
                    options={{strokeColor: style.color1,strokeWidth:6}}
                />

          }


          


            {(this.state.immediateMode!="" && this.state.immediateInfo!=undefined && this.state.immediateMode!="driverArrivate" && this.state.immediateInfo!="" && this.state.myDriverAnimate!=undefined && this.state.myDriverAnimate!="" && this.state.myDriverAnimateBefore!=undefined && this.state.mapZoom>10) && 

               <MapView.Polyline
                    coordinates={[...this.state.myDriverAnimateBefore]}
                    path={[...this.state.myDriverAnimateBefore]}
                    strokeWidth={6}
                    strokeColor={style.color1}
                    geodesic={true}
                    options={{strokeColor: style.color1,strokeWidth:6}}
                />

          }

            <MapView.Polyline
              coordinates={[...this.state.coords]}
              path={[...this.state.coords]}
              strokeWidth={6}
              strokeColor={style.color1}
              geodesic={true}
              options={{strokeColor: style.color1,strokeWidth:6}}


            />

            {this.state.driverNavigateTo!="" && <MapView.Polyline
              coordinates={[...this.state.driverNavigateTo]}
              strokeWidth={6}
              strokeColor={style.color1}
            />}


            {this.state.driverNavigateTo!="" && <MapView.Marker icon={(Platform.OS=="web")?require('../assets/pin.png'):null} coordinate={this.state.driverNavigateTo[this.state.driverNavigateTo.length-1]} >
                {(Platform.OS!="web") && <Image
                    source={require('../assets/pin.png')}
                    style={{resizeMode:"contain",height:20,width:20}}
                />}
            </MapView.Marker>}



            {(Platform.OS!="web" &&  this.state.mapZoom>10 && (this.state.hideOtherCarIfRaceInProgress==false || this.state.immediateMode=="" || this.state.immediateMode=="findDriver")) && this.state.markersCars.map((marker,key) => (
              <MapView.Marker.Animated coordinate={marker.coordinate} >
                 <Image
                  source={require('../assets/car.png')}
                  style={{position:"absolute",resizeMode:"contain",height:30,width:30,transform: [{rotate: ((this.state.animateCarsList[key].coordinate[this.state.animateCarsList[key].actual]!=undefined && this.state.animateCarsList[key].coordinate[this.state.animateCarsList[key].actual].rotation!=undefined)?this.state.animateCarsList[key].coordinate[this.state.animateCarsList[key].actual].rotation:0)+'deg'}]}}
                />
              </MapView.Marker.Animated>
              
            ))}



            



            {(this.state.myDriver!=undefined && this.state.myDriver!="" && this.state.myDriver.coordinate!=undefined && this.state.mapZoom>10) && 
              <MapView.Marker.Animated coordinate={this.state.myDriver.coordinate} >
                <View style={{left:-20, top:-20}}>
                    <Image source={(this.state.immediateInfo!="" && this.state.immediateInfo.carName!=undefined && this.state.picturesCar.carUsed[this.state.immediateInfo.carName]!=undefined && this.state.picturesCar.carUsed[this.state.immediateInfo.carName].above!=undefined && this.state.picturesCar.carAvailable[this.state.picturesCar.carUsed[this.state.immediateInfo.carName].above]!=undefined)?{uri:"https://firebasestorage.googleapis.com/v0/b/"+info.firebaseProjectID+".appspot.com/o/assets%2F"+this.state.picturesCar.carUsed[this.state.immediateInfo.carName].above+"%2Fpicture.png?alt=media"}   :require('../assets/car.png')} style={{position:"absolute",resizeMode:"contain",height:40,width:40,transform: [{rotate:((this.state.myDriverAnimate==undefined && this.state.myDriver.coordinate.rotation!=undefined)?this.state.myDriver.coordinate.rotation:((this.state.myDriverAnimate!=undefined && this.state.myDriverAnimate!="" && this.state.myDriverAnimate.coordinate[this.state.myDriverAnimate.actual]!=undefined && this.state.myDriverAnimate.coordinate[this.state.myDriverAnimate.actual].rotation!=undefined)?this.state.myDriverAnimate.coordinate[this.state.myDriverAnimate.actual].rotation:0))+'deg'}]}} />
                    {(this.state.driverApproachingColor!=undefined && this.state.driverApproachingColor!="") && <Image source={require('../assets/car.png')} style={{position:"absolute",tintColor: this.state.driverApproachingColor,resizeMode:"contain",height:40,width:40,transform: [{rotate: ((this.state.myDriverAnimate!=undefined && this.state.myDriverAnimate!="" && this.state.myDriverAnimate.coordinate[this.state.myDriverAnimate.actual]!=undefined && this.state.myDriverAnimate.coordinate[this.state.myDriverAnimate.actual].rotation!=undefined)?this.state.myDriverAnimate.coordinate[this.state.myDriverAnimate.actual].rotation:0)+'deg'}]}} />}
                </View>

                 </MapView.Marker.Animated>
              
            }


            {(this.state.mapZoom>10 && (this.state.hideOtherCarIfRaceInProgress==false || this.state.immediateMode=="" || this.state.immediateMode=="findDriver"))  && this.state.markersCarsReal.map((marker,key) => (
              <View>
              {(getAuth(firebase).currentUser==undefined || getAuth(firebase).currentUser.uid!=marker.uuid) &&  <MapView.Marker icon={(Platform.OS=="web")?require('../assets/car.png'):null}
                onPress={() => {if(marker.name!=undefined) this.setState({markerDriverDetail:marker})}}
                coordinate={marker}>
                 
                {(Platform.OS!="web") && 

                  <View style={{alignItems:"center"}}>
                    {marker.status!=undefined && <View style={{width:8, height:8, borderRadius:4, marginBottom:4, backgroundColor:(marker.status=="online")?"#4F8F00":( (marker.status=="raceInProgress")?"#FEA812":style.backgroundColorContrast), shadowOpacity: 1, shadowColor:(style.mode=="dark")?'#000':"#FFFFFF", shadowRadius: 1,shadowOffset: {height: 0,width: 0},elevation: 1 }}/>}

                    <View style={{width:30, height:30}}>
                        <Image source={ (marker.carModel!=undefined && this.state.picturesCar.carUsed[marker.carModel]!=undefined && this.state.picturesCar.carUsed[marker.carModel].above!=undefined && this.state.picturesCar.carAvailable[this.state.picturesCar.carUsed[marker.carModel].above]!=undefined)?{uri:"https://firebasestorage.googleapis.com/v0/b/"+info.firebaseProjectID+".appspot.com/o/assets%2F"+this.state.picturesCar.carUsed[marker.carModel].above+"%2Fpicture.png?alt=media"}   :require('../assets/car.png')} style={{position:"absolute",resizeMode:"contain",height:30,width:30}}  />
                        {(this.state.carDriverColor!=undefined && this.state.carDriverColor!="") && <Image source={require('../assets/car.png')} style={{position:"absolute",tintColor: this.state.carDriverColor, resizeMode:"contain",height:30,width:30}}  />}
                    </View>

                    {marker.name!=undefined && <Text style={{marginTop:4,width:50,fontWeight: 'bold', textShadowColor: (style.mode=="dark")?'#000':"#FFFFFF", color:(style.mode=="dark")?'#FFFFFF':"#000000", textShadowOffset: { width: 0.5, height: 0.5 }, textShadowRadius: 1,fontSize: style.textInputFontSize*0.6,textAlign: 'center'}}>{marker.name}</Text>}
                    {marker.name!=undefined && <Text numberOfLines={1} style={{width:50,fontWeight: 'bold', textShadowColor: (style.mode=="dark")?'#000':"#FFFFFF", color:(style.mode=="dark")?'#FFFFFF':"#000000", textShadowOffset: { width: 0.5, height: 0.5 }, textShadowRadius: 1,fontSize: style.textInputFontSize*0.6,textAlign: 'center'}}>{marker.lastName}</Text>}
                    

                </View>}
                  
              </MapView.Marker>}
              </View>
              
            ))}


            {(Platform.OS!="web" && this.state.markerGeo!={} && this.state.markerGeo.coordinates!=undefined && this.state.immediateMode!="raceInProgress") && <MapView.Marker coordinate={this.state.markerGeo.coordinates} >
              <Image
                source={require('../assets/pinGeo.png')}
                style={{resizeMode:"contain",height:20,width:20}}
              />
            </MapView.Marker>}

          </MapView>}
  


          

          
        </View>


        {this.state.controlePanelOpen!=true && <View style={{ marginTop:0, width:(Dimensions.get('window').width>style.mobileSizeMax)?style.minimizeWidth+30:Dimensions.get('window').width, position:((Dimensions.get('window').width>style.mobileSizeMax) || backgroundStyle==false)?"absolute":"relative", }}>

            {(Platform.OS=="web" && !(Dimensions.get('window').width>style.mobileSizeMax)) && <MavNavigationMinimize title={strings.maps } 
                headerLeft={ (<View>
                    <TouchableHighlight style={{ marginRight:10}} underlayColor={"#FFFFFF00"} onPress={() => {if(getAuth(firebase).currentUser==undefined) this._createAccount(); else this._openDrawer();}}>
                    <View>
                      {(getAuth(firebase).currentUser!=undefined) && <Image source={(style.mode=="dark")?require('../assets/more_dark.png'):require('../assets/more_light.png')} style={{marginLeft:  Dimensions.get('window').width * 0.05, width: 25, height: 25 }}/>}
                      {(getAuth(firebase).currentUser==undefined) && <Image source={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} style={{marginLeft:  Dimensions.get('window').width * 0.05, width: 25, height: 25 }}/>}
                    </View>
                    </TouchableHighlight>
                </View>)} 
            />}










            
            {( (this.state.waitingSettings==false || this.state.waitingPersonnalInfo==false) && this.state.dispenser.enabled!=true && (this.state.manager==false || this.state.managerInfo.dispatch==true ) && this.state.immediateMode=="" && (this.state.partner==false || (this.state.privilegeDriver!="basic" && this.state.privilegeDriver!="standard" ) || this.state.basicDriverAddRace==true )    ) && <View style={(backgroundStyle==true)?{backgroundColor:style.color1, position:"absolute",bottom:((this.state.ads.length>0)?(75+this.state.adsMarginBottom):0)+((this.state.estimatePriceGo != '' || this.state.estimatePriceGoTaxi!="")?(115+style.buttonHeight+(this.state.estimatePriceGo.length+this.state.estimatePriceGoTaxi.length+1)*style.textInputHeight):85),height:style.textInputHeight*3+45,width:"100%"}:{}}>

              {this.state.multiStop==true && <TouchableHighlight underlayColor={"#FFFFFF00"} onPress={() => {this.setState({viewMultiStop:true}); if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true, title: strings.trip,  headerLeft: props => <HeaderLeft goBackEnabled={true} hideMultiStop={this.hideMultiStop}  /> }) }}>
                  <MavTextInput backgroundColor={(backgroundStyle==true)?style.color1:undefined} shadow={!backgroundStyle} style={{marginTop:15}} enableNext={!backgroundStyle} marginSize={15} textExplicationBold={!backgroundStyle} disableLine={!backgroundStyle} textInputColor={(backgroundStyle==true)?"#FFFFFF":undefined} textInputLineColor={"#FFFFFF"} textExplication={strings.whereWantToGo} disabledText={true} iconClassicSmall={true} iconClassic={ (style.mode=="dark")? require('../assets/favorite/pin_white.png')  :require('../assets/favorite/pin_black.png')     } textExplicationMini={(this.state.mapFrom.userDescription == '' || this.state.mapTo.userDescription=="")? undefined: (this.state.mapFrom.userDescription+" > "+( (this.state.mapIntermediate.length>0)? "... > " :"" )+((this.state.mapTo.userDescription!=undefined)?this.state.mapTo.userDescription: ((((Math.floor(this.state.provisionDuration/3600))<10)?"0":"")+Math.floor(this.state.provisionDuration/3600)+":"+((Math.floor((this.state.provisionDuration%3600)/60)<10)?"0":"")+Math.floor((this.state.provisionDuration%3600)/60) )             ))}  />
              </TouchableHighlight>} 

              {this.state.multiStop!=true && <TouchableHighlight underlayColor={"#FFFFFF00"}
                    onPress={() => {
                      if (this.state.lock==false) {
                        this.setState({lock:true})
                        timer.setTimeout(generateUUID(), () => {this.setState({lock:false})}, 2000);
                        if(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax ) {this.setState({viewTrajet:"from",controlePanelOpen:true});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false });}
                        else this.props.navigation.navigate('Trajet', {favorite:Object.assign(this.state.previousSearchDisplay,this.state.favorite, this.state.favoriteGlobal,),longitude: this.state.longitude,latitude: this.state.latitude,addPreviousSearch: this.addPreviousSearch, removePreviousSearch:this.removePreviousSearch,onChangeFrom: this.onChangeFrom,mapTo: this.state.mapTo,mapFrom: this.state.mapFrom,});
                      }
                    }}><MavTextInput backgroundColor={(backgroundStyle==true)?style.color1:undefined} shadow={!backgroundStyle} style={{marginTop:15}} enableNext={!backgroundStyle} marginSize={15} textExplicationBold={!backgroundStyle} disableLine={!backgroundStyle} textInputColor={(backgroundStyle==true)?"#FFFFFF":undefined} textInputLineColor={"#FFFFFF"} textExplication={(backgroundStyle===true)?(this.state.mapFrom.userDescription == ''? strings.chooseStart: this.state.mapFrom.userDescription):strings.selectFromPoint} disabledText={true} iconClassicSmall={true} iconClassic={(backgroundStyle==true)?require('../assets/pinRoundGreen.png'):((style.mode=="dark")?( (this.state.mapFrom.iconDark!=undefined)?this.state.mapFrom.iconDark: require('../assets/favorite/pin_white.png')   ): ( (this.state.mapFrom.iconLight!=undefined)?this.state.mapFrom.iconLight: require('../assets/favorite/pin_black.png')   )   )     } textExplicationMini={(backgroundStyle===true)?undefined:(this.state.mapFrom.userDescription == ''? strings.chooseStart: this.state.mapFrom.userDescription)}  />
              </TouchableHighlight>}


              {this.state.multiStop!=true && <TouchableHighlight underlayColor={"#FFFFFF00"} onPress={() => {this.trajetToDestination();}}>
                    <MavTextInput backgroundColor={(backgroundStyle==true)?style.color1:undefined} shadow={!backgroundStyle} style={{marginTop:5}} enableNext={!backgroundStyle} marginSize={15} textExplicationBold={!backgroundStyle} disableLine={!backgroundStyle} textInputColor={(backgroundStyle==true)?"#FFFFFF":undefined} textInputLineColor={"#FFFFFF"} textExplication={(backgroundStyle===true)?((this.state.durationSelected==true)? (  (this.state.provisionDuration == '')? ((info.disableProvision==true)?strings.chooseDestination:strings.chooseDestinationOrDuration)   : ( strings.duration+" : "+(((Math.floor(this.state.provisionDuration/3600))<10)?"0":"")+Math.floor(this.state.provisionDuration/3600)+":"+((Math.floor((this.state.provisionDuration%3600)/60)<10)?"0":"")+Math.floor((this.state.provisionDuration%3600)/60) )     )  : ( this.state.mapTo.userDescription == ''? ((info.disableProvision==true)?strings.chooseDestination:strings.chooseDestinationOrDuration): this.state.mapTo.userDescription )):((info.disableProvision==true)?strings.destination:strings.destinationOrDuration)} disabledText={true} iconClassicSmall={true} iconClassic={(backgroundStyle==true)?require('../assets/pinRoundRed.png'):( (this.state.durationSelected==true)?( (style.mode=="dark")?require('../assets/favorite/chronometer_white.png'):require('../assets/favorite/chronometer_black.png')  ): ((this.state.mapTo.iconLight!=undefined)?( (style.mode=="dark")?this.state.mapTo.iconDark:this.state.mapTo.iconLight  ) :(  (style.mode=="dark")?require('../assets/favorite/pin_white.png'):require('../assets/favorite/pin_black.png')  ) ) )} textExplicationMini={(backgroundStyle===true)?undefined:((this.state.durationSelected==true)? (  (this.state.provisionDuration == '')? ((info.disableProvision==true)?strings.chooseDestination:strings.chooseDestinationOrDuration)   : ( strings.duration+" : "+(((Math.floor(this.state.provisionDuration/3600))<10)?"0":"")+Math.floor(this.state.provisionDuration/3600)+":"+((Math.floor((this.state.provisionDuration%3600)/60)<10)?"0":"")+Math.floor((this.state.provisionDuration%3600)/60) )     )  : ( this.state.mapTo.userDescription == ''? ((info.disableProvision==true)?strings.chooseDestination:strings.chooseDestinationOrDuration): this.state.mapTo.userDescription ))} />
              </TouchableHighlight>}



              <TouchableHighlight underlayColor={"#FFFFFF00"} onPress={() => {  this.selectDate() }}>
                  <MavTextInput backgroundColor={(backgroundStyle==true)?style.color1:undefined} shadow={!backgroundStyle} style={{marginTop:5, marginBottom:(backgroundStyle==true)?15:0}} enableNext={!backgroundStyle} marginSize={15} textExplicationBold={!backgroundStyle} textInputColor={(backgroundStyle==true)?"#FFFFFF":undefined} textInputLineColor={"#FFFFFF"} disableLine={(backgroundStyle==false || (this.state.estimatePriceGo == '' && this.state.estimatePriceGoTaxi=="")) } textExplication={(backgroundStyle===true)?((this.state.immediate==true)?strings.asap:((this.state.date=="")?strings.chooseDate:this.state.date)):strings.dateAndHour} disabledText={true} iconClassicSmall={true} iconClassic={(style.mode=="dark" || backgroundStyle==true)?require('../assets/calendar_white.png'):require('../assets/calendar_black.png') } accessibilityLabelMini={(backgroundStyle===true)?undefined:((this.state.immediate==true)?strings.asap:((this.state.date=="")?strings.chooseDate: (new Date(this.state.integerDate).getDate()+" "+strings.monthList[new Date(this.state.integerDate).getMonth()]+" "+strings.at+" "+new Date(this.state.integerDate).getHours()+" "+strings.hour+" "+new Date(this.state.integerDate).getMinutes()+" "+strings.minute)  ))}  textExplicationMini={(backgroundStyle===true)?undefined:((this.state.immediate==true)?strings.asap:((this.state.date=="")?strings.chooseDate:this.state.date))}  />
              </TouchableHighlight>

            </View>}

            {(this.state.controlePanelOpen!=true && Platform.OS=="web"  && (Dimensions.get('window').width>style.mobileSizeMax)) && <View style={{ marginLeft:Dimensions.get('window').width-Dimensions.get('window').height*0.10-10,  marginTop:10,position:"absolute"}}>
              <TouchableHighlight underlayColor={"#FFFFFF00"} onPress={() => {if(getAuth(firebase).currentUser==undefined) this._createAccount(); else this._openDrawer();}} > 

                <View style={{position:"absolute", backgroundColor:style.backgroundColor, alignItems:"center", justifyContent:"center",width:Dimensions.get('window').height*0.10, height:Dimensions.get('window').height*0.10, borderWidth:3, borderColor:"#FFFFFF", borderRadius: Dimensions.get('window').height*0.05,}} >
                    {(getAuth(firebase).currentUser!=undefined) && <Image source={(style.mode=="dark")?require('../assets/more_dark.png'):require('../assets/more_light.png')} style={{height:"65%",width:"65%",resizeMode:"cover", }}/>}
                  {(getAuth(firebase).currentUser==undefined) && <Image source={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} style={{height:"65%",width:"65%",resizeMode:"cover", }}/>}
                
                </View>
            </TouchableHighlight></View>}

        </View>}

        {(this.state.controlePanelOpen!=true && Platform.OS=="web" &&  (Dimensions.get('window').width>style.mobileSizeMax)) && <View style={{ marginLeft:Dimensions.get('window').width-Dimensions.get('window').height*0.10-10,  marginTop:10,position:"absolute"}}>
          <TouchableHighlight underlayColor={"#FFFFFF00"} onPress={() => {if(getAuth(firebase).currentUser==undefined) this._createAccount(); else this._openDrawer();}} > 

            <View style={{position:"absolute", backgroundColor:style.backgroundColor, alignItems:"center", justifyContent:"center",width:Dimensions.get('window').height*0.10, height:Dimensions.get('window').height*0.10, borderWidth:3, borderColor:"#FFFFFF", borderRadius: Dimensions.get('window').height*0.05,}} >
                {(getAuth(firebase).currentUser!=undefined) && <Image source={(style.mode=="dark")?require('../assets/more_dark.png'):require('../assets/more_light.png')} style={{height:"65%",width:"65%",resizeMode:"cover", }}/>}
              {(getAuth(firebase).currentUser==undefined) && <Image source={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} style={{height:"65%",width:"65%",resizeMode:"cover", }}/>}
            
            </View>
        </TouchableHighlight></View>}



        
        

        
        {(backgroundStyle!=true   && this.state.dispenser.enabled!=true &&  this.state.estimatePriceGo == '' && this.state.estimatePriceGoTaxi=="" && this.state.immediateMode=="")  && <TouchableHighlight style={{position: 'absolute',width: 50,height: 50,backgroundColor: style.backgroundColor,bottom: (this.state.ads.length>0)?(75+this.state.adsMarginBottom):10,right:10,borderRadius: 25,justifyContent: 'center', alignItems:'center',}} underlayColor={'#FFFFFFF0'}  onPress={() => {  this.updatePosition();}}>
          
         

          <Image source={(style.mode=="dark")?require('../assets/favorite/target_white.png'):require('../assets/favorite/target_black.png')} style={{ width: 35, height: 35 }}/>
        </TouchableHighlight>}


        {this.state.ads.length>0 && <View style={{position: 'absolute',width: Dimensions.get('window').width,height: 65+this.state.adsMarginBottom,backgroundColor: style.backgroundColor,bottom: 0,alignItems: 'center', shadowOpacity: 0.3,shadowRadius: 2,shadowOffset: {height: 0,width: 0},elevation: 1}}>
          <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.clickOnAdd(this.state.ads[this.state.adsSelected],false)     }}>
            <Image resizeMode='contain' source={{uri:this.state.ads[this.state.adsSelected].file}} style={{ height:65,width:Dimensions.get('window').width}}/>
          </TouchableHighlight>
        </View>}






         {((this.state.estimatePriceGo != '' || this.state.estimatePriceGoTaxi!="") && !( (this.state.viewBook==true || this.state.viewTrajet!=false) && this.state.dispenser.enabled==true) && this.state.immediateMode=="" && this.state.controlePanelOpen!=true) && <View style={{marginLeft:((Dimensions.get('window').width>style.mobileSizeMax && this.state.dispenser.enabled!=true)?15:0), marginTop:((Dimensions.get('window').width>style.mobileSizeMax && this.state.dispenser.enabled!=true)?((this.state.multiStop==true)?110:160):0), position:((Dimensions.get('window').width>style.mobileSizeMax)?"absolute":"absolute"),width: ((Dimensions.get('window').width>style.mobileSizeMax && this.state.dispenser.enabled!=true)?style.minimizeWidth:Dimensions.get('window').width), backgroundColor: (backgroundStyle==true)?style.color1:style.backgroundColor, height:(this.state.dispenser.enabled==true)?Dimensions.get('window').height:undefined ,bottom: ((Dimensions.get('window').width>style.mobileSizeMax)?undefined:  (this.state.ads.length>0)?(65+this.state.adsMarginBottom):0 ),shadowOpacity: 0.3,shadowRadius: 2,shadowOffset: {height: 2,width: 0},elevation: 1}}>
            <ChoiceCar mainInfo={this.state} selectDate={(value) => { this.selectDate()   }} changeState={(value) => { this.setState(value)   }} 
            
            viewCalculDetail={(listType,value) => {
              if(listType=="vtc") this.props.navigation.navigate('CalculDetail',{noVAT:this.state.noVAT, adminMode:this.state.driver, viewCalcPrice:this.state.viewCalcPrice, money:this.state.money, precision:(this.state.pricingPrecise===true)?100:1, carList:[this.state.priceEstimation[value]] }); 
              else this.props.navigation.navigate('CalculDetail',{noVAT:this.state.noVAT, adminMode:this.state.driver, viewCalcPrice:this.state.viewCalcPrice, money:this.state.money, precision:(this.state.pricingPrecise===true)?100:1, carList:[this.state.priceEstimationTaxi[value]] }) 
            }}
            order={(value) => { 

              if(getAuth(firebase).currentUser==undefined){
                    if(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax ){
                      this.setState({viewCreateAccount:"orderRace", controlePanelOpen:true});
                      if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false })
                    }
                    else this.props.navigation.navigate('CreateAccount',{goToBook:() => { console.log("je suis dans goToBook");  this.getPersonnalInformations({goToBook:true});   }    }); 
              }
              else {
                  if(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax ){this.setState({viewBook:true, controlePanelOpen:true});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false })}
                  else this.props.navigation.navigate('Book', {purposeReturn:this.purposeReturn, data: this.state,start3DSecure:this.start3DSecure,saveBook:this.saveBook,updateAfterBook:this.updateAfterBook }); 
              }

             }}

            />

        </View>}










        {(this.state.immediateMode!="" && this.state.driver!=true && this.state.partner!=true) && <View style={{position: 'absolute',marginLeft:((Dimensions.get('window').width>style.mobileSizeMax)?15:0), marginTop:((Dimensions.get('window').width>style.mobileSizeMax)?10:0),width: ((Dimensions.get('window').width>style.mobileSizeMax)?style.minimizeWidth:Dimensions.get('window').width),height: (Dimensions.get('window').width>style.mobileSizeMax)?200:230 , backgroundColor: style.backgroundColor,bottom: (Dimensions.get('window').width>style.mobileSizeMax)?null:((this.state.ads.length>0)?(65+this.state.adsMarginBottom):0),alignItems: 'center',shadowOpacity: 0.3,shadowRadius: 2,shadowOffset: {height: 0,width: 0},elevation: 1}}>
          

          {true && <Text style={{color: style.textInputColor,fontSize: 18,textAlign: 'center',marginTop:10,}}>{(this.state.immediateMode=="findDriver")?strings.findDriver.toUpperCase():( (this.state.immediateMode=="driverNavigateToCustomer")?strings.yourDriverApproch.toUpperCase():(  (this.state.immediateMode=="driverArrivate")?strings.driverIsPresent.toUpperCase():strings.raceInProgress.toUpperCase()   )      )  }</Text>}
          
          {(this.state.immediateMode=="findDriver") && <ActivityIndicator style={{marginTop:35,marginBottom:35}} size="large" color={style.color1} />}
          
          {(this.state.immediateMode!="findDriver") && <View style={{width:"100%", height:100,marginTop:5,flexDirection: 'row',alignItems:"center"}}>
            <View style={{width: 85, height: 85,marginLeft:30,marginRight:10 }}>
              <Image source={require('../assets/userBlank.png')} style={{ width: 86, height: 86,position:"absolute" }}/>
              <Image source={{uri: this.state.immediateInfo.picture}} style={{borderRadius:((Platform.OS=="web")?"50%":43), width: 86, height: 86, position:"absolute" }}/>
            
            </View>

            <View>
              <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize*1.3}}>{this.state.immediateInfo.text}</Text>

              {(this.state.immediateInfo.partnerNote!=undefined) && <View style={{flexDirection:'row',marginTop:2, alignItems:"center"}}> 

                      <Image source={(this.state.immediateInfo.partnerNote.note>0)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>
                      <Image source={(this.state.immediateInfo.partnerNote.note>1)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>
                      <Image source={(this.state.immediateInfo.partnerNote.note>2)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>
                      <Image source={(this.state.immediateInfo.partnerNote.note>3)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>
                      <Image source={(this.state.immediateInfo.partnerNote.note>4)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>

                      <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.7,textAlign: "center",marginLeft:5}}>{"("+this.state.immediateInfo.partnerNote.note+"/5 - "+this.state.immediateInfo.partnerNote.reviews+" "+strings.reviews.toLowerCase()+")"}</Text>


                </View>}



              {this.state.immediateInfo.car!=undefined && <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize*1.1}}>{this.state.immediateInfo.car}</Text>}
              {this.state.immediateInfo.immatriculation!=undefined && <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize*1.1}}>{this.state.immediateInfo.immatriculation}</Text>}
              {(this.state.immediateMode=="driverNavigateToCustomer" && this.state.immediateInfo.arrivalDate!=undefined) && <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize*1.1}}>{strings.arrivalAt+" : "+((this.state.immediateInfo.arrivalDate.getHours()<10)?"0":"")+ this.state.immediateInfo.arrivalDate.getHours()+":"+((this.state.immediateInfo.arrivalDate.getMinutes()<10)?"0":"")+ this.state.immediateInfo.arrivalDate.getMinutes()      }</Text>}
              {(this.state.immediateMode=="driverArrivate" && this.state.immediateInfo.arrivateDate!=undefined) && <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize*1.1}}>{strings.yourDriverAreArrivateAt+" : "+((new Date(this.state.immediateInfo.arrivateDate).getHours()<10)?"0":"")+ new Date(this.state.immediateInfo.arrivateDate).getHours()+":"+((new Date(this.state.immediateInfo.arrivateDate).getMinutes()<10)?"0":"")+ new Date(this.state.immediateInfo.arrivateDate).getMinutes()      }</Text>}



            </View>



          </View>}

          <View style={{width: "100%",alignItems:"center",justifyContent:"center",marginTop:10,}}>
            {(false && this.state.immediateMode!="raceInProgress") && <MavButton onlyButton={true} small={true} strokeMode={true} text={strings.cancel} style={{}} onPress={()=>{ this.props.navigation.navigate('Book', { data: this.state,purposeReturn:this.purposeReturn,saveBook:this.saveBook,updateAfterBook:this.updateAfterBook }); }}/>}
            
            {this.state.immediateMode!="findDriver" && <MavMiniButton badgeNotification={(this.state.chatMainProv!=undefined && this.state.chatMainProv[this.state.immediateInfo.uuid]!=undefined)?"1":undefined} icon={(style.mode=="dark")?require('../assets/driver_message_dark.png'):require('../assets/driver_message_light.png')} text={strings.contact} onlyButton={true}  onPress={()=>{
                        this.setState({chatMainProv:undefined})
                        this.startChatClient()
                   }} />}




            </View>

        </View>}


        {(this.state.immediateMode!="" && (this.state.driver==true || this.state.partner==true)) && <View style={{position: 'absolute',width: Dimensions.get('window').width, bottom: (this.state.ads.length>0)?(65+this.state.adsMarginBottom):0,alignItems: 'center',shadowOpacity: 0.3,shadowRadius: 2,shadowOffset: {height: 0,width: 0},elevation: 1, }}>
          
          <View style={{flex:1, marginBottom:10, flexDirection:"row"}}>
          <KeepAwake />

          <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {
                var adre=(this.state.immediateMode=="raceInProgress" && this.state.immediateInfo.stopListActu!=undefined && this.state.immediateInfo.stopList!=undefined)?(this.state.immediateInfo.stopList[this.state.immediateInfo.stopListActu]):(        (this.state.immediateMode=="raceInProgress")?this.state.immediateInfo.racePlaceEndName:this.state.immediateInfo.racePlaceStartName);
                Linking.openURL("https://www.google.com/maps/dir/?api=1&destination="+adre)
            }}> 

                <View style={{ width:Dimensions.get('window').width*0.4, height:40, borderRadius:12, flexDirection:"row", alignItems:"center", justifyContent:"center",backgroundColor:style.backgroundColor  }}>
                     <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize}}>{strings.navigateWith}</Text>
                     <Image source={require('../assets/googleMaps.png')} style={{ marginLeft:5, width: 30, height: 30}}/>  
                </View>

          </TouchableHighlight>


          <TouchableHighlight underlayColor={'#FFFFFF00'} style={{marginLeft:Dimensions.get('window').width*0.066}} onPress={() => {
                var adre=(this.state.immediateMode=="raceInProgress" && this.state.immediateInfo.stopListActu!=undefined && this.state.immediateInfo.stopList!=undefined)?(this.state.immediateInfo.stopList[this.state.immediateInfo.stopListActu]):(        (this.state.immediateMode=="raceInProgress")?this.state.immediateInfo.racePlaceEndName:this.state.immediateInfo.racePlaceStartName);
                Linking.openURL('waze://?q='+(adre)+'&navigate=yes')
            }}> 

                <View style={{ width:Dimensions.get('window').width*0.4, height:40, borderRadius:12, flexDirection:"row", alignItems:"center", justifyContent:"center",backgroundColor:style.backgroundColor  }}>
                     <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize}}>{strings.navigateWith}</Text>
                     <Image source={require('../assets/waze.png')} style={{ marginLeft:5, width: 30, height: 30}}/>  
                </View>

          </TouchableHighlight>

          </View>

          <View style={{backgroundColor: style.backgroundColor,}}>


              <View style={{marginLeft:10, marginRight:15,flexDirection:'row',}}>
                  <View style={{ width:"50%", }}>
                        <Text style={{color: style.textInputColor,fontSize: 18,fontWeight: 'bold',marginTop:10,}}>{(this.state.immediateMode!="driverArrivate")?((this.state.immediateMode=="raceInProgress" && this.state.immediateInfo.racePlaceEndName==undefined)?strings.provision:strings.navigateTo ):strings.waitingCustomer}</Text>
                        
                        {(this.state.immediateMode=="driverArrivate" && this.state.immediateInfo.arrivateDate!=undefined) && <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize*1.1}}>{strings.yourAreArrivateAt+" : "+((new Date(this.state.immediateInfo.arrivateDate).getHours()<10)?"0":"")+ new Date(this.state.immediateInfo.arrivateDate).getHours()+":"+((new Date(this.state.immediateInfo.arrivateDate).getMinutes()<10)?"0":"")+ new Date(this.state.immediateInfo.arrivateDate).getMinutes()      }</Text>}

                        {( (this.state.immediateMode=="driverNavigateToCustomer" || this.state.immediateMode=="driverArrivate") && (this.state.immediateInfo.numFlight!=undefined)  ) && 
                          <TouchableHighlight underlayColor={'#FFFFFFF0'}  onPress={() => { if(this.state.immediateInfo.numFlight!=undefined) Linking.openURL("https://fr.flightaware.com/search/"+this.state.immediateInfo.numFlight)  }}>
                              <View style={{flexDirection:"row"}}> 
                                  <Image source={(this.state.immediateInfo.numTrain!=undefined)?((style.mode=="dark")?require("../assets/favorite/train_white.png"):require("../assets/favorite/train_black.png")):((style.mode=="dark")?require("../assets/favorite/flight_white.png"):require("../assets/favorite/flight_black.png"))} style={{width:12,height:12,marginRight:2,}}></Image>

                                  <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize*0.8}} >{ ((this.state.immediateInfo.numTrain!=undefined)?strings.numeroTrain:strings.numeroFlight)+" : "}<Text style={{textDecorationLine: (this.state.immediateInfo.numTrain!=undefined)?undefined:'underline'}}>{ ((this.state.immediateInfo.numTrain!=undefined)?this.state.immediateInfo.numTrain:this.state.immediateInfo.numFlight) }</Text></Text> 
                              </View> 
                        </TouchableHighlight>}


                        {(this.state.immediateInfo.splitAdress!=undefined) && this.state.immediateInfo.splitAdress.map((rowData, key) => ( <View> 
                          {(rowData!="France") && <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize*((key==0)?1.1:0.85)}}>{this.state.immediateInfo.splitAdress[key]}</Text>}
                        </View>))}

                        


                  </View>


                   <View style={{ width:"50%", alignItems:"flex-end" }}>
                        <Text style={{color: style.textInputColor,fontSize: 18,fontWeight: 'bold',marginTop:10,}}>{(this.state.infoRace!=undefined && this.state.infoRace.passagersList!=undefined && this.state.infoRace.passagersList.length>0)?strings.travelers:strings.traveler}</Text>
                        <Text style={{color: style.textInputColor,fontSize:style.textInputFontSize*1.1}}>{this.state.immediateInfo.clientName}</Text>

                        {(this.state.immediateMode!="raceInProgress" && this.state.immediateMode!="raceReturnInProgress" && this.state.immediateInfo.clientNote!=undefined) && <View style={{flexDirection:'row',marginTop:2, alignItems:"center"}}> 
                                <Image source={(this.state.immediateInfo.clientNote.note>0)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>
                                <Image source={(this.state.immediateInfo.clientNote.note>1)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>
                                <Image source={(this.state.immediateInfo.clientNote.note>2)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>
                                <Image source={(this.state.immediateInfo.clientNote.note>3)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>
                                <Image source={(this.state.immediateInfo.clientNote.note>4)?((style.mode=="dark")?require("../assets/star1_dark.png"):require("../assets/star1_light.png")): ((style.mode=="dark")?require("../assets/star2_dark.png"):require("../assets/star2_light.png") )} style={{width:12,height:12,marginRight:2,}}></Image>

                                <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.7,textAlign: "center",marginLeft:5}}>{"("+this.state.immediateInfo.clientNote.reviews+" "+strings.reviews.toLowerCase()+")"}</Text>
                          </View>}

                          {(this.state.infoRace!=undefined && this.state.infoRace.passagersList!=undefined && this.state.infoRace.passagersList.length>0) && <View >{

                              this.state.infoRace.passagersList.map((rowData, key) => ( <View> 
                                  {
                                    <View style={{flexDirection:"row", justifyContent:"flex-end", alignItems:"center"}}>
                                      <Text style={{textAlign:"right", color: style.textInputColor,fontSize:style.textInputFontSize*0.85, textDecorationLine: (rowData.step=="leave" || (rowData.end!=undefined && (this.state.immediateInfo.stopListActu==undefined || this.state.immediateInfo.stopList==undefined)  && (this.state.immediateMode=="raceInProgress" || this.state.immediateMode=="raceReturnInProgress" )))?'line-through':undefined, color:( (this.state.immediateInfo.stopListActu==undefined || this.state.immediateInfo.stopList==undefined)  && (this.state.immediateMode=="raceInProgress" || this.state.immediateMode=="raceReturnInProgress" ))?style.textInputColor: ((rowData.step=="dropOff")?style.colorNotification:((rowData.step=="priceCharge")?style.colorWaiting:((rowData.start!=undefined && rowData.step==undefined)?style.placeholderTextInputColor:style.textInputColor)))   }} >{((rowData.name=="" && rowData.lastName=="")?(strings.customer+" "+(key+1) ) : (rowData.name+" "+rowData.lastName))}</Text>
                                      {(rowData.step=="priceCharge") && <Image source={require("../assets/waiting.png")} style={{width:10,height:10,marginLeft:2,}}></Image>}
                                      {(rowData.step=="dropOff") && <Image source={require("../assets/right-arrow-notification.png")} style={{width:10,height:10,marginLeft:2,}}></Image>}
                                    
                                    </View>
                                  } 
                                  </View> ))

                            }</View>}


                           


                  </View>

              </View>

              
              {this.state.immediateInfo.numTrain!=undefined && <View style={{marginLeft:10, marginRight:15,marginTop:10, backgroundColor:style.backgroundColorContrast,shadowRadius: 2,shadowOffset: {height: 1,width: 0},elevation: 1, shadowOpacity: 1, shadowColor:"#00000070", }}> 
                  <SncfInfo raceDate={this.state.immediateInfo.raceDate} style={{marginTop:5, marginBottom:5, marginLeft:5, marginRight:5}} racePlaceStartName={this.state.immediateInfo.racePlaceStartName} racePlaceEndName={this.state.immediateInfo.racePlaceEndName} textInputFlex={2} numero={this.state.immediateInfo.numTrain}  editable={false}  />
              </View>}

              <View style={{marginTop:20, marginBottom:50, marginLeft:10, marginRight:10, flexDirection:"row", justifyContent: 'space-between', alignItems:"center", }}>
                  
                  {info.countryCode!="ma" && <MavMiniButton icon={(style.mode=="dark")?require('../assets/driver_bon_dark.png'):require('../assets/driver_bon_light.png')} text={strings.bdc} onlyButton={true}  onPress={()=>{  var infoOrder=JSON.parse(JSON.stringify(this.state.infoRace)); if(!(this.state.infoRace.clientPhone!=undefined && this.state.infoRace.clientPhone!="" && (this.state.driver==true || (this.state.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.infoRace.customerPro==true || this.state.infoRace.providerID!=undefined)) ))))) infoOrder.clientPhone=info.companyPhone; infoOrder.description+=" "+infoOrder.carName; this.props.navigation.navigate("Order",infoOrder)   }} />}


                  <MavMiniButton badgeNotification={(this.state.chatMainProv!=undefined && this.state.chatMainProv[this.state.immediateInfo.uuid]!=undefined)?"1":undefined} icon={(style.mode=="dark")?require('../assets/driver_message_dark.png'):require('../assets/driver_message_light.png')} text={strings.contactClient} onlyButton={true}  onPress={()=>{
                        this.setState({chatMainProv:undefined})
                        if(this.state.immediateInfo.noChat==true) this.contactMessage(this.state.immediateInfo.clientPhone)
                        else if(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax ){
                            this.setState({viewChat:true, controlePanelOpen:true});
                            if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false })
                        }
                        else this.props.navigation.navigate("Chat",{partner:true, sender:this.state.immediateInfo.clientName,raceID:this.state.immediateInfo.uuid,senderPhone:this.state.immediateInfo.clientPhone, contactMessage:this.contactMessage,senderID:this.state.immediateInfo.clientID })
                      
                   }} />

                  {(this.state.immediateMode=="driverNavigateToCustomer") && <MavMiniButton maximize={true} icon={(style.mode=="dark")?require('../assets/nextArrow_black.png'):require('../assets/nextArrow_white.png')} text={strings.signalArrival} onlyButton={true}  onPress={()=>{
                      const fireInfo={} 
                      fireInfo['race/' + this.state.immediateInfo.uuid+"/immediateMode"]="driverArrivate";
                      fireInfo['race/' + this.state.immediateInfo.uuid+"/arrivateDate"]=Date.parse(new Date())
                      update(ref(getDatabase(firebase)), fireInfo)
                  }} />}
              

                  {(this.state.immediateMode=="driverArrivate") && <MavMiniButton maximize={true} icon={(style.mode=="dark")?require('../assets/nextArrow_black.png'):require('../assets/nextArrow_white.png')} text={strings.customerOnBoard} onlyButton={true}  onPress={()=>{
                        const fireInfo={} 
                        fireInfo['race/' + this.state.immediateInfo.uuid+"/immediateMode"]="raceInProgress";
                        fireInfo['race/' + this.state.immediateInfo.uuid+"/realRaceDate"]=Date.parse(new Date());
                        if(this.state.immediateInfo.stopList!=undefined) fireInfo['race/' + this.state.immediateInfo.uuid+"/sla"]=0; 
 
                        this.changeStopListActu(0)
                        update(ref(getDatabase(firebase)), fireInfo)
                        
                   }} />}
              

                   {(this.state.immediateMode=="raceInProgress" && this.state.immediateInfo.stopListActu!=undefined && this.state.immediateInfo.stopList!=undefined) && <MavMiniButton maximize={true} icon={(style.mode=="dark")?require('../assets/nextArrow_black.png'):require('../assets/nextArrow_white.png')} text={strings.next} onlyButton={true}  onPress={()=>{
                          var sla=this.state.immediateInfo.stopListActu+1; 
                          if(this.state.immediateInfo.stopList.length===sla) {
                          const fireInfo={} 
                          fireInfo['race/' + this.state.immediateInfo.uuid+"/sla"]=null;
                          update(ref(getDatabase(firebase)), fireInfo)
                          imm=this.state.immediateInfo; imm.stopListActu=undefined; this.setState({immediateInfo:imm},() =>{ this.viewDriverNavigateToDestination(); })  }
                          else {
                              const fireInfo={} 
                              fireInfo['race/' + this.state.immediateInfo.uuid+"/sla"]=sla
                              update(ref(getDatabase(firebase)), fireInfo)
                            }
                          this.changeStopListActu(sla)
                   }} />}

                  {(this.state.immediateMode=="raceInProgress" && this.state.immediateInfo.goReturnTaxi==true && (this.state.immediateInfo.stopListActu==undefined || this.state.immediateInfo.stopList==undefined) && this.state.immediateInfo.stopList!=undefined) && <MavMiniButton maximize={true} icon={(style.mode=="dark")?require('../assets/nextArrow_black.png'):require('../assets/nextArrow_white.png')} text={strings.raceReturn} onlyButton={true}  onPress={()=>{
                          const fireInfo={} 
                          fireInfo['race/' + this.state.immediateInfo.uuid+"/immediateMode"]="raceReturnInProgress"
                          fireInfo['race/' + this.state.immediateInfo.uuid+"/realRaceDateReturn"]=Date.parse(new Date())
                          update(ref(getDatabase(firebase)), fireInfo)
                   }} />}


                   {( (this.state.immediateMode=="raceInProgress" && this.state.immediateInfo.goReturnTaxi!=true && (this.state.immediateInfo.stopListActu==undefined || this.state.immediateInfo.stopList==undefined) ) || this.state.immediateMode=="raceReturnInProgress") && <MavMiniButton maximize={true} icon={(style.mode=="dark")?require('../assets/nextArrow_black.png'):require('../assets/nextArrow_white.png')} text={strings.signalEndRace} onlyButton={true}  onPress={()=>{ this.navigateToGenerateBill() }} />}













                   <MavMiniButton icon={(style.mode=="dark")?require('../assets/user_black.png'):require('../assets/user_white.png')} text={strings.signPost} onlyButton={true}  onPress={()=>{ 
                      this.alert.onAlert({title:strings.clickToClose,buttons:[
                      {text: "OK",onPress: () => {this.setState({viewSignpost:true}) }},
                      {text: strings.cancel, style:"cancel",onPress: () => {}}],});
                   }} />

                   <MavMiniButton icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.stopTracking} onlyButton={true}  onPress={()=>{ this.stopTracking() }} />



              </View>


          </View>


        </View>}


        
        {this.state.markerDriverDetail!="" && <TouchableHighlight underlayColor={'#FFFFFFF0'}  onPress={() => {this.setState({markerDriverDetail:""})}} style={{elevation: 3,position:"absolute",backgroundColor:style.backgroundColorOpacity,width:Dimensions.get('window').width,height:Dimensions.get('window').height, alignItems:"center",justifyContent:"center"}}>
        
              <View style={{width:250,height:80, backgroundColor:style.backgroundColor, justifyContent:"center"}}>
                    <Text style={{marginTop:5,fontSize: style.textInputFontSize*1.2,color:style.textInputColor,textAlign:"center", width:250,fontWeight: 'bold',}}>{this.state.markerDriverDetail.name+" "+this.state.markerDriverDetail.lastName.toUpperCase()}</Text>
                    <Text style={{fontSize: style.textInputFontSize*0.6,color:style.textInputColor,textAlign:"center", width:250}}>{strings.lastMAJ+" : "+this.state.markerDriverDetail.date}</Text>
                    {(this.state.markerDriverDetail.phone!=undefined) && <View style={{width:250, alignItems:"center",flexDirection: 'row',justifyContent:"center" }}>
                      <MavButton text={strings.contactClient} onlyButton={true} small={true} style={{marginTop:5,marginRight:10}} onPress={()=>{Linking.openURL("tel:"+this.state.markerDriverDetail.phone) }}/>
                      <MavButton text={strings.learnMore} onlyButton={true} small={true} style={{marginTop:5}} onPress={()=>{ this.props.navigation.navigate("Account",{adminView:true,disabledChange:true,findClientById:this.state.markerDriverDetail.uuid }) }}/>
                   
                    </View>}
              </View>
        </TouchableHighlight>}

        

         <View style={{elevation: 3,position:"absolute",backgroundColor:"rgba(0,0,0,0.7)",width:Dimensions.get('window').width,height:(this.state.controlePanelOpen==true)?Dimensions.get('window').height:0}}/>
        

        {(this.state.viewTrajet!=false || this.state.viewChat!=false || this.state.viewCreateAccount!=false || this.state.viewBook!=false) && <View style={{zIndex: 10, marginTop:(!(Dimensions.get('window').width>style.mobileSizeMax) || this.state.dispenser.enabled==true)?0:15, marginLeft:(!(Dimensions.get('window').width>style.mobileSizeMax) || this.state.dispenser.enabled==true)?0:15, width:((Dimensions.get('window').width>style.mobileSizeMax && this.state.dispenser.enabled!=true)?style.minimizeWidth:Dimensions.get('window').width), height:Dimensions.get('window').height+( (!(Dimensions.get('window').width>style.mobileSizeMax) || this.state.dispenser.enabled==true)?0:-30), position:"absolute", }}>
          
           {(this.state.viewTrajet=="from") && <Trajet params={{  goBack:() => {this.setState({viewTrajet:false,controlePanelOpen:false}); if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true })  }, dispenser:this.state.dispenser.enabled,  favorite:Object.assign(this.state.previousSearchDisplay,this.state.favorite, this.state.favoriteGlobal,),longitude: this.state.longitude,latitude: this.state.latitude,addPreviousSearch: this.addPreviousSearch, removePreviousSearch:this.removePreviousSearch,onChangeFrom: this.onChangeFrom,mapTo: this.state.mapTo,mapFrom: this.state.mapFrom,}}/>}
           {(this.state.viewTrajet=="stop") && <Trajet params={{  goBack:() => {this.setState({viewTrajet:false,controlePanelOpen:false}); if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true })  }, dispenser:this.state.dispenser.enabled,  favorite:Object.assign(this.state.previousSearchDisplay,this.state.favorite, this.state.favoriteGlobal,),longitude: this.state.longitude,latitude: this.state.latitude,addPreviousSearch: this.addPreviousSearch, removePreviousSearch:this.removePreviousSearch,onChangeIntermediateStop: this.onChangeIntermediateStop, intermediateStop:this.state.intermediateStopId,mapTo: this.state.mapTo,mapFrom: this.state.mapFrom,}}/>}
           {(this.state.viewTrajet=="to") && <Trajet params={{  goBack:() => {this.setState({viewTrajet:false,controlePanelOpen:false}); if(this.state.dispenser.enabled==true && this.state.estimatePriceGo!="") this.setState({estimatePriceGo:"", estimatePriceGoTaxi:""});   if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true }) }, dispenser:this.state.dispenser.enabled,  favorite:Object.assign(this.state.previousSearchDisplay,this.state.favorite, this.state.favoriteGlobal,),longitude: this.state.longitude,latitude: this.state.latitude,addPreviousSearch: this.addPreviousSearch, removePreviousSearch:this.removePreviousSearch,mapTo: this.state.mapTo,mapFrom: this.state.mapFrom, onChangeTo: this.onChangeTo,durationSelected:this.state.durationSelected, duration:this.state.provisionDuration,durationMin:this.state.durationMin,changeDuration: this.changeDuration,choiceDuration:(info.disableProvision==true)?false:true}}/>}
           {(this.state.viewTrajet=="date") && <MavSelectDate params={{   goBack:(info) => {console.log("info = "+info); this.setState({viewTrajet:false,controlePanelOpen:false});  if(this.state.dispenser.enabled==true && info!="validate") this.trajetToDestination()  ;if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true }) }, dispenser:this.state.dispenser.enabled, enableTimezone:this.state.enableTimezone, delayRaceMin:this.state.delayRaceMin, driver:(this.state.driver==true || this.state.manager==true)?true:false, partner:this.state.partner, contactUs:this.contactUs, changeDate: this.changeDate, navigate:true,immediate:this.state.immediate, immediateMode:this.state.immediateModeOrder,date:this.state.integerDate,dateMin:this.state.dateMin }}/>}
        
           {(this.state.viewCreateAccount!=false) && <CreateAccount params={{ partnerID:this.state.forcePartner, lockOtherPartner:this.state.lockOtherPartner, goToBook:() => { var oldviewCreateAccount=JSON.parse(JSON.stringify(this.state.viewCreateAccount)); this.setState({viewCreateAccount:false,controlePanelOpen:false},()=>{  if(oldviewCreateAccount=="orderRace") this.getPersonnalInformations({goToBook:true}); else this.getPersonnalInformations() });if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:true });  },  goBack:(next) => {
                this.setState({viewCreateAccount:false,controlePanelOpen:false});
                if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:true });  
                if(this.state.linkDownloadApp!=undefined){
                          this.alert.onAlert({title:strings.thanksSubscribe, subTitle:strings.orderNowDownloadApp,buttons:[
                            {text: strings.downloadApp,onPress: () => { 
                              Linking.openURL(this.state.linkDownloadApp);
                             }},
                            {text: strings.close, style:"cancel",onPress: () => { goBck.goBack(); }}
                          ]}) 
                        }

              }, }} />}

            {(this.state.viewBook!=false) && <Book params ={{ navigate:(value,params) => { if(Platform.OS=="web") this._nativateView.open(value, params,"left"); else this.props.navigation.navigate(value,params); }, popToTop:() => {this.setState({viewBook:false,controlePanelOpen:false});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true });}, goBack:() => {this.setState({viewBook:false,controlePanelOpen:false});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:true });}, data: this.state,start3DSecure:this.start3DSecure,purposeReturn:this.purposeReturn, saveBook:this.saveBook, updateAfterBook:this.updateAfterBook }}/>}
           
            {(this.state.viewChat!=false) && <Chat params ={{ goBack:() => {this.setState({viewChat:false,forceChat:undefined,controlePanelOpen:false});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:(this.state.dispenser.enabled==true)?false:true });}, outRace:(this.state.forceChat!=undefined)?true:undefined, contactUs:(this.state.driver==true || this.state.partner==true || this.state.forceChat!=undefined)?undefined:this.contactUs, sender:(this.state.forceChat!=undefined)?this.state.forceChat.sender:((this.state.driver==true || this.state.partner==true)?this.state.immediateInfo.clientName:this.state.immediateInfo.text),raceID:(this.state.forceChat!=undefined)?this.state.forceChat.raceID:this.state.immediateInfo.uuid,partner:(this.state.partner==true || this.state.driver==true)?true:false, senderPhone:(this.state.forceChat!=undefined)?undefined:((this.state.driver==true || this.state.partner==true)?this.state.immediateInfo.clientPhone:this.state.immediateInfo.driverPhone),contactMessage:(this.state.forceChat!=undefined)?undefined:this.contactMessage,senderID:(this.state.forceChat!=undefined)?this.state.forceChat.senderID:((this.state.driver==true || this.state.partner==true)?this.state.immediateInfo.clientID:this.state.immediateInfo.driverID) }}/>}
           

             

        </View>}






        

        <AfterRacePay ref={afterRacePay => {this.afterRacePay = afterRacePay;}}/>


        {(this.state.viewSpecificPOI!=false && this.state.viewMultiStop!=true && !( (this.state.viewBook==true || this.state.viewTrajet!=false) && this.state.dispenser.enabled==true) && this.state.immediateMode=="" && this.state.controlePanelOpen!=true) && <View style={{marginLeft:((Dimensions.get('window').width>style.mobileSizeMax)?15:0), position:"absolute", marginTop:(Dimensions.get('window').width>style.mobileSizeMax)?10:0, width: ((Dimensions.get('window').width>style.mobileSizeMax)?style.minimizeWidth:Dimensions.get('window').width), backgroundColor:style.backgroundColor, bottom: ((Dimensions.get('window').width>style.mobileSizeMax)?undefined: 0 ),shadowOpacity: 0.3,shadowRadius: 2,shadowOffset: {height: 2,width: 0},elevation: 1}}>
              <POIMapDetail disableFromTo={((this.state.partner==false || (this.state.privilegeDriver!="basic" && this.state.privilegeDriver!="standard" ) || this.state.basicDriverAddRace==true ) && this.state.immediateMode=="")?false:true} data={this.state.viewSpecificPOI} close={(value) => { if(value=="from") this.onChangeFrom(this.state.viewSpecificPOI); else if(value=="to") this.onChangeTo(this.state.viewSpecificPOI) ;     this.setState({viewSpecificPOI:false}) } } />

        
        </View>}


       {this.state.viewMultiStop==true &&  <View style={{ width:"100%", height:"100%",position:"absolute", backgroundColor:"rgba(0,0,0,0.7)"}}>



        <View style={{width:(Dimensions.get('window').width>style.mobileSizeMax)?style.minimizeWidth+30:Dimensions.get('window').width}}>

       <TouchableHighlight underlayColor={"#FFFFFF00"}
                    onPress={() => {
                      if (this.state.lock==false) {
                        this.setState({lock:true})
                        timer.setTimeout(generateUUID(), () => {this.setState({lock:false})}, 2000);
                        if(Platform.OS=="web" || Dimensions.get('window').width>style.mobileSizeMax ) {this.setState({viewTrajet:"from",controlePanelOpen:true});if(Platform.OS!="web") this.props.navigation.setOptions({headerShown:false });}
                        else this.props.navigation.navigate('Trajet', {favorite:Object.assign(this.state.previousSearchDisplay,this.state.favorite, this.state.favoriteGlobal,),longitude: this.state.longitude,latitude: this.state.latitude,addPreviousSearch: this.addPreviousSearch, removePreviousSearch:this.removePreviousSearch,onChangeFrom: this.onChangeFrom,mapTo: this.state.mapTo,mapFrom: this.state.mapFrom,});
                      }
                    }}><MavTextInput backgroundColor={(backgroundStyle==true)?style.color1:undefined} shadow={!backgroundStyle} style={{marginTop:15}} enableNext={!backgroundStyle} marginSize={15} textExplicationBold={!backgroundStyle} disableLine={!backgroundStyle} textInputColor={(backgroundStyle==true)?"#FFFFFF":undefined} textInputLineColor={"#FFFFFF"} textExplication={(backgroundStyle===true)?(this.state.mapFrom.userDescription == ''? strings.chooseStart: this.state.mapFrom.userDescription):strings.selectFromPoint} disabledText={true} iconClassicSmall={true} iconClassic={(backgroundStyle==true)?require('../assets/pinRoundGreen.png'):((style.mode=="dark")?( (this.state.mapFrom.iconDark!=undefined)?this.state.mapFrom.iconDark: require('../assets/favorite/pin_white.png')   ): ( (this.state.mapFrom.iconLight!=undefined)?this.state.mapFrom.iconLight: require('../assets/favorite/pin_black.png')   )   )     } textExplicationMini={(backgroundStyle===true)?undefined:(this.state.mapFrom.userDescription == ''? strings.chooseStart: this.state.mapFrom.userDescription)}  />
              </TouchableHighlight>


              {this.state.mapIntermediate.map((stop,id) => (
                 <TouchableHighlight underlayColor={"#FFFFFF00"} onPress={() => {this.trajetMultiStop(id);}}>
                    <MavTextInput  shadow={true} style={{marginTop:5}} enableRemove={true} onRemove={() => { this.trajetMultiStop(id,"remove") }} marginSize={15} textExplicationBold={true} disableLine={true} textInputLineColor={"#FFFFFF"} textExplication={strings.multiStopInfo} disabledText={true} iconClassicSmall={true} iconClassic={ (stop.iconLight!=undefined)?( (style.mode=="dark")?stop.iconDark:stop.iconLight  ) :(  (style.mode=="dark")?require('../assets/favorite/pin_white.png'):require('../assets/favorite/pin_black.png')  ) } textExplicationMini={stop.userDescription } />
              </TouchableHighlight>

              ))}


               


               {(this.state.durationSelected!=true && (this.state.mapTo.userDescription != '' || info.disableProvision==true) && this.state.mapIntermediate.length<6) && <TouchableHighlight underlayColor={"#FFFFFF00"} onPress={() => { this.trajetMultiStop(-1);}}>
                    <MavTextInput shadow={true} style={{marginTop:5}} marginSize={15} textExplicationBold={true} disableLine={true}  textInputLineColor={"#FFFFFF"} textExplication={strings.addStop} disabledText={true} iconClassicSmall={true} iconClassic={(style.mode=="dark")?require('../assets/plus_white.png'):require('../assets/plus_black.png')}  />
              </TouchableHighlight>}


              <TouchableHighlight underlayColor={"#FFFFFF00"} onPress={() => {this.trajetToDestination();}}>
                    <MavTextInput backgroundColor={(backgroundStyle==true)?style.color1:undefined} shadow={!backgroundStyle} style={{marginTop:5}} enableNext={!backgroundStyle} marginSize={15} textExplicationBold={!backgroundStyle} disableLine={!backgroundStyle} textInputColor={(backgroundStyle==true)?"#FFFFFF":undefined} textInputLineColor={"#FFFFFF"} textExplication={(backgroundStyle===true)?((this.state.durationSelected==true)? (  (this.state.provisionDuration == '')? ((info.disableProvision==true)?strings.chooseDestination:strings.chooseDestinationOrDuration)   : ( strings.duration+" : "+(((Math.floor(this.state.provisionDuration/3600))<10)?"0":"")+Math.floor(this.state.provisionDuration/3600)+":"+((Math.floor((this.state.provisionDuration%3600)/60)<10)?"0":"")+Math.floor((this.state.provisionDuration%3600)/60) )     )  : ( this.state.mapTo.userDescription == ''? ((info.disableProvision==true)?strings.chooseDestination:strings.chooseDestinationOrDuration): this.state.mapTo.userDescription )):((info.disableProvision==true)?strings.destination:strings.destinationOrDuration)} disabledText={true} iconClassicSmall={true} iconClassic={(backgroundStyle==true)?require('../assets/pinRoundRed.png'):( (this.state.durationSelected==true)?( (style.mode=="dark")?require('../assets/favorite/chronometer_white.png'):require('../assets/favorite/chronometer_black.png')  ): ((this.state.mapTo.iconLight!=undefined)?( (style.mode=="dark")?this.state.mapTo.iconDark:this.state.mapTo.iconLight  ) :(  (style.mode=="dark")?require('../assets/favorite/pin_white.png'):require('../assets/favorite/pin_black.png')  ) ) )} textExplicationMini={(backgroundStyle===true)?undefined:((this.state.durationSelected==true)? (  (this.state.provisionDuration == '')? ((info.disableProvision==true)?strings.chooseDestination:strings.chooseDestinationOrDuration)   : ( strings.duration+" : "+(((Math.floor(this.state.provisionDuration/3600))<10)?"0":"")+Math.floor(this.state.provisionDuration/3600)+":"+((Math.floor((this.state.provisionDuration%3600)/60)<10)?"0":"")+Math.floor((this.state.provisionDuration%3600)/60) )     )  : ( this.state.mapTo.userDescription == ''? ((info.disableProvision==true)?strings.chooseDestination:strings.chooseDestinationOrDuration): this.state.mapTo.userDescription ))} />
              </TouchableHighlight>

              {Platform.OS=="web" && <View style={{width:(Dimensions.get('window').width>style.mobileSizeMax)?style.minimizeWidth+30:Dimensions.get('window').width, marginTop:30, alignItems:"center", justifyContent:"center"}}>
                      <MavButton onlyButton={true}  text={strings.validate} style={{}} onPress={()=>{ this.setState({viewMultiStop:false}) }}/>
              </View>}

          </View>






        </View>}


        {(this.state.adsFullScreen!=undefined && this.state.controlePanelOpen!=true && this.state.dispenser.enabled!=true) && <View style={{ width:"100%", height:"100%",position:"absolute", backgroundColor:"rgba(0,0,0,0.7)"}}>

          <View style={{shadowOpacity: 0.3,shadowRadius: 2,shadowOffset: {height: 2,width: 0},elevation: 1, width:"95%", height:"95%",  marginLeft:"2.5%", marginTop:"2.5%", backgroundColor:style.backgroundColor,position:"absolute", alignItems:"center", justifyContent:"center" }}>
            <TouchableHighlight underlayColor={'#FFFFFFF0'} style={{ width:"100%", height:"100%"}}  onPress={() => {   this.clickOnAdd(this.state.adsFullScreen,true) }}>
                <Image resizeMode='contain' source={{uri:this.state.adsFullScreen.file}} style={{ width:"100%", height:"100%"}}/>
            </TouchableHighlight>
          </View>

          <TouchableHighlight underlayColor={'#FFFFFFF0'}  onPress={() => { this.setState({adsFullScreen:undefined, })  }} style={{shadowOpacity: 0.3,shadowRadius: 2,shadowOffset: {height: 2,width: 0},elevation: 1, width:40, height:40, borderRadius:20, borderWidth:2, borderColor:style.backgroundColor, position:"absolute",backgroundColor:style.color1, alignItems:"center", justifyContent:"center" }}>
            <Image
                  source={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')}
                  style={{resizeMode:"contain",height:20,width:20}}
                />
          </TouchableHighlight>

        </View>}

        <MavNotation ref={notation => {this.notation = notation;}} onNotationFinish={notation => {
          

          if(notation.note!=undefined){
            var send={note:notation.note}
            if(notation.comment!=undefined) send.comment=notation.comment;

            const fireInfo={} 
            if(notation.noteCustomer==false) fireInfo['/reviews/race/'+this.state.reviewRaceID+"/client"]=send
            else fireInfo['/reviews/race/'+this.state.reviewRaceID+"/partner"]=send
            update(ref(getDatabase(firebase)), fireInfo)

          }
          const fireInfo={} 
          fireInfo['/users/'+getAuth(firebase).currentUser.uid+"/reviewRaceID"]=null
          update(ref(getDatabase(firebase)), fireInfo)
          this.setState({reviewRaceID:""})

          




        }}/>

        <StatusBar hidden={(this.state.dispenser.enabled==true)?true:false} />


        {(this.state.errorGeolocalisation==true && this.state.immediateMode!="" && (this.state.partner==true || this.state.driver==true)) && <View style={{position: 'absolute',width:"100%",marginTop:15,height:60,justifyContent: 'center',alignItems:"center" }}>
              <View style={{width:"85%",flexDirection: 'row',borderRadius: 30,backgroundColor:"#FF2434",justifyContent: 'center',alignItems:"center",shadowOpacity: 0.3,shadowRadius: 2,shadowOffset: {height: 0,width: 0},elevation: 1}} >
                    <Text style={{fontSize: style.textInputFontSize*3, color:"#FFFFFF", textAlign:"center", flex:1}}>{"!"}</Text>

                  <Text style={{fontSize: style.textInputFontSize*0.9, color:"#FFFFFF",  flex:9}}>{strings.errorGeolocalisation}</Text>
              </View>
            </View>}


        

        

        {this.state.waiting3DSecure==true && <Wait3DSecure status={this.state.waiting3DSecureStatus} urlRedirect={this.state.waiting3DSecureUrlRedirect} />}

        {(Platform.OS!="web" && this.state.controlePanelOpen==true) && <Animated.View style={{width:Dimensions.get('window').width*0.12,height:Dimensions.get('window').width*0.12, position:"absolute", top:30, left:Dimensions.get('window').width*0.04, borderWidth:2,opacity:this.opacityCloseButton, borderColor:"#FFFFFF", borderRadius: Dimensions.get('window').width*0.075,alignItems:"center", justifyContent:"center", }}>
            <Image source={require("../assets/driver_cancel_light.png")} style={{height:"65%",width:"65%",resizeMode:"cover", }}/>
        </Animated.View>}


      </Drawer>}

      <MavAlert ref={alert => {this.alert = alert;}}/>

      <Modal animationType="slide" transparent={false} visible={this.state.viewSignpost===true} > 
        <View style={{width:"100%", backgroundColor:style.backgroundColor, height:"100%",}}>
          <View style={{width:"100%",height:"100%", alignItems:"center",justifyContent:"center",  }}>
              <TouchableHighlight underlayColor={'#FFFFFFF0'}  onPress={() => { this.setState({viewSignpost:false}) }}>
                  <Image source={require("../assets/login_logo.png")} style={{height:Dimensions.get('window').width*0.18,resizeMode:"contain"}}/>
              </TouchableHighlight>
              <Text numberOfLines={1} ellipsizeMode={"tail"} style={{color: style.textInputColor,fontSize: style.textInputFontSize*7,textAlign: "center",}}>{this.state.immediateInfo.clientUName}</Text>
              {this.state.immediateInfo.clientLastName!=undefined && <Text numberOfLines={1} ellipsizeMode={"tail"} style={{color: style.textInputColor,fontSize: style.textInputFontSize*7,textAlign: "center",marginTop:-20}}>{this.state.immediateInfo.clientLastName.toUpperCase()}</Text>}
              
          </View> 
        </View>     
      </Modal>
      
      </View>
      </NavigateView>
      }</StyleContext.Consumer>
    );
  }
}




export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}


